import type { Hobby } from "../types";

export const SEED_HOBBIES: Hobby[] = [
  {
    "id": "hob_1",
    "label": "Ajedrez",
    "category": "base",
    "gear": [
      "ajedrez",
      "tablero de ajedrez"
    ]
  },
  {
    "id": "hob_2",
    "label": "Guitarra acústica",
    "category": "base",
    "gear": [
      "guitarra"
    ]
  },
  {
    "id": "hob_3",
    "label": "Guitarra eléctrica",
    "category": "base",
    "gear": [
      "guitarra"
    ]
  },
  {
    "id": "hob_4",
    "label": "Ukelele",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_5",
    "label": "Piano",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_6",
    "label": "Batería",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_7",
    "label": "Violín",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_8",
    "label": "Flauta",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_9",
    "label": "Armónica",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_10",
    "label": "Canto",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_11",
    "label": "Dibujo a lápiz",
    "category": "base",
    "gear": [
      "pintura",
      "material de pintura"
    ]
  },
  {
    "id": "hob_12",
    "label": "Acuarela",
    "category": "base",
    "gear": [
      "pintura",
      "material de pintura"
    ]
  },
  {
    "id": "hob_13",
    "label": "Óleo",
    "category": "base",
    "gear": [
      "pintura",
      "material de pintura"
    ]
  },
  {
    "id": "hob_14",
    "label": "Acrílico",
    "category": "base",
    "gear": [
      "pintura"
    ]
  },
  {
    "id": "hob_15",
    "label": "Cómic",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_16",
    "label": "Caligrafía",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_17",
    "label": "Lettering",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_18",
    "label": "Origami",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_19",
    "label": "Cerámica",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_20",
    "label": "Costura",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_21",
    "label": "Punto de cruz",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_22",
    "label": "Ganchillo",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_23",
    "label": "Punto de media",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_24",
    "label": "Bordado",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_25",
    "label": "Macramé",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_26",
    "label": "Cuero",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_27",
    "label": "Joyería",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_28",
    "label": "Modelismo",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_29",
    "label": "Maquetas",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_30",
    "label": "Puzles",
    "category": "base",
    "gear": [
      "puzles"
    ]
  },
  {
    "id": "hob_31",
    "label": "Puzzles 3D",
    "category": "base",
    "gear": [
      "puzles"
    ]
  },
  {
    "id": "hob_32",
    "label": "Legos",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_33",
    "label": "Drones",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_34",
    "label": "Astronomía",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_35",
    "label": "Birdwatching",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_36",
    "label": "Setas",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_37",
    "label": "Plantas de interior",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_38",
    "label": "Huerto urbano",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_39",
    "label": "Bonsái",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_40",
    "label": "Compostaje",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_41",
    "label": "Cocina vegana",
    "category": "base",
    "gear": [
      "cocina"
    ]
  },
  {
    "id": "hob_42",
    "label": "Repostería",
    "category": "base",
    "gear": [
      "cocina"
    ]
  },
  {
    "id": "hob_43",
    "label": "Panadería",
    "category": "base",
    "gear": [
      "cocina"
    ]
  },
  {
    "id": "hob_44",
    "label": "Cafés de especialidad",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_45",
    "label": "Cata de tés",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_46",
    "label": "Cata de vinos",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_47",
    "label": "Cerveza artesanal",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_48",
    "label": "Cócteles",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_49",
    "label": "Cocina fermentada",
    "category": "base",
    "gear": [
      "cocina"
    ]
  },
  {
    "id": "hob_50",
    "label": "Running",
    "category": "base",
    "gear": [
      "running",
      "zapatillas de correr"
    ]
  },
  {
    "id": "hob_51",
    "label": "Trail",
    "category": "base",
    "gear": [
      "running",
      "zapatillas de correr"
    ]
  },
  {
    "id": "hob_52",
    "label": "Ciclismo de carretera",
    "category": "base",
    "gear": [
      "bicicleta"
    ]
  },
  {
    "id": "hob_53",
    "label": "Mtb",
    "category": "base",
    "gear": [
      "bicicleta"
    ]
  },
  {
    "id": "hob_54",
    "label": "Bici urbana",
    "category": "base",
    "gear": [
      "bicicleta"
    ]
  },
  {
    "id": "hob_55",
    "label": "Patinaje",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_56",
    "label": "Skate",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_57",
    "label": "Surf",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_58",
    "label": "Bodyboard",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_59",
    "label": "Paddle surf",
    "category": "base",
    "gear": [
      "kayak"
    ]
  },
  {
    "id": "hob_60",
    "label": "Kayak",
    "category": "base",
    "gear": [
      "kayak"
    ]
  },
  {
    "id": "hob_61",
    "label": "Remo",
    "category": "base",
    "gear": [
      "kayak"
    ]
  },
  {
    "id": "hob_62",
    "label": "Natación",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_63",
    "label": "Buceo",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_64",
    "label": "Escalada indoor",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_65",
    "label": "Boulder",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_66",
    "label": "Senderismo",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_67",
    "label": "Trekking",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_68",
    "label": "Acampada",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_69",
    "label": "Orientación",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_70",
    "label": "Geocaching",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_71",
    "label": "Yoga",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_72",
    "label": "Pilates",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_73",
    "label": "Meditación",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_74",
    "label": "Tai chi",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_75",
    "label": "Calistenia",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_76",
    "label": "Crossfit",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_77",
    "label": "Boxeo",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_78",
    "label": "Artes marciales",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_79",
    "label": "Esgrima",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_80",
    "label": "Tiro con arco",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_81",
    "label": "Tenis",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_82",
    "label": "Pádel",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_83",
    "label": "Bádminton",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_84",
    "label": "Ping-pong",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_85",
    "label": "Fútbol",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_86",
    "label": "Baloncesto",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_87",
    "label": "Voleibol",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_88",
    "label": "Ultimate",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_89",
    "label": "Disfraces",
    "category": "base",
    "gear": [
      "disfraz"
    ]
  },
  {
    "id": "hob_90",
    "label": "Cosplay",
    "category": "base",
    "gear": [
      "disfraz"
    ]
  },
  {
    "id": "hob_91",
    "label": "Teatro amateur",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_92",
    "label": "Improvisación teatral",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_93",
    "label": "Stand up",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_94",
    "label": "Magia",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_95",
    "label": "Malabares",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_96",
    "label": "Cuerda floja",
    "category": "base",
    "gear": [
      "cuerda floja",
      "cuerda / slackline"
    ]
  },
  {
    "id": "hob_97",
    "label": "Slackline",
    "category": "base",
    "gear": [
      "cuerda floja",
      "cuerda / slackline"
    ]
  },
  {
    "id": "hob_98",
    "label": "Cometas",
    "category": "base",
    "gear": [
      "cometa"
    ]
  },
  {
    "id": "hob_99",
    "label": "Aeromodelismo",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_100",
    "label": "Trenes miniatura",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_101",
    "label": "Videojuegos indie",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_102",
    "label": "Videojuegos competitivos",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_103",
    "label": "Juegos de mesa",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_104",
    "label": "Rol de mesa",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_105",
    "label": "Wargames",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_106",
    "label": "Cartas coleccionables",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_107",
    "label": "Lectura de novela",
    "category": "base",
    "gear": [
      "libros"
    ]
  },
  {
    "id": "hob_108",
    "label": "Poesía",
    "category": "base",
    "gear": [
      "libros"
    ]
  },
  {
    "id": "hob_109",
    "label": "Ensayo",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_110",
    "label": "Escritura creativa",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_111",
    "label": "Journaling",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_112",
    "label": "Podcasting",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_113",
    "label": "Radio amateur",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_114",
    "label": "Edición de vídeo",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_115",
    "label": "Stop motion",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_116",
    "label": "Fotografía analógica",
    "category": "base",
    "gear": [
      "cámara"
    ]
  },
  {
    "id": "hob_117",
    "label": "Revelado",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_118",
    "label": "Street photography",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_119",
    "label": "Arquitectura urbana",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_120",
    "label": "Visitar museos",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_121",
    "label": "Visitar monumentos",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_122",
    "label": "Ver pueblitos",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_123",
    "label": "Ver ciudad",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_124",
    "label": "Viajes en tren",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_125",
    "label": "Viajes en furgoneta",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_126",
    "label": "Turismo industrial",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_127",
    "label": "Ruinas",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_128",
    "label": "Cementerios históricos",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_129",
    "label": "Mercados",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_130",
    "label": "Librerías de viejo",
    "category": "base",
    "gear": [
      "libros"
    ]
  },
  {
    "id": "hob_131",
    "label": "Vinilos",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_132",
    "label": "Casetes",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_133",
    "label": "Sellos",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_134",
    "label": "Monedas",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_135",
    "label": "Minerales",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_136",
    "label": "Fósiles",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_137",
    "label": "Insectos (entomología amateur)",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_138",
    "label": "Acuariofilia",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_139",
    "label": "Cuidado de gatos",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_140",
    "label": "Cuidado de perros",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_141",
    "label": "Adiestramiento canino",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_142",
    "label": "Agility",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_143",
    "label": "Equitación",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_144",
    "label": "Voluntariado animal",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_145",
    "label": "Voluntariado social",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_146",
    "label": "Lengua de signos",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_147",
    "label": "Idiomas",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_148",
    "label": "Latín",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_149",
    "label": "Esperanto",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_150",
    "label": "Ajedrez por correspondencia",
    "category": "base",
    "gear": [
      "ajedrez",
      "tablero de ajedrez"
    ]
  },
  {
    "id": "hob_151",
    "label": "Go",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_152",
    "label": "Shogi",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_153",
    "label": "Bridge",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_154",
    "label": "Mahjong",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_155",
    "label": "Sudokus",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_156",
    "label": "Crucigramas",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_157",
    "label": "Escape rooms caseros",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_158",
    "label": "Robótica",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_159",
    "label": "Arduino",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_160",
    "label": "Impresión 3D",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_161",
    "label": "Reparar electrónicos",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_162",
    "label": "Linux",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_163",
    "label": "Ciberseguridad ética amateur",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_164",
    "label": "Mapas OSM",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_165",
    "label": "Hammocking",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_166",
    "label": "Sauna",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_167",
    "label": "Baños fríos",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_168",
    "label": "Respiración",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_169",
    "label": "Astrología cultural",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_170",
    "label": "Tarot artístico",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_171",
    "label": "Perfumería artesanal",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_172",
    "label": "Jabones",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_173",
    "label": "Velas",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_174",
    "label": "Incienso",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_175",
    "label": "Tes de hierbas",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_176",
    "label": "Foraging urbano",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_177",
    "label": "Urban sketching",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_178",
    "label": "Zines",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_179",
    "label": "Fanzines",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_180",
    "label": "Serigrafía",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_181",
    "label": "Linograbado",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_182",
    "label": "Tipografía",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_183",
    "label": "Diseño de interiores",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_184",
    "label": "Feng shui amateur",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_185",
    "label": "Organización del hogar",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_186",
    "label": "Zero waste",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_187",
    "label": "Costura de arreglos",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_188",
    "label": "Upcycling",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_189",
    "label": "Reparar bicis",
    "category": "base",
    "gear": [
      "bicicleta"
    ]
  },
  {
    "id": "hob_190",
    "label": "Mecánica básica",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_191",
    "label": "Carpintería",
    "category": "base",
    "gear": [
      "material de pintura"
    ]
  },
  {
    "id": "hob_192",
    "label": "Torno de madera",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_193",
    "label": "Pirografía",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_194",
    "label": "Vidrio fundido",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_195",
    "label": "Mosaicos",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_196",
    "label": "Graffiti legal",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_197",
    "label": "Parkour ligero",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_198",
    "label": "Danza contemporánea",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_199",
    "label": "Salsa",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_200",
    "label": "Bachata",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_201",
    "label": "Tango",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_202",
    "label": "Swing",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_203",
    "label": "K-pop dance",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_204",
    "label": "Ballet amateur",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_205",
    "label": "Capoeira",
    "category": "base",
    "gear": []
  },
  {
    "id": "hob_206",
    "label": "practicar ajedrez",
    "category": "ocio",
    "gear": [
      "ajedrez",
      "tablero de ajedrez"
    ]
  },
  {
    "id": "hob_207",
    "label": "practicar guitarra acústica",
    "category": "musica",
    "gear": [
      "guitarra"
    ]
  },
  {
    "id": "hob_208",
    "label": "practicar guitarra eléctrica",
    "category": "musica",
    "gear": [
      "guitarra"
    ]
  },
  {
    "id": "hob_209",
    "label": "practicar ukelele",
    "category": "musica",
    "gear": []
  },
  {
    "id": "hob_210",
    "label": "practicar piano",
    "category": "musica",
    "gear": []
  },
  {
    "id": "hob_211",
    "label": "practicar batería",
    "category": "musica",
    "gear": []
  },
  {
    "id": "hob_212",
    "label": "practicar violín",
    "category": "musica",
    "gear": []
  },
  {
    "id": "hob_213",
    "label": "practicar flauta",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_214",
    "label": "practicar armónica",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_215",
    "label": "practicar canto",
    "category": "musica",
    "gear": []
  },
  {
    "id": "hob_216",
    "label": "practicar dibujo a lápiz",
    "category": "arte",
    "gear": [
      "pintura",
      "material de pintura"
    ]
  },
  {
    "id": "hob_217",
    "label": "practicar acuarela",
    "category": "ocio",
    "gear": [
      "pintura",
      "material de pintura"
    ]
  },
  {
    "id": "hob_218",
    "label": "practicar óleo",
    "category": "arte",
    "gear": [
      "pintura",
      "material de pintura"
    ]
  },
  {
    "id": "hob_219",
    "label": "practicar acrílico",
    "category": "ocio",
    "gear": [
      "pintura"
    ]
  },
  {
    "id": "hob_220",
    "label": "practicar cómic",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_221",
    "label": "practicar caligrafía",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_222",
    "label": "practicar lettering",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_223",
    "label": "practicar origami",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_224",
    "label": "practicar cerámica",
    "category": "arte",
    "gear": []
  },
  {
    "id": "hob_225",
    "label": "practicar costura",
    "category": "arte",
    "gear": []
  },
  {
    "id": "hob_226",
    "label": "practicar punto de cruz",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_227",
    "label": "practicar ganchillo",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_228",
    "label": "practicar punto de media",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_229",
    "label": "practicar bordado",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_230",
    "label": "practicar macramé",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_231",
    "label": "practicar cuero",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_232",
    "label": "practicar joyería",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_233",
    "label": "practicar modelismo",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_234",
    "label": "practicar maquetas",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_235",
    "label": "practicar puzles",
    "category": "ocio",
    "gear": [
      "puzles"
    ]
  },
  {
    "id": "hob_236",
    "label": "practicar puzzles 3D",
    "category": "ocio",
    "gear": [
      "puzles"
    ]
  },
  {
    "id": "hob_237",
    "label": "practicar legos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_238",
    "label": "practicar drones",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_239",
    "label": "practicar astronomía",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_240",
    "label": "practicar birdwatching",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_241",
    "label": "practicar setas",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_242",
    "label": "practicar plantas de interior",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_243",
    "label": "practicar huerto urbano",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_244",
    "label": "practicar bonsái",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_245",
    "label": "practicar compostaje",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_246",
    "label": "practicar cocina vegana",
    "category": "gastronomia",
    "gear": [
      "cocina"
    ]
  },
  {
    "id": "hob_247",
    "label": "practicar repostería",
    "category": "ocio",
    "gear": [
      "cocina"
    ]
  },
  {
    "id": "hob_248",
    "label": "practicar panadería",
    "category": "gastronomia",
    "gear": [
      "cocina"
    ]
  },
  {
    "id": "hob_249",
    "label": "practicar cafés de especialidad",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_250",
    "label": "practicar cata de tés",
    "category": "gastronomia",
    "gear": []
  },
  {
    "id": "hob_251",
    "label": "practicar cata de vinos",
    "category": "gastronomia",
    "gear": []
  },
  {
    "id": "hob_252",
    "label": "practicar cerveza artesanal",
    "category": "gastronomia",
    "gear": []
  },
  {
    "id": "hob_253",
    "label": "practicar cócteles",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_254",
    "label": "practicar cocina fermentada",
    "category": "gastronomia",
    "gear": [
      "cocina"
    ]
  },
  {
    "id": "hob_255",
    "label": "practicar running",
    "category": "deporte",
    "gear": [
      "running",
      "zapatillas de correr"
    ]
  },
  {
    "id": "hob_256",
    "label": "practicar trail",
    "category": "ocio",
    "gear": [
      "running",
      "zapatillas de correr"
    ]
  },
  {
    "id": "hob_257",
    "label": "practicar ciclismo de carretera",
    "category": "ocio",
    "gear": [
      "bicicleta"
    ]
  },
  {
    "id": "hob_258",
    "label": "practicar mtb",
    "category": "ocio",
    "gear": [
      "bicicleta"
    ]
  },
  {
    "id": "hob_259",
    "label": "practicar bici urbana",
    "category": "deporte",
    "gear": [
      "bicicleta"
    ]
  },
  {
    "id": "hob_260",
    "label": "practicar patinaje",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_261",
    "label": "practicar skate",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_262",
    "label": "practicar surf",
    "category": "deporte",
    "gear": []
  },
  {
    "id": "hob_263",
    "label": "practicar bodyboard",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_264",
    "label": "practicar paddle surf",
    "category": "deporte",
    "gear": [
      "kayak"
    ]
  },
  {
    "id": "hob_265",
    "label": "practicar kayak",
    "category": "ocio",
    "gear": [
      "kayak"
    ]
  },
  {
    "id": "hob_266",
    "label": "practicar remo",
    "category": "ocio",
    "gear": [
      "kayak"
    ]
  },
  {
    "id": "hob_267",
    "label": "practicar natación",
    "category": "deporte",
    "gear": []
  },
  {
    "id": "hob_268",
    "label": "practicar buceo",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_269",
    "label": "practicar escalada indoor",
    "category": "deporte",
    "gear": []
  },
  {
    "id": "hob_270",
    "label": "practicar boulder",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_271",
    "label": "practicar senderismo",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_272",
    "label": "practicar trekking",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_273",
    "label": "practicar acampada",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_274",
    "label": "practicar orientación",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_275",
    "label": "practicar geocaching",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_276",
    "label": "practicar yoga",
    "category": "deporte",
    "gear": []
  },
  {
    "id": "hob_277",
    "label": "practicar pilates",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_278",
    "label": "practicar meditación",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_279",
    "label": "practicar tai chi",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_280",
    "label": "practicar calistenia",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_281",
    "label": "practicar crossfit",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_282",
    "label": "practicar boxeo",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_283",
    "label": "practicar artes marciales",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_284",
    "label": "practicar esgrima",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_285",
    "label": "practicar tiro con arco",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_286",
    "label": "practicar tenis",
    "category": "deporte",
    "gear": []
  },
  {
    "id": "hob_287",
    "label": "practicar pádel",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_288",
    "label": "practicar bádminton",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_289",
    "label": "practicar ping-pong",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_290",
    "label": "practicar fútbol",
    "category": "deporte",
    "gear": []
  },
  {
    "id": "hob_291",
    "label": "practicar baloncesto",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_292",
    "label": "practicar voleibol",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_293",
    "label": "practicar ultimate",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_294",
    "label": "practicar disfraces",
    "category": "ocio",
    "gear": [
      "disfraz"
    ]
  },
  {
    "id": "hob_295",
    "label": "practicar cosplay",
    "category": "ocio",
    "gear": [
      "disfraz"
    ]
  },
  {
    "id": "hob_296",
    "label": "practicar teatro amateur",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_297",
    "label": "practicar improvisación teatral",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_298",
    "label": "practicar stand up",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_299",
    "label": "practicar magia",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_300",
    "label": "practicar malabares",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_301",
    "label": "practicar cuerda floja",
    "category": "ocio",
    "gear": [
      "cuerda floja",
      "cuerda / slackline"
    ]
  },
  {
    "id": "hob_302",
    "label": "practicar slackline",
    "category": "ocio",
    "gear": [
      "cuerda floja",
      "cuerda / slackline"
    ]
  },
  {
    "id": "hob_303",
    "label": "practicar cometas",
    "category": "ocio",
    "gear": [
      "cometa"
    ]
  },
  {
    "id": "hob_304",
    "label": "practicar aeromodelismo",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_305",
    "label": "practicar trenes miniatura",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_306",
    "label": "practicar videojuegos indie",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_307",
    "label": "practicar videojuegos competitivos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_308",
    "label": "practicar juegos de mesa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_309",
    "label": "practicar rol de mesa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_310",
    "label": "practicar wargames",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_311",
    "label": "practicar cartas coleccionables",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_312",
    "label": "practicar lectura de novela",
    "category": "ocio",
    "gear": [
      "libros"
    ]
  },
  {
    "id": "hob_313",
    "label": "practicar poesía",
    "category": "ocio",
    "gear": [
      "libros"
    ]
  },
  {
    "id": "hob_314",
    "label": "practicar ensayo",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_315",
    "label": "practicar escritura creativa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_316",
    "label": "practicar journaling",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_317",
    "label": "practicar podcasting",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_318",
    "label": "practicar radio amateur",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_319",
    "label": "practicar edición de vídeo",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_320",
    "label": "practicar stop motion",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_321",
    "label": "practicar fotografía analógica",
    "category": "arte",
    "gear": [
      "cámara"
    ]
  },
  {
    "id": "hob_322",
    "label": "practicar revelado",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_323",
    "label": "practicar street photography",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_324",
    "label": "practicar arquitectura urbana",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_325",
    "label": "practicar visitar museos",
    "category": "cultura",
    "gear": []
  },
  {
    "id": "hob_326",
    "label": "practicar visitar monumentos",
    "category": "cultura",
    "gear": []
  },
  {
    "id": "hob_327",
    "label": "practicar ver pueblitos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_328",
    "label": "practicar ver ciudad",
    "category": "cultura",
    "gear": []
  },
  {
    "id": "hob_329",
    "label": "practicar viajes en tren",
    "category": "cultura",
    "gear": []
  },
  {
    "id": "hob_330",
    "label": "practicar viajes en furgoneta",
    "category": "cultura",
    "gear": []
  },
  {
    "id": "hob_331",
    "label": "practicar turismo industrial",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_332",
    "label": "practicar ruinas",
    "category": "cultura",
    "gear": []
  },
  {
    "id": "hob_333",
    "label": "practicar cementerios históricos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_334",
    "label": "practicar mercados",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_335",
    "label": "practicar librerías de viejo",
    "category": "ocio",
    "gear": [
      "libros"
    ]
  },
  {
    "id": "hob_336",
    "label": "practicar vinilos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_337",
    "label": "practicar casetes",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_338",
    "label": "practicar sellos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_339",
    "label": "practicar monedas",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_340",
    "label": "practicar minerales",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_341",
    "label": "practicar fósiles",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_342",
    "label": "practicar insectos (entomología amateur)",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_343",
    "label": "practicar acuariofilia",
    "category": "mascotas",
    "gear": []
  },
  {
    "id": "hob_344",
    "label": "practicar cuidado de gatos",
    "category": "mascotas",
    "gear": []
  },
  {
    "id": "hob_345",
    "label": "practicar cuidado de perros",
    "category": "mascotas",
    "gear": []
  },
  {
    "id": "hob_346",
    "label": "practicar adiestramiento canino",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_347",
    "label": "practicar agility",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_348",
    "label": "practicar equitación",
    "category": "mascotas",
    "gear": []
  },
  {
    "id": "hob_349",
    "label": "practicar voluntariado animal",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_350",
    "label": "practicar voluntariado social",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_351",
    "label": "practicar lengua de signos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_352",
    "label": "practicar idiomas",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_353",
    "label": "practicar latín",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_354",
    "label": "practicar esperanto",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_355",
    "label": "practicar ajedrez por correspondencia",
    "category": "ocio",
    "gear": [
      "ajedrez",
      "tablero de ajedrez"
    ]
  },
  {
    "id": "hob_356",
    "label": "practicar go",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_357",
    "label": "practicar shogi",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_358",
    "label": "practicar bridge",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_359",
    "label": "practicar mahjong",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_360",
    "label": "practicar sudokus",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_361",
    "label": "practicar crucigramas",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_362",
    "label": "practicar escape rooms caseros",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_363",
    "label": "practicar robótica",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_364",
    "label": "practicar arduino",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_365",
    "label": "practicar impresión 3D",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_366",
    "label": "practicar reparar electrónicos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_367",
    "label": "practicar linux",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_368",
    "label": "practicar ciberseguridad ética amateur",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_369",
    "label": "practicar mapas OSM",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_370",
    "label": "practicar hammocking",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_371",
    "label": "practicar sauna",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_372",
    "label": "practicar baños fríos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_373",
    "label": "practicar respiración",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_374",
    "label": "practicar astrología cultural",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_375",
    "label": "practicar tarot artístico",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_376",
    "label": "practicar perfumería artesanal",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_377",
    "label": "practicar jabones",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_378",
    "label": "practicar velas",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_379",
    "label": "practicar incienso",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_380",
    "label": "practicar tes de hierbas",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_381",
    "label": "practicar foraging urbano",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_382",
    "label": "practicar urban sketching",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_383",
    "label": "practicar zines",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_384",
    "label": "practicar fanzines",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_385",
    "label": "practicar serigrafía",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_386",
    "label": "practicar linograbado",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_387",
    "label": "practicar tipografía",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_388",
    "label": "practicar diseño de interiores",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_389",
    "label": "practicar feng shui amateur",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_390",
    "label": "practicar organización del hogar",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_391",
    "label": "practicar zero waste",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_392",
    "label": "practicar costura de arreglos",
    "category": "arte",
    "gear": []
  },
  {
    "id": "hob_393",
    "label": "practicar upcycling",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_394",
    "label": "practicar reparar bicis",
    "category": "deporte",
    "gear": [
      "bicicleta"
    ]
  },
  {
    "id": "hob_395",
    "label": "practicar mecánica básica",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_396",
    "label": "practicar carpintería",
    "category": "ocio",
    "gear": [
      "material de pintura"
    ]
  },
  {
    "id": "hob_397",
    "label": "practicar torno de madera",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_398",
    "label": "practicar pirografía",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_399",
    "label": "practicar vidrio fundido",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_400",
    "label": "practicar mosaicos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_401",
    "label": "practicar graffiti legal",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_402",
    "label": "practicar parkour ligero",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_403",
    "label": "practicar danza contemporánea",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_404",
    "label": "practicar salsa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_405",
    "label": "practicar bachata",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_406",
    "label": "practicar tango",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_407",
    "label": "practicar swing",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_408",
    "label": "practicar k-pop dance",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_409",
    "label": "practicar ballet amateur",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_410",
    "label": "practicar capoeira",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_411",
    "label": "aprender ajedrez",
    "category": "ocio",
    "gear": [
      "ajedrez",
      "tablero de ajedrez"
    ]
  },
  {
    "id": "hob_412",
    "label": "aprender guitarra acústica",
    "category": "musica",
    "gear": [
      "guitarra"
    ]
  },
  {
    "id": "hob_413",
    "label": "aprender guitarra eléctrica",
    "category": "musica",
    "gear": [
      "guitarra"
    ]
  },
  {
    "id": "hob_414",
    "label": "aprender ukelele",
    "category": "musica",
    "gear": []
  },
  {
    "id": "hob_415",
    "label": "aprender piano",
    "category": "musica",
    "gear": []
  },
  {
    "id": "hob_416",
    "label": "aprender batería",
    "category": "musica",
    "gear": []
  },
  {
    "id": "hob_417",
    "label": "aprender violín",
    "category": "musica",
    "gear": []
  },
  {
    "id": "hob_418",
    "label": "aprender flauta",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_419",
    "label": "aprender armónica",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_420",
    "label": "aprender canto",
    "category": "musica",
    "gear": []
  },
  {
    "id": "hob_421",
    "label": "aprender dibujo a lápiz",
    "category": "arte",
    "gear": [
      "pintura",
      "material de pintura"
    ]
  },
  {
    "id": "hob_422",
    "label": "aprender acuarela",
    "category": "ocio",
    "gear": [
      "pintura",
      "material de pintura"
    ]
  },
  {
    "id": "hob_423",
    "label": "aprender óleo",
    "category": "arte",
    "gear": [
      "pintura",
      "material de pintura"
    ]
  },
  {
    "id": "hob_424",
    "label": "aprender acrílico",
    "category": "ocio",
    "gear": [
      "pintura"
    ]
  },
  {
    "id": "hob_425",
    "label": "aprender cómic",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_426",
    "label": "aprender caligrafía",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_427",
    "label": "aprender lettering",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_428",
    "label": "aprender origami",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_429",
    "label": "aprender cerámica",
    "category": "arte",
    "gear": []
  },
  {
    "id": "hob_430",
    "label": "aprender costura",
    "category": "arte",
    "gear": []
  },
  {
    "id": "hob_431",
    "label": "aprender punto de cruz",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_432",
    "label": "aprender ganchillo",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_433",
    "label": "aprender punto de media",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_434",
    "label": "aprender bordado",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_435",
    "label": "aprender macramé",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_436",
    "label": "aprender cuero",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_437",
    "label": "aprender joyería",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_438",
    "label": "aprender modelismo",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_439",
    "label": "aprender maquetas",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_440",
    "label": "aprender puzles",
    "category": "ocio",
    "gear": [
      "puzles"
    ]
  },
  {
    "id": "hob_441",
    "label": "aprender puzzles 3D",
    "category": "ocio",
    "gear": [
      "puzles"
    ]
  },
  {
    "id": "hob_442",
    "label": "aprender legos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_443",
    "label": "aprender drones",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_444",
    "label": "aprender astronomía",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_445",
    "label": "aprender birdwatching",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_446",
    "label": "aprender setas",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_447",
    "label": "aprender plantas de interior",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_448",
    "label": "aprender huerto urbano",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_449",
    "label": "aprender bonsái",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_450",
    "label": "aprender compostaje",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_451",
    "label": "aprender cocina vegana",
    "category": "gastronomia",
    "gear": [
      "cocina"
    ]
  },
  {
    "id": "hob_452",
    "label": "aprender repostería",
    "category": "ocio",
    "gear": [
      "cocina"
    ]
  },
  {
    "id": "hob_453",
    "label": "aprender panadería",
    "category": "gastronomia",
    "gear": [
      "cocina"
    ]
  },
  {
    "id": "hob_454",
    "label": "aprender cafés de especialidad",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_455",
    "label": "aprender cata de tés",
    "category": "gastronomia",
    "gear": []
  },
  {
    "id": "hob_456",
    "label": "aprender cata de vinos",
    "category": "gastronomia",
    "gear": []
  },
  {
    "id": "hob_457",
    "label": "aprender cerveza artesanal",
    "category": "gastronomia",
    "gear": []
  },
  {
    "id": "hob_458",
    "label": "aprender cócteles",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_459",
    "label": "aprender cocina fermentada",
    "category": "gastronomia",
    "gear": [
      "cocina"
    ]
  },
  {
    "id": "hob_460",
    "label": "aprender running",
    "category": "deporte",
    "gear": [
      "running",
      "zapatillas de correr"
    ]
  },
  {
    "id": "hob_461",
    "label": "aprender trail",
    "category": "ocio",
    "gear": [
      "running",
      "zapatillas de correr"
    ]
  },
  {
    "id": "hob_462",
    "label": "aprender ciclismo de carretera",
    "category": "ocio",
    "gear": [
      "bicicleta"
    ]
  },
  {
    "id": "hob_463",
    "label": "aprender mtb",
    "category": "ocio",
    "gear": [
      "bicicleta"
    ]
  },
  {
    "id": "hob_464",
    "label": "aprender bici urbana",
    "category": "deporte",
    "gear": [
      "bicicleta"
    ]
  },
  {
    "id": "hob_465",
    "label": "aprender patinaje",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_466",
    "label": "aprender skate",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_467",
    "label": "aprender surf",
    "category": "deporte",
    "gear": []
  },
  {
    "id": "hob_468",
    "label": "aprender bodyboard",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_469",
    "label": "aprender paddle surf",
    "category": "deporte",
    "gear": [
      "kayak"
    ]
  },
  {
    "id": "hob_470",
    "label": "aprender kayak",
    "category": "ocio",
    "gear": [
      "kayak"
    ]
  },
  {
    "id": "hob_471",
    "label": "aprender remo",
    "category": "ocio",
    "gear": [
      "kayak"
    ]
  },
  {
    "id": "hob_472",
    "label": "aprender natación",
    "category": "deporte",
    "gear": []
  },
  {
    "id": "hob_473",
    "label": "aprender buceo",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_474",
    "label": "aprender escalada indoor",
    "category": "deporte",
    "gear": []
  },
  {
    "id": "hob_475",
    "label": "aprender boulder",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_476",
    "label": "aprender senderismo",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_477",
    "label": "aprender trekking",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_478",
    "label": "aprender acampada",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_479",
    "label": "aprender orientación",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_480",
    "label": "aprender geocaching",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_481",
    "label": "aprender yoga",
    "category": "deporte",
    "gear": []
  },
  {
    "id": "hob_482",
    "label": "aprender pilates",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_483",
    "label": "aprender meditación",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_484",
    "label": "aprender tai chi",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_485",
    "label": "aprender calistenia",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_486",
    "label": "aprender crossfit",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_487",
    "label": "aprender boxeo",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_488",
    "label": "aprender artes marciales",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_489",
    "label": "aprender esgrima",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_490",
    "label": "aprender tiro con arco",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_491",
    "label": "aprender tenis",
    "category": "deporte",
    "gear": []
  },
  {
    "id": "hob_492",
    "label": "aprender pádel",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_493",
    "label": "aprender bádminton",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_494",
    "label": "aprender ping-pong",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_495",
    "label": "aprender fútbol",
    "category": "deporte",
    "gear": []
  },
  {
    "id": "hob_496",
    "label": "aprender baloncesto",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_497",
    "label": "aprender voleibol",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_498",
    "label": "aprender ultimate",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_499",
    "label": "aprender disfraces",
    "category": "ocio",
    "gear": [
      "disfraz"
    ]
  },
  {
    "id": "hob_500",
    "label": "aprender cosplay",
    "category": "ocio",
    "gear": [
      "disfraz"
    ]
  },
  {
    "id": "hob_501",
    "label": "aprender teatro amateur",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_502",
    "label": "aprender improvisación teatral",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_503",
    "label": "aprender stand up",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_504",
    "label": "aprender magia",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_505",
    "label": "aprender malabares",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_506",
    "label": "aprender cuerda floja",
    "category": "ocio",
    "gear": [
      "cuerda floja",
      "cuerda / slackline"
    ]
  },
  {
    "id": "hob_507",
    "label": "aprender slackline",
    "category": "ocio",
    "gear": [
      "cuerda floja",
      "cuerda / slackline"
    ]
  },
  {
    "id": "hob_508",
    "label": "aprender cometas",
    "category": "ocio",
    "gear": [
      "cometa"
    ]
  },
  {
    "id": "hob_509",
    "label": "aprender aeromodelismo",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_510",
    "label": "aprender trenes miniatura",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_511",
    "label": "aprender videojuegos indie",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_512",
    "label": "aprender videojuegos competitivos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_513",
    "label": "aprender juegos de mesa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_514",
    "label": "aprender rol de mesa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_515",
    "label": "aprender wargames",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_516",
    "label": "aprender cartas coleccionables",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_517",
    "label": "aprender lectura de novela",
    "category": "ocio",
    "gear": [
      "libros"
    ]
  },
  {
    "id": "hob_518",
    "label": "aprender poesía",
    "category": "ocio",
    "gear": [
      "libros"
    ]
  },
  {
    "id": "hob_519",
    "label": "aprender ensayo",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_520",
    "label": "aprender escritura creativa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_521",
    "label": "aprender journaling",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_522",
    "label": "aprender podcasting",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_523",
    "label": "aprender radio amateur",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_524",
    "label": "aprender edición de vídeo",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_525",
    "label": "aprender stop motion",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_526",
    "label": "aprender fotografía analógica",
    "category": "arte",
    "gear": [
      "cámara"
    ]
  },
  {
    "id": "hob_527",
    "label": "aprender revelado",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_528",
    "label": "aprender street photography",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_529",
    "label": "aprender arquitectura urbana",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_530",
    "label": "aprender visitar museos",
    "category": "cultura",
    "gear": []
  },
  {
    "id": "hob_531",
    "label": "aprender visitar monumentos",
    "category": "cultura",
    "gear": []
  },
  {
    "id": "hob_532",
    "label": "aprender ver pueblitos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_533",
    "label": "aprender ver ciudad",
    "category": "cultura",
    "gear": []
  },
  {
    "id": "hob_534",
    "label": "aprender viajes en tren",
    "category": "cultura",
    "gear": []
  },
  {
    "id": "hob_535",
    "label": "aprender viajes en furgoneta",
    "category": "cultura",
    "gear": []
  },
  {
    "id": "hob_536",
    "label": "aprender turismo industrial",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_537",
    "label": "aprender ruinas",
    "category": "cultura",
    "gear": []
  },
  {
    "id": "hob_538",
    "label": "aprender cementerios históricos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_539",
    "label": "aprender mercados",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_540",
    "label": "aprender librerías de viejo",
    "category": "ocio",
    "gear": [
      "libros"
    ]
  },
  {
    "id": "hob_541",
    "label": "aprender vinilos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_542",
    "label": "aprender casetes",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_543",
    "label": "aprender sellos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_544",
    "label": "aprender monedas",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_545",
    "label": "aprender minerales",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_546",
    "label": "aprender fósiles",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_547",
    "label": "aprender insectos (entomología amateur)",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_548",
    "label": "aprender acuariofilia",
    "category": "mascotas",
    "gear": []
  },
  {
    "id": "hob_549",
    "label": "aprender cuidado de gatos",
    "category": "mascotas",
    "gear": []
  },
  {
    "id": "hob_550",
    "label": "aprender cuidado de perros",
    "category": "mascotas",
    "gear": []
  },
  {
    "id": "hob_551",
    "label": "aprender adiestramiento canino",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_552",
    "label": "aprender agility",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_553",
    "label": "aprender equitación",
    "category": "mascotas",
    "gear": []
  },
  {
    "id": "hob_554",
    "label": "aprender voluntariado animal",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_555",
    "label": "aprender voluntariado social",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_556",
    "label": "aprender lengua de signos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_557",
    "label": "aprender idiomas",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_558",
    "label": "aprender latín",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_559",
    "label": "aprender esperanto",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_560",
    "label": "aprender ajedrez por correspondencia",
    "category": "ocio",
    "gear": [
      "ajedrez",
      "tablero de ajedrez"
    ]
  },
  {
    "id": "hob_561",
    "label": "aprender go",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_562",
    "label": "aprender shogi",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_563",
    "label": "aprender bridge",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_564",
    "label": "aprender mahjong",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_565",
    "label": "aprender sudokus",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_566",
    "label": "aprender crucigramas",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_567",
    "label": "aprender escape rooms caseros",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_568",
    "label": "aprender robótica",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_569",
    "label": "aprender arduino",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_570",
    "label": "aprender impresión 3D",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_571",
    "label": "aprender reparar electrónicos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_572",
    "label": "aprender linux",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_573",
    "label": "aprender ciberseguridad ética amateur",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_574",
    "label": "aprender mapas OSM",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_575",
    "label": "aprender hammocking",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_576",
    "label": "aprender sauna",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_577",
    "label": "aprender baños fríos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_578",
    "label": "aprender respiración",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_579",
    "label": "aprender astrología cultural",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_580",
    "label": "aprender tarot artístico",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_581",
    "label": "aprender perfumería artesanal",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_582",
    "label": "aprender jabones",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_583",
    "label": "aprender velas",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_584",
    "label": "aprender incienso",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_585",
    "label": "aprender tes de hierbas",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_586",
    "label": "aprender foraging urbano",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_587",
    "label": "aprender urban sketching",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_588",
    "label": "aprender zines",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_589",
    "label": "aprender fanzines",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_590",
    "label": "aprender serigrafía",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_591",
    "label": "aprender linograbado",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_592",
    "label": "aprender tipografía",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_593",
    "label": "aprender diseño de interiores",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_594",
    "label": "aprender feng shui amateur",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_595",
    "label": "aprender organización del hogar",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_596",
    "label": "aprender zero waste",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_597",
    "label": "aprender costura de arreglos",
    "category": "arte",
    "gear": []
  },
  {
    "id": "hob_598",
    "label": "aprender upcycling",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_599",
    "label": "aprender reparar bicis",
    "category": "deporte",
    "gear": [
      "bicicleta"
    ]
  },
  {
    "id": "hob_600",
    "label": "aprender mecánica básica",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_601",
    "label": "aprender carpintería",
    "category": "ocio",
    "gear": [
      "material de pintura"
    ]
  },
  {
    "id": "hob_602",
    "label": "aprender torno de madera",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_603",
    "label": "aprender pirografía",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_604",
    "label": "aprender vidrio fundido",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_605",
    "label": "aprender mosaicos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_606",
    "label": "aprender graffiti legal",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_607",
    "label": "aprender parkour ligero",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_608",
    "label": "aprender danza contemporánea",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_609",
    "label": "aprender salsa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_610",
    "label": "aprender bachata",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_611",
    "label": "aprender tango",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_612",
    "label": "aprender swing",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_613",
    "label": "aprender k-pop dance",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_614",
    "label": "aprender ballet amateur",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_615",
    "label": "aprender capoeira",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_616",
    "label": "coleccionar ajedrez",
    "category": "ocio",
    "gear": [
      "ajedrez",
      "tablero de ajedrez"
    ]
  },
  {
    "id": "hob_617",
    "label": "coleccionar guitarra acústica",
    "category": "musica",
    "gear": [
      "guitarra"
    ]
  },
  {
    "id": "hob_618",
    "label": "coleccionar guitarra eléctrica",
    "category": "musica",
    "gear": [
      "guitarra"
    ]
  },
  {
    "id": "hob_619",
    "label": "coleccionar ukelele",
    "category": "musica",
    "gear": []
  },
  {
    "id": "hob_620",
    "label": "coleccionar piano",
    "category": "musica",
    "gear": []
  },
  {
    "id": "hob_621",
    "label": "coleccionar batería",
    "category": "musica",
    "gear": []
  },
  {
    "id": "hob_622",
    "label": "coleccionar violín",
    "category": "musica",
    "gear": []
  },
  {
    "id": "hob_623",
    "label": "coleccionar flauta",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_624",
    "label": "coleccionar armónica",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_625",
    "label": "coleccionar canto",
    "category": "musica",
    "gear": []
  },
  {
    "id": "hob_626",
    "label": "coleccionar dibujo a lápiz",
    "category": "arte",
    "gear": [
      "pintura",
      "material de pintura"
    ]
  },
  {
    "id": "hob_627",
    "label": "coleccionar acuarela",
    "category": "ocio",
    "gear": [
      "pintura",
      "material de pintura"
    ]
  },
  {
    "id": "hob_628",
    "label": "coleccionar óleo",
    "category": "arte",
    "gear": [
      "pintura",
      "material de pintura"
    ]
  },
  {
    "id": "hob_629",
    "label": "coleccionar acrílico",
    "category": "ocio",
    "gear": [
      "pintura"
    ]
  },
  {
    "id": "hob_630",
    "label": "coleccionar cómic",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_631",
    "label": "coleccionar caligrafía",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_632",
    "label": "coleccionar lettering",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_633",
    "label": "coleccionar origami",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_634",
    "label": "coleccionar cerámica",
    "category": "arte",
    "gear": []
  },
  {
    "id": "hob_635",
    "label": "coleccionar costura",
    "category": "arte",
    "gear": []
  },
  {
    "id": "hob_636",
    "label": "coleccionar punto de cruz",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_637",
    "label": "coleccionar ganchillo",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_638",
    "label": "coleccionar punto de media",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_639",
    "label": "coleccionar bordado",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_640",
    "label": "coleccionar macramé",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_641",
    "label": "coleccionar cuero",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_642",
    "label": "coleccionar joyería",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_643",
    "label": "coleccionar modelismo",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_644",
    "label": "coleccionar maquetas",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_645",
    "label": "coleccionar puzles",
    "category": "ocio",
    "gear": [
      "puzles"
    ]
  },
  {
    "id": "hob_646",
    "label": "coleccionar puzzles 3D",
    "category": "ocio",
    "gear": [
      "puzles"
    ]
  },
  {
    "id": "hob_647",
    "label": "coleccionar legos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_648",
    "label": "coleccionar drones",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_649",
    "label": "coleccionar astronomía",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_650",
    "label": "coleccionar birdwatching",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_651",
    "label": "coleccionar setas",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_652",
    "label": "coleccionar plantas de interior",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_653",
    "label": "coleccionar huerto urbano",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_654",
    "label": "coleccionar bonsái",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_655",
    "label": "coleccionar compostaje",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_656",
    "label": "coleccionar cocina vegana",
    "category": "gastronomia",
    "gear": [
      "cocina"
    ]
  },
  {
    "id": "hob_657",
    "label": "coleccionar repostería",
    "category": "ocio",
    "gear": [
      "cocina"
    ]
  },
  {
    "id": "hob_658",
    "label": "coleccionar panadería",
    "category": "gastronomia",
    "gear": [
      "cocina"
    ]
  },
  {
    "id": "hob_659",
    "label": "coleccionar cafés de especialidad",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_660",
    "label": "coleccionar cata de tés",
    "category": "gastronomia",
    "gear": []
  },
  {
    "id": "hob_661",
    "label": "coleccionar cata de vinos",
    "category": "gastronomia",
    "gear": []
  },
  {
    "id": "hob_662",
    "label": "coleccionar cerveza artesanal",
    "category": "gastronomia",
    "gear": []
  },
  {
    "id": "hob_663",
    "label": "coleccionar cócteles",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_664",
    "label": "coleccionar cocina fermentada",
    "category": "gastronomia",
    "gear": [
      "cocina"
    ]
  },
  {
    "id": "hob_665",
    "label": "coleccionar running",
    "category": "deporte",
    "gear": [
      "running",
      "zapatillas de correr"
    ]
  },
  {
    "id": "hob_666",
    "label": "coleccionar trail",
    "category": "ocio",
    "gear": [
      "running",
      "zapatillas de correr"
    ]
  },
  {
    "id": "hob_667",
    "label": "coleccionar ciclismo de carretera",
    "category": "ocio",
    "gear": [
      "bicicleta"
    ]
  },
  {
    "id": "hob_668",
    "label": "coleccionar mtb",
    "category": "ocio",
    "gear": [
      "bicicleta"
    ]
  },
  {
    "id": "hob_669",
    "label": "coleccionar bici urbana",
    "category": "deporte",
    "gear": [
      "bicicleta"
    ]
  },
  {
    "id": "hob_670",
    "label": "coleccionar patinaje",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_671",
    "label": "coleccionar skate",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_672",
    "label": "coleccionar surf",
    "category": "deporte",
    "gear": []
  },
  {
    "id": "hob_673",
    "label": "coleccionar bodyboard",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_674",
    "label": "coleccionar paddle surf",
    "category": "deporte",
    "gear": [
      "kayak"
    ]
  },
  {
    "id": "hob_675",
    "label": "coleccionar kayak",
    "category": "ocio",
    "gear": [
      "kayak"
    ]
  },
  {
    "id": "hob_676",
    "label": "coleccionar remo",
    "category": "ocio",
    "gear": [
      "kayak"
    ]
  },
  {
    "id": "hob_677",
    "label": "coleccionar natación",
    "category": "deporte",
    "gear": []
  },
  {
    "id": "hob_678",
    "label": "coleccionar buceo",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_679",
    "label": "coleccionar escalada indoor",
    "category": "deporte",
    "gear": []
  },
  {
    "id": "hob_680",
    "label": "coleccionar boulder",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_681",
    "label": "coleccionar senderismo",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_682",
    "label": "coleccionar trekking",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_683",
    "label": "coleccionar acampada",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_684",
    "label": "coleccionar orientación",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_685",
    "label": "coleccionar geocaching",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_686",
    "label": "coleccionar yoga",
    "category": "deporte",
    "gear": []
  },
  {
    "id": "hob_687",
    "label": "coleccionar pilates",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_688",
    "label": "coleccionar meditación",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_689",
    "label": "coleccionar tai chi",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_690",
    "label": "coleccionar calistenia",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_691",
    "label": "coleccionar crossfit",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_692",
    "label": "coleccionar boxeo",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_693",
    "label": "coleccionar artes marciales",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_694",
    "label": "coleccionar esgrima",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_695",
    "label": "coleccionar tiro con arco",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_696",
    "label": "coleccionar tenis",
    "category": "deporte",
    "gear": []
  },
  {
    "id": "hob_697",
    "label": "coleccionar pádel",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_698",
    "label": "coleccionar bádminton",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_699",
    "label": "coleccionar ping-pong",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_700",
    "label": "coleccionar fútbol",
    "category": "deporte",
    "gear": []
  },
  {
    "id": "hob_701",
    "label": "coleccionar baloncesto",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_702",
    "label": "coleccionar voleibol",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_703",
    "label": "coleccionar ultimate",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_704",
    "label": "coleccionar disfraces",
    "category": "ocio",
    "gear": [
      "disfraz"
    ]
  },
  {
    "id": "hob_705",
    "label": "coleccionar cosplay",
    "category": "ocio",
    "gear": [
      "disfraz"
    ]
  },
  {
    "id": "hob_706",
    "label": "coleccionar teatro amateur",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_707",
    "label": "coleccionar improvisación teatral",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_708",
    "label": "coleccionar stand up",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_709",
    "label": "coleccionar magia",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_710",
    "label": "coleccionar malabares",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_711",
    "label": "coleccionar cuerda floja",
    "category": "ocio",
    "gear": [
      "cuerda floja",
      "cuerda / slackline"
    ]
  },
  {
    "id": "hob_712",
    "label": "coleccionar slackline",
    "category": "ocio",
    "gear": [
      "cuerda floja",
      "cuerda / slackline"
    ]
  },
  {
    "id": "hob_713",
    "label": "coleccionar cometas",
    "category": "ocio",
    "gear": [
      "cometa"
    ]
  },
  {
    "id": "hob_714",
    "label": "coleccionar aeromodelismo",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_715",
    "label": "coleccionar trenes miniatura",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_716",
    "label": "coleccionar videojuegos indie",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_717",
    "label": "coleccionar videojuegos competitivos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_718",
    "label": "coleccionar juegos de mesa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_719",
    "label": "coleccionar rol de mesa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_720",
    "label": "coleccionar wargames",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_721",
    "label": "coleccionar cartas coleccionables",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_722",
    "label": "coleccionar lectura de novela",
    "category": "ocio",
    "gear": [
      "libros"
    ]
  },
  {
    "id": "hob_723",
    "label": "coleccionar poesía",
    "category": "ocio",
    "gear": [
      "libros"
    ]
  },
  {
    "id": "hob_724",
    "label": "coleccionar ensayo",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_725",
    "label": "coleccionar escritura creativa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_726",
    "label": "coleccionar journaling",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_727",
    "label": "coleccionar podcasting",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_728",
    "label": "coleccionar radio amateur",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_729",
    "label": "coleccionar edición de vídeo",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_730",
    "label": "coleccionar stop motion",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_731",
    "label": "coleccionar fotografía analógica",
    "category": "arte",
    "gear": [
      "cámara"
    ]
  },
  {
    "id": "hob_732",
    "label": "coleccionar revelado",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_733",
    "label": "coleccionar street photography",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_734",
    "label": "coleccionar arquitectura urbana",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_735",
    "label": "coleccionar visitar museos",
    "category": "cultura",
    "gear": []
  },
  {
    "id": "hob_736",
    "label": "coleccionar visitar monumentos",
    "category": "cultura",
    "gear": []
  },
  {
    "id": "hob_737",
    "label": "coleccionar ver pueblitos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_738",
    "label": "coleccionar ver ciudad",
    "category": "cultura",
    "gear": []
  },
  {
    "id": "hob_739",
    "label": "coleccionar viajes en tren",
    "category": "cultura",
    "gear": []
  },
  {
    "id": "hob_740",
    "label": "coleccionar viajes en furgoneta",
    "category": "cultura",
    "gear": []
  },
  {
    "id": "hob_741",
    "label": "coleccionar turismo industrial",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_742",
    "label": "coleccionar ruinas",
    "category": "cultura",
    "gear": []
  },
  {
    "id": "hob_743",
    "label": "coleccionar cementerios históricos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_744",
    "label": "coleccionar mercados",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_745",
    "label": "coleccionar librerías de viejo",
    "category": "ocio",
    "gear": [
      "libros"
    ]
  },
  {
    "id": "hob_746",
    "label": "coleccionar vinilos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_747",
    "label": "coleccionar casetes",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_748",
    "label": "coleccionar sellos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_749",
    "label": "coleccionar monedas",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_750",
    "label": "coleccionar minerales",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_751",
    "label": "coleccionar fósiles",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_752",
    "label": "coleccionar insectos (entomología amateur)",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_753",
    "label": "coleccionar acuariofilia",
    "category": "mascotas",
    "gear": []
  },
  {
    "id": "hob_754",
    "label": "coleccionar cuidado de gatos",
    "category": "mascotas",
    "gear": []
  },
  {
    "id": "hob_755",
    "label": "coleccionar cuidado de perros",
    "category": "mascotas",
    "gear": []
  },
  {
    "id": "hob_756",
    "label": "coleccionar adiestramiento canino",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_757",
    "label": "coleccionar agility",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_758",
    "label": "coleccionar equitación",
    "category": "mascotas",
    "gear": []
  },
  {
    "id": "hob_759",
    "label": "coleccionar voluntariado animal",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_760",
    "label": "coleccionar voluntariado social",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_761",
    "label": "coleccionar lengua de signos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_762",
    "label": "coleccionar idiomas",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_763",
    "label": "coleccionar latín",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_764",
    "label": "coleccionar esperanto",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_765",
    "label": "coleccionar ajedrez por correspondencia",
    "category": "ocio",
    "gear": [
      "ajedrez",
      "tablero de ajedrez"
    ]
  },
  {
    "id": "hob_766",
    "label": "coleccionar go",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_767",
    "label": "coleccionar shogi",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_768",
    "label": "coleccionar bridge",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_769",
    "label": "coleccionar mahjong",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_770",
    "label": "coleccionar sudokus",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_771",
    "label": "coleccionar crucigramas",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_772",
    "label": "coleccionar escape rooms caseros",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_773",
    "label": "coleccionar robótica",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_774",
    "label": "coleccionar arduino",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_775",
    "label": "coleccionar impresión 3D",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_776",
    "label": "coleccionar reparar electrónicos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_777",
    "label": "coleccionar linux",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_778",
    "label": "coleccionar ciberseguridad ética amateur",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_779",
    "label": "coleccionar mapas OSM",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_780",
    "label": "coleccionar hammocking",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_781",
    "label": "coleccionar sauna",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_782",
    "label": "coleccionar baños fríos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_783",
    "label": "coleccionar respiración",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_784",
    "label": "coleccionar astrología cultural",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_785",
    "label": "coleccionar tarot artístico",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_786",
    "label": "coleccionar perfumería artesanal",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_787",
    "label": "coleccionar jabones",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_788",
    "label": "coleccionar velas",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_789",
    "label": "coleccionar incienso",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_790",
    "label": "coleccionar tes de hierbas",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_791",
    "label": "coleccionar foraging urbano",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_792",
    "label": "coleccionar urban sketching",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_793",
    "label": "coleccionar zines",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_794",
    "label": "coleccionar fanzines",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_795",
    "label": "coleccionar serigrafía",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_796",
    "label": "coleccionar linograbado",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_797",
    "label": "coleccionar tipografía",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_798",
    "label": "coleccionar diseño de interiores",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_799",
    "label": "coleccionar feng shui amateur",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_800",
    "label": "coleccionar organización del hogar",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_801",
    "label": "coleccionar zero waste",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_802",
    "label": "coleccionar costura de arreglos",
    "category": "arte",
    "gear": []
  },
  {
    "id": "hob_803",
    "label": "coleccionar upcycling",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_804",
    "label": "coleccionar reparar bicis",
    "category": "deporte",
    "gear": [
      "bicicleta"
    ]
  },
  {
    "id": "hob_805",
    "label": "coleccionar mecánica básica",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_806",
    "label": "coleccionar carpintería",
    "category": "ocio",
    "gear": [
      "material de pintura"
    ]
  },
  {
    "id": "hob_807",
    "label": "coleccionar torno de madera",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_808",
    "label": "coleccionar pirografía",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_809",
    "label": "coleccionar vidrio fundido",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_810",
    "label": "coleccionar mosaicos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_811",
    "label": "coleccionar graffiti legal",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_812",
    "label": "coleccionar parkour ligero",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_813",
    "label": "coleccionar danza contemporánea",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_814",
    "label": "coleccionar salsa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_815",
    "label": "coleccionar bachata",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_816",
    "label": "coleccionar tango",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_817",
    "label": "coleccionar swing",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_818",
    "label": "coleccionar k-pop dance",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_819",
    "label": "coleccionar ballet amateur",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_820",
    "label": "coleccionar capoeira",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_821",
    "label": "improvisar ajedrez",
    "category": "ocio",
    "gear": [
      "ajedrez",
      "tablero de ajedrez"
    ]
  },
  {
    "id": "hob_822",
    "label": "improvisar guitarra acústica",
    "category": "musica",
    "gear": [
      "guitarra"
    ]
  },
  {
    "id": "hob_823",
    "label": "improvisar guitarra eléctrica",
    "category": "musica",
    "gear": [
      "guitarra"
    ]
  },
  {
    "id": "hob_824",
    "label": "improvisar ukelele",
    "category": "musica",
    "gear": []
  },
  {
    "id": "hob_825",
    "label": "improvisar piano",
    "category": "musica",
    "gear": []
  },
  {
    "id": "hob_826",
    "label": "improvisar batería",
    "category": "musica",
    "gear": []
  },
  {
    "id": "hob_827",
    "label": "improvisar violín",
    "category": "musica",
    "gear": []
  },
  {
    "id": "hob_828",
    "label": "improvisar flauta",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_829",
    "label": "improvisar armónica",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_830",
    "label": "improvisar canto",
    "category": "musica",
    "gear": []
  },
  {
    "id": "hob_831",
    "label": "improvisar dibujo a lápiz",
    "category": "arte",
    "gear": [
      "pintura",
      "material de pintura"
    ]
  },
  {
    "id": "hob_832",
    "label": "improvisar acuarela",
    "category": "ocio",
    "gear": [
      "pintura",
      "material de pintura"
    ]
  },
  {
    "id": "hob_833",
    "label": "improvisar óleo",
    "category": "arte",
    "gear": [
      "pintura",
      "material de pintura"
    ]
  },
  {
    "id": "hob_834",
    "label": "improvisar acrílico",
    "category": "ocio",
    "gear": [
      "pintura"
    ]
  },
  {
    "id": "hob_835",
    "label": "improvisar cómic",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_836",
    "label": "improvisar caligrafía",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_837",
    "label": "improvisar lettering",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_838",
    "label": "improvisar origami",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_839",
    "label": "improvisar cerámica",
    "category": "arte",
    "gear": []
  },
  {
    "id": "hob_840",
    "label": "improvisar costura",
    "category": "arte",
    "gear": []
  },
  {
    "id": "hob_841",
    "label": "improvisar punto de cruz",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_842",
    "label": "improvisar ganchillo",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_843",
    "label": "improvisar punto de media",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_844",
    "label": "improvisar bordado",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_845",
    "label": "improvisar macramé",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_846",
    "label": "improvisar cuero",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_847",
    "label": "improvisar joyería",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_848",
    "label": "improvisar modelismo",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_849",
    "label": "improvisar maquetas",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_850",
    "label": "improvisar puzles",
    "category": "ocio",
    "gear": [
      "puzles"
    ]
  },
  {
    "id": "hob_851",
    "label": "improvisar puzzles 3D",
    "category": "ocio",
    "gear": [
      "puzles"
    ]
  },
  {
    "id": "hob_852",
    "label": "improvisar legos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_853",
    "label": "improvisar drones",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_854",
    "label": "improvisar astronomía",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_855",
    "label": "improvisar birdwatching",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_856",
    "label": "improvisar setas",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_857",
    "label": "improvisar plantas de interior",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_858",
    "label": "improvisar huerto urbano",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_859",
    "label": "improvisar bonsái",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_860",
    "label": "improvisar compostaje",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_861",
    "label": "improvisar cocina vegana",
    "category": "gastronomia",
    "gear": [
      "cocina"
    ]
  },
  {
    "id": "hob_862",
    "label": "improvisar repostería",
    "category": "ocio",
    "gear": [
      "cocina"
    ]
  },
  {
    "id": "hob_863",
    "label": "improvisar panadería",
    "category": "gastronomia",
    "gear": [
      "cocina"
    ]
  },
  {
    "id": "hob_864",
    "label": "improvisar cafés de especialidad",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_865",
    "label": "improvisar cata de tés",
    "category": "gastronomia",
    "gear": []
  },
  {
    "id": "hob_866",
    "label": "improvisar cata de vinos",
    "category": "gastronomia",
    "gear": []
  },
  {
    "id": "hob_867",
    "label": "improvisar cerveza artesanal",
    "category": "gastronomia",
    "gear": []
  },
  {
    "id": "hob_868",
    "label": "improvisar cócteles",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_869",
    "label": "improvisar cocina fermentada",
    "category": "gastronomia",
    "gear": [
      "cocina"
    ]
  },
  {
    "id": "hob_870",
    "label": "improvisar running",
    "category": "deporte",
    "gear": [
      "running",
      "zapatillas de correr"
    ]
  },
  {
    "id": "hob_871",
    "label": "improvisar trail",
    "category": "ocio",
    "gear": [
      "running",
      "zapatillas de correr"
    ]
  },
  {
    "id": "hob_872",
    "label": "improvisar ciclismo de carretera",
    "category": "ocio",
    "gear": [
      "bicicleta"
    ]
  },
  {
    "id": "hob_873",
    "label": "improvisar mtb",
    "category": "ocio",
    "gear": [
      "bicicleta"
    ]
  },
  {
    "id": "hob_874",
    "label": "improvisar bici urbana",
    "category": "deporte",
    "gear": [
      "bicicleta"
    ]
  },
  {
    "id": "hob_875",
    "label": "improvisar patinaje",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_876",
    "label": "improvisar skate",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_877",
    "label": "improvisar surf",
    "category": "deporte",
    "gear": []
  },
  {
    "id": "hob_878",
    "label": "improvisar bodyboard",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_879",
    "label": "improvisar paddle surf",
    "category": "deporte",
    "gear": [
      "kayak"
    ]
  },
  {
    "id": "hob_880",
    "label": "improvisar kayak",
    "category": "ocio",
    "gear": [
      "kayak"
    ]
  },
  {
    "id": "hob_881",
    "label": "improvisar remo",
    "category": "ocio",
    "gear": [
      "kayak"
    ]
  },
  {
    "id": "hob_882",
    "label": "improvisar natación",
    "category": "deporte",
    "gear": []
  },
  {
    "id": "hob_883",
    "label": "improvisar buceo",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_884",
    "label": "improvisar escalada indoor",
    "category": "deporte",
    "gear": []
  },
  {
    "id": "hob_885",
    "label": "improvisar boulder",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_886",
    "label": "improvisar senderismo",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_887",
    "label": "improvisar trekking",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_888",
    "label": "improvisar acampada",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_889",
    "label": "improvisar orientación",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_890",
    "label": "improvisar geocaching",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_891",
    "label": "improvisar yoga",
    "category": "deporte",
    "gear": []
  },
  {
    "id": "hob_892",
    "label": "improvisar pilates",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_893",
    "label": "improvisar meditación",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_894",
    "label": "improvisar tai chi",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_895",
    "label": "improvisar calistenia",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_896",
    "label": "improvisar crossfit",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_897",
    "label": "improvisar boxeo",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_898",
    "label": "improvisar artes marciales",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_899",
    "label": "improvisar esgrima",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_900",
    "label": "improvisar tiro con arco",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_901",
    "label": "improvisar tenis",
    "category": "deporte",
    "gear": []
  },
  {
    "id": "hob_902",
    "label": "improvisar pádel",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_903",
    "label": "improvisar bádminton",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_904",
    "label": "improvisar ping-pong",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_905",
    "label": "improvisar fútbol",
    "category": "deporte",
    "gear": []
  },
  {
    "id": "hob_906",
    "label": "improvisar baloncesto",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_907",
    "label": "improvisar voleibol",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_908",
    "label": "improvisar ultimate",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_909",
    "label": "improvisar disfraces",
    "category": "ocio",
    "gear": [
      "disfraz"
    ]
  },
  {
    "id": "hob_910",
    "label": "improvisar cosplay",
    "category": "ocio",
    "gear": [
      "disfraz"
    ]
  },
  {
    "id": "hob_911",
    "label": "improvisar teatro amateur",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_912",
    "label": "improvisar improvisación teatral",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_913",
    "label": "improvisar stand up",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_914",
    "label": "improvisar magia",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_915",
    "label": "improvisar malabares",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_916",
    "label": "improvisar cuerda floja",
    "category": "ocio",
    "gear": [
      "cuerda floja",
      "cuerda / slackline"
    ]
  },
  {
    "id": "hob_917",
    "label": "improvisar slackline",
    "category": "ocio",
    "gear": [
      "cuerda floja",
      "cuerda / slackline"
    ]
  },
  {
    "id": "hob_918",
    "label": "improvisar cometas",
    "category": "ocio",
    "gear": [
      "cometa"
    ]
  },
  {
    "id": "hob_919",
    "label": "improvisar aeromodelismo",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_920",
    "label": "improvisar trenes miniatura",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_921",
    "label": "improvisar videojuegos indie",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_922",
    "label": "improvisar videojuegos competitivos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_923",
    "label": "improvisar juegos de mesa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_924",
    "label": "improvisar rol de mesa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_925",
    "label": "improvisar wargames",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_926",
    "label": "improvisar cartas coleccionables",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_927",
    "label": "improvisar lectura de novela",
    "category": "ocio",
    "gear": [
      "libros"
    ]
  },
  {
    "id": "hob_928",
    "label": "improvisar poesía",
    "category": "ocio",
    "gear": [
      "libros"
    ]
  },
  {
    "id": "hob_929",
    "label": "improvisar ensayo",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_930",
    "label": "improvisar escritura creativa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_931",
    "label": "improvisar journaling",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_932",
    "label": "improvisar podcasting",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_933",
    "label": "improvisar radio amateur",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_934",
    "label": "improvisar edición de vídeo",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_935",
    "label": "improvisar stop motion",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_936",
    "label": "improvisar fotografía analógica",
    "category": "arte",
    "gear": [
      "cámara"
    ]
  },
  {
    "id": "hob_937",
    "label": "improvisar revelado",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_938",
    "label": "improvisar street photography",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_939",
    "label": "improvisar arquitectura urbana",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_940",
    "label": "improvisar visitar museos",
    "category": "cultura",
    "gear": []
  },
  {
    "id": "hob_941",
    "label": "improvisar visitar monumentos",
    "category": "cultura",
    "gear": []
  },
  {
    "id": "hob_942",
    "label": "improvisar ver pueblitos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_943",
    "label": "improvisar ver ciudad",
    "category": "cultura",
    "gear": []
  },
  {
    "id": "hob_944",
    "label": "improvisar viajes en tren",
    "category": "cultura",
    "gear": []
  },
  {
    "id": "hob_945",
    "label": "improvisar viajes en furgoneta",
    "category": "cultura",
    "gear": []
  },
  {
    "id": "hob_946",
    "label": "improvisar turismo industrial",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_947",
    "label": "improvisar ruinas",
    "category": "cultura",
    "gear": []
  },
  {
    "id": "hob_948",
    "label": "improvisar cementerios históricos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_949",
    "label": "improvisar mercados",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_950",
    "label": "improvisar librerías de viejo",
    "category": "ocio",
    "gear": [
      "libros"
    ]
  },
  {
    "id": "hob_951",
    "label": "improvisar vinilos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_952",
    "label": "improvisar casetes",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_953",
    "label": "improvisar sellos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_954",
    "label": "improvisar monedas",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_955",
    "label": "improvisar minerales",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_956",
    "label": "improvisar fósiles",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_957",
    "label": "improvisar insectos (entomología amateur)",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_958",
    "label": "improvisar acuariofilia",
    "category": "mascotas",
    "gear": []
  },
  {
    "id": "hob_959",
    "label": "improvisar cuidado de gatos",
    "category": "mascotas",
    "gear": []
  },
  {
    "id": "hob_960",
    "label": "improvisar cuidado de perros",
    "category": "mascotas",
    "gear": []
  },
  {
    "id": "hob_961",
    "label": "improvisar adiestramiento canino",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_962",
    "label": "improvisar agility",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_963",
    "label": "improvisar equitación",
    "category": "mascotas",
    "gear": []
  },
  {
    "id": "hob_964",
    "label": "improvisar voluntariado animal",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_965",
    "label": "improvisar voluntariado social",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_966",
    "label": "improvisar lengua de signos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_967",
    "label": "improvisar idiomas",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_968",
    "label": "improvisar latín",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_969",
    "label": "improvisar esperanto",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_970",
    "label": "improvisar ajedrez por correspondencia",
    "category": "ocio",
    "gear": [
      "ajedrez",
      "tablero de ajedrez"
    ]
  },
  {
    "id": "hob_971",
    "label": "improvisar go",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_972",
    "label": "improvisar shogi",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_973",
    "label": "improvisar bridge",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_974",
    "label": "improvisar mahjong",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_975",
    "label": "improvisar sudokus",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_976",
    "label": "improvisar crucigramas",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_977",
    "label": "improvisar escape rooms caseros",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_978",
    "label": "improvisar robótica",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_979",
    "label": "improvisar arduino",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_980",
    "label": "improvisar impresión 3D",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_981",
    "label": "improvisar reparar electrónicos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_982",
    "label": "improvisar linux",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_983",
    "label": "improvisar ciberseguridad ética amateur",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_984",
    "label": "improvisar mapas OSM",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_985",
    "label": "improvisar hammocking",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_986",
    "label": "improvisar sauna",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_987",
    "label": "improvisar baños fríos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_988",
    "label": "improvisar respiración",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_989",
    "label": "improvisar astrología cultural",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_990",
    "label": "improvisar tarot artístico",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_991",
    "label": "improvisar perfumería artesanal",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_992",
    "label": "improvisar jabones",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_993",
    "label": "improvisar velas",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_994",
    "label": "improvisar incienso",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_995",
    "label": "improvisar tes de hierbas",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_996",
    "label": "improvisar foraging urbano",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_997",
    "label": "improvisar urban sketching",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_998",
    "label": "improvisar zines",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_999",
    "label": "improvisar fanzines",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1000",
    "label": "improvisar serigrafía",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1001",
    "label": "improvisar linograbado",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1002",
    "label": "improvisar tipografía",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1003",
    "label": "improvisar diseño de interiores",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1004",
    "label": "improvisar feng shui amateur",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1005",
    "label": "improvisar organización del hogar",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1006",
    "label": "improvisar zero waste",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1007",
    "label": "improvisar costura de arreglos",
    "category": "arte",
    "gear": []
  },
  {
    "id": "hob_1008",
    "label": "improvisar upcycling",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1009",
    "label": "improvisar reparar bicis",
    "category": "deporte",
    "gear": [
      "bicicleta"
    ]
  },
  {
    "id": "hob_1010",
    "label": "improvisar mecánica básica",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1011",
    "label": "improvisar carpintería",
    "category": "ocio",
    "gear": [
      "material de pintura"
    ]
  },
  {
    "id": "hob_1012",
    "label": "improvisar torno de madera",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1013",
    "label": "improvisar pirografía",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1014",
    "label": "improvisar vidrio fundido",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1015",
    "label": "improvisar mosaicos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1016",
    "label": "improvisar graffiti legal",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1017",
    "label": "improvisar parkour ligero",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1018",
    "label": "improvisar danza contemporánea",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1019",
    "label": "improvisar salsa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1020",
    "label": "improvisar bachata",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1021",
    "label": "improvisar tango",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1022",
    "label": "improvisar swing",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1023",
    "label": "improvisar k-pop dance",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1024",
    "label": "improvisar ballet amateur",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1025",
    "label": "improvisar capoeira",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1026",
    "label": "explorar ajedrez",
    "category": "ocio",
    "gear": [
      "ajedrez",
      "tablero de ajedrez"
    ]
  },
  {
    "id": "hob_1027",
    "label": "explorar guitarra acústica",
    "category": "musica",
    "gear": [
      "guitarra"
    ]
  },
  {
    "id": "hob_1028",
    "label": "explorar guitarra eléctrica",
    "category": "musica",
    "gear": [
      "guitarra"
    ]
  },
  {
    "id": "hob_1029",
    "label": "explorar ukelele",
    "category": "musica",
    "gear": []
  },
  {
    "id": "hob_1030",
    "label": "explorar piano",
    "category": "musica",
    "gear": []
  },
  {
    "id": "hob_1031",
    "label": "explorar batería",
    "category": "musica",
    "gear": []
  },
  {
    "id": "hob_1032",
    "label": "explorar violín",
    "category": "musica",
    "gear": []
  },
  {
    "id": "hob_1033",
    "label": "explorar flauta",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1034",
    "label": "explorar armónica",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1035",
    "label": "explorar canto",
    "category": "musica",
    "gear": []
  },
  {
    "id": "hob_1036",
    "label": "explorar dibujo a lápiz",
    "category": "arte",
    "gear": [
      "pintura",
      "material de pintura"
    ]
  },
  {
    "id": "hob_1037",
    "label": "explorar acuarela",
    "category": "ocio",
    "gear": [
      "pintura",
      "material de pintura"
    ]
  },
  {
    "id": "hob_1038",
    "label": "explorar óleo",
    "category": "arte",
    "gear": [
      "pintura",
      "material de pintura"
    ]
  },
  {
    "id": "hob_1039",
    "label": "explorar acrílico",
    "category": "ocio",
    "gear": [
      "pintura"
    ]
  },
  {
    "id": "hob_1040",
    "label": "explorar cómic",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1041",
    "label": "explorar caligrafía",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1042",
    "label": "explorar lettering",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1043",
    "label": "explorar origami",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1044",
    "label": "explorar cerámica",
    "category": "arte",
    "gear": []
  },
  {
    "id": "hob_1045",
    "label": "explorar costura",
    "category": "arte",
    "gear": []
  },
  {
    "id": "hob_1046",
    "label": "explorar punto de cruz",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1047",
    "label": "explorar ganchillo",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1048",
    "label": "explorar punto de media",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1049",
    "label": "explorar bordado",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1050",
    "label": "explorar macramé",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1051",
    "label": "explorar cuero",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1052",
    "label": "explorar joyería",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1053",
    "label": "explorar modelismo",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1054",
    "label": "explorar maquetas",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1055",
    "label": "explorar puzles",
    "category": "ocio",
    "gear": [
      "puzles"
    ]
  },
  {
    "id": "hob_1056",
    "label": "explorar puzzles 3D",
    "category": "ocio",
    "gear": [
      "puzles"
    ]
  },
  {
    "id": "hob_1057",
    "label": "explorar legos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1058",
    "label": "explorar drones",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1059",
    "label": "explorar astronomía",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1060",
    "label": "explorar birdwatching",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1061",
    "label": "explorar setas",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1062",
    "label": "explorar plantas de interior",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1063",
    "label": "explorar huerto urbano",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1064",
    "label": "explorar bonsái",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1065",
    "label": "explorar compostaje",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1066",
    "label": "explorar cocina vegana",
    "category": "gastronomia",
    "gear": [
      "cocina"
    ]
  },
  {
    "id": "hob_1067",
    "label": "explorar repostería",
    "category": "ocio",
    "gear": [
      "cocina"
    ]
  },
  {
    "id": "hob_1068",
    "label": "explorar panadería",
    "category": "gastronomia",
    "gear": [
      "cocina"
    ]
  },
  {
    "id": "hob_1069",
    "label": "explorar cafés de especialidad",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1070",
    "label": "explorar cata de tés",
    "category": "gastronomia",
    "gear": []
  },
  {
    "id": "hob_1071",
    "label": "explorar cata de vinos",
    "category": "gastronomia",
    "gear": []
  },
  {
    "id": "hob_1072",
    "label": "explorar cerveza artesanal",
    "category": "gastronomia",
    "gear": []
  },
  {
    "id": "hob_1073",
    "label": "explorar cócteles",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1074",
    "label": "explorar cocina fermentada",
    "category": "gastronomia",
    "gear": [
      "cocina"
    ]
  },
  {
    "id": "hob_1075",
    "label": "explorar running",
    "category": "deporte",
    "gear": [
      "running",
      "zapatillas de correr"
    ]
  },
  {
    "id": "hob_1076",
    "label": "explorar trail",
    "category": "ocio",
    "gear": [
      "running",
      "zapatillas de correr"
    ]
  },
  {
    "id": "hob_1077",
    "label": "explorar ciclismo de carretera",
    "category": "ocio",
    "gear": [
      "bicicleta"
    ]
  },
  {
    "id": "hob_1078",
    "label": "explorar mtb",
    "category": "ocio",
    "gear": [
      "bicicleta"
    ]
  },
  {
    "id": "hob_1079",
    "label": "explorar bici urbana",
    "category": "deporte",
    "gear": [
      "bicicleta"
    ]
  },
  {
    "id": "hob_1080",
    "label": "explorar patinaje",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1081",
    "label": "explorar skate",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1082",
    "label": "explorar surf",
    "category": "deporte",
    "gear": []
  },
  {
    "id": "hob_1083",
    "label": "explorar bodyboard",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1084",
    "label": "explorar paddle surf",
    "category": "deporte",
    "gear": [
      "kayak"
    ]
  },
  {
    "id": "hob_1085",
    "label": "explorar kayak",
    "category": "ocio",
    "gear": [
      "kayak"
    ]
  },
  {
    "id": "hob_1086",
    "label": "explorar remo",
    "category": "ocio",
    "gear": [
      "kayak"
    ]
  },
  {
    "id": "hob_1087",
    "label": "explorar natación",
    "category": "deporte",
    "gear": []
  },
  {
    "id": "hob_1088",
    "label": "explorar buceo",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1089",
    "label": "explorar escalada indoor",
    "category": "deporte",
    "gear": []
  },
  {
    "id": "hob_1090",
    "label": "explorar boulder",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1091",
    "label": "explorar senderismo",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1092",
    "label": "explorar trekking",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1093",
    "label": "explorar acampada",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1094",
    "label": "explorar orientación",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1095",
    "label": "explorar geocaching",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1096",
    "label": "explorar yoga",
    "category": "deporte",
    "gear": []
  },
  {
    "id": "hob_1097",
    "label": "explorar pilates",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1098",
    "label": "explorar meditación",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1099",
    "label": "explorar tai chi",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1100",
    "label": "explorar calistenia",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1101",
    "label": "explorar crossfit",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1102",
    "label": "explorar boxeo",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1103",
    "label": "explorar artes marciales",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1104",
    "label": "explorar esgrima",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1105",
    "label": "explorar tiro con arco",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1106",
    "label": "explorar tenis",
    "category": "deporte",
    "gear": []
  },
  {
    "id": "hob_1107",
    "label": "explorar pádel",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1108",
    "label": "explorar bádminton",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1109",
    "label": "explorar ping-pong",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1110",
    "label": "explorar fútbol",
    "category": "deporte",
    "gear": []
  },
  {
    "id": "hob_1111",
    "label": "explorar baloncesto",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1112",
    "label": "explorar voleibol",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1113",
    "label": "explorar ultimate",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1114",
    "label": "explorar disfraces",
    "category": "ocio",
    "gear": [
      "disfraz"
    ]
  },
  {
    "id": "hob_1115",
    "label": "explorar cosplay",
    "category": "ocio",
    "gear": [
      "disfraz"
    ]
  },
  {
    "id": "hob_1116",
    "label": "explorar teatro amateur",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1117",
    "label": "explorar improvisación teatral",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1118",
    "label": "explorar stand up",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1119",
    "label": "explorar magia",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1120",
    "label": "explorar malabares",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1121",
    "label": "explorar cuerda floja",
    "category": "ocio",
    "gear": [
      "cuerda floja",
      "cuerda / slackline"
    ]
  },
  {
    "id": "hob_1122",
    "label": "explorar slackline",
    "category": "ocio",
    "gear": [
      "cuerda floja",
      "cuerda / slackline"
    ]
  },
  {
    "id": "hob_1123",
    "label": "explorar cometas",
    "category": "ocio",
    "gear": [
      "cometa"
    ]
  },
  {
    "id": "hob_1124",
    "label": "explorar aeromodelismo",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1125",
    "label": "explorar trenes miniatura",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1126",
    "label": "explorar videojuegos indie",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1127",
    "label": "explorar videojuegos competitivos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1128",
    "label": "explorar juegos de mesa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1129",
    "label": "explorar rol de mesa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1130",
    "label": "explorar wargames",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1131",
    "label": "explorar cartas coleccionables",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1132",
    "label": "explorar lectura de novela",
    "category": "ocio",
    "gear": [
      "libros"
    ]
  },
  {
    "id": "hob_1133",
    "label": "explorar poesía",
    "category": "ocio",
    "gear": [
      "libros"
    ]
  },
  {
    "id": "hob_1134",
    "label": "explorar ensayo",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1135",
    "label": "explorar escritura creativa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1136",
    "label": "explorar journaling",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1137",
    "label": "explorar podcasting",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1138",
    "label": "explorar radio amateur",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1139",
    "label": "explorar edición de vídeo",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1140",
    "label": "explorar stop motion",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1141",
    "label": "explorar fotografía analógica",
    "category": "arte",
    "gear": [
      "cámara"
    ]
  },
  {
    "id": "hob_1142",
    "label": "explorar revelado",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1143",
    "label": "explorar street photography",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1144",
    "label": "explorar arquitectura urbana",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1145",
    "label": "explorar visitar museos",
    "category": "cultura",
    "gear": []
  },
  {
    "id": "hob_1146",
    "label": "explorar visitar monumentos",
    "category": "cultura",
    "gear": []
  },
  {
    "id": "hob_1147",
    "label": "explorar ver pueblitos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1148",
    "label": "explorar ver ciudad",
    "category": "cultura",
    "gear": []
  },
  {
    "id": "hob_1149",
    "label": "explorar viajes en tren",
    "category": "cultura",
    "gear": []
  },
  {
    "id": "hob_1150",
    "label": "explorar viajes en furgoneta",
    "category": "cultura",
    "gear": []
  },
  {
    "id": "hob_1151",
    "label": "explorar turismo industrial",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1152",
    "label": "explorar ruinas",
    "category": "cultura",
    "gear": []
  },
  {
    "id": "hob_1153",
    "label": "explorar cementerios históricos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1154",
    "label": "explorar mercados",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1155",
    "label": "explorar librerías de viejo",
    "category": "ocio",
    "gear": [
      "libros"
    ]
  },
  {
    "id": "hob_1156",
    "label": "explorar vinilos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1157",
    "label": "explorar casetes",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1158",
    "label": "explorar sellos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1159",
    "label": "explorar monedas",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1160",
    "label": "explorar minerales",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1161",
    "label": "explorar fósiles",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1162",
    "label": "explorar insectos (entomología amateur)",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1163",
    "label": "explorar acuariofilia",
    "category": "mascotas",
    "gear": []
  },
  {
    "id": "hob_1164",
    "label": "explorar cuidado de gatos",
    "category": "mascotas",
    "gear": []
  },
  {
    "id": "hob_1165",
    "label": "explorar cuidado de perros",
    "category": "mascotas",
    "gear": []
  },
  {
    "id": "hob_1166",
    "label": "explorar adiestramiento canino",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1167",
    "label": "explorar agility",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1168",
    "label": "explorar equitación",
    "category": "mascotas",
    "gear": []
  },
  {
    "id": "hob_1169",
    "label": "explorar voluntariado animal",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1170",
    "label": "explorar voluntariado social",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1171",
    "label": "explorar lengua de signos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1172",
    "label": "explorar idiomas",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1173",
    "label": "explorar latín",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1174",
    "label": "explorar esperanto",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1175",
    "label": "explorar ajedrez por correspondencia",
    "category": "ocio",
    "gear": [
      "ajedrez",
      "tablero de ajedrez"
    ]
  },
  {
    "id": "hob_1176",
    "label": "explorar go",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1177",
    "label": "explorar shogi",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1178",
    "label": "explorar bridge",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1179",
    "label": "explorar mahjong",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1180",
    "label": "explorar sudokus",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1181",
    "label": "explorar crucigramas",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1182",
    "label": "explorar escape rooms caseros",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1183",
    "label": "explorar robótica",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1184",
    "label": "explorar arduino",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1185",
    "label": "explorar impresión 3D",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1186",
    "label": "explorar reparar electrónicos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1187",
    "label": "explorar linux",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1188",
    "label": "explorar ciberseguridad ética amateur",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1189",
    "label": "explorar mapas OSM",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1190",
    "label": "explorar hammocking",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1191",
    "label": "explorar sauna",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1192",
    "label": "explorar baños fríos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1193",
    "label": "explorar respiración",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1194",
    "label": "explorar astrología cultural",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1195",
    "label": "explorar tarot artístico",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1196",
    "label": "explorar perfumería artesanal",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1197",
    "label": "explorar jabones",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1198",
    "label": "explorar velas",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1199",
    "label": "explorar incienso",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1200",
    "label": "explorar tes de hierbas",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1201",
    "label": "explorar foraging urbano",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1202",
    "label": "explorar urban sketching",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1203",
    "label": "explorar zines",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1204",
    "label": "explorar fanzines",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1205",
    "label": "explorar serigrafía",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1206",
    "label": "explorar linograbado",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1207",
    "label": "explorar tipografía",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1208",
    "label": "explorar diseño de interiores",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1209",
    "label": "explorar feng shui amateur",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1210",
    "label": "explorar organización del hogar",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1211",
    "label": "explorar zero waste",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1212",
    "label": "explorar costura de arreglos",
    "category": "arte",
    "gear": []
  },
  {
    "id": "hob_1213",
    "label": "explorar upcycling",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1214",
    "label": "explorar reparar bicis",
    "category": "deporte",
    "gear": [
      "bicicleta"
    ]
  },
  {
    "id": "hob_1215",
    "label": "explorar mecánica básica",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1216",
    "label": "explorar carpintería",
    "category": "ocio",
    "gear": [
      "material de pintura"
    ]
  },
  {
    "id": "hob_1217",
    "label": "explorar torno de madera",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1218",
    "label": "explorar pirografía",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1219",
    "label": "explorar vidrio fundido",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1220",
    "label": "explorar mosaicos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1221",
    "label": "explorar graffiti legal",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1222",
    "label": "explorar parkour ligero",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1223",
    "label": "explorar danza contemporánea",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1224",
    "label": "explorar salsa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1225",
    "label": "explorar bachata",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1226",
    "label": "explorar tango",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1227",
    "label": "explorar swing",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1228",
    "label": "explorar k-pop dance",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1229",
    "label": "explorar ballet amateur",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1230",
    "label": "explorar capoeira",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1231",
    "label": "construir ajedrez",
    "category": "ocio",
    "gear": [
      "ajedrez",
      "tablero de ajedrez"
    ]
  },
  {
    "id": "hob_1232",
    "label": "construir guitarra acústica",
    "category": "musica",
    "gear": [
      "guitarra"
    ]
  },
  {
    "id": "hob_1233",
    "label": "construir guitarra eléctrica",
    "category": "musica",
    "gear": [
      "guitarra"
    ]
  },
  {
    "id": "hob_1234",
    "label": "construir ukelele",
    "category": "musica",
    "gear": []
  },
  {
    "id": "hob_1235",
    "label": "construir piano",
    "category": "musica",
    "gear": []
  },
  {
    "id": "hob_1236",
    "label": "construir batería",
    "category": "musica",
    "gear": []
  },
  {
    "id": "hob_1237",
    "label": "construir violín",
    "category": "musica",
    "gear": []
  },
  {
    "id": "hob_1238",
    "label": "construir flauta",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1239",
    "label": "construir armónica",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1240",
    "label": "construir canto",
    "category": "musica",
    "gear": []
  },
  {
    "id": "hob_1241",
    "label": "construir dibujo a lápiz",
    "category": "arte",
    "gear": [
      "pintura",
      "material de pintura"
    ]
  },
  {
    "id": "hob_1242",
    "label": "construir acuarela",
    "category": "ocio",
    "gear": [
      "pintura",
      "material de pintura"
    ]
  },
  {
    "id": "hob_1243",
    "label": "construir óleo",
    "category": "arte",
    "gear": [
      "pintura",
      "material de pintura"
    ]
  },
  {
    "id": "hob_1244",
    "label": "construir acrílico",
    "category": "ocio",
    "gear": [
      "pintura"
    ]
  },
  {
    "id": "hob_1245",
    "label": "construir cómic",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1246",
    "label": "construir caligrafía",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1247",
    "label": "construir lettering",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1248",
    "label": "construir origami",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1249",
    "label": "construir cerámica",
    "category": "arte",
    "gear": []
  },
  {
    "id": "hob_1250",
    "label": "construir costura",
    "category": "arte",
    "gear": []
  },
  {
    "id": "hob_1251",
    "label": "construir punto de cruz",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1252",
    "label": "construir ganchillo",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1253",
    "label": "construir punto de media",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1254",
    "label": "construir bordado",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1255",
    "label": "construir macramé",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1256",
    "label": "construir cuero",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1257",
    "label": "construir joyería",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1258",
    "label": "construir modelismo",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1259",
    "label": "construir maquetas",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1260",
    "label": "construir puzles",
    "category": "ocio",
    "gear": [
      "puzles"
    ]
  },
  {
    "id": "hob_1261",
    "label": "construir puzzles 3D",
    "category": "ocio",
    "gear": [
      "puzles"
    ]
  },
  {
    "id": "hob_1262",
    "label": "construir legos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1263",
    "label": "construir drones",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1264",
    "label": "construir astronomía",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1265",
    "label": "construir birdwatching",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1266",
    "label": "construir setas",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1267",
    "label": "construir plantas de interior",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1268",
    "label": "construir huerto urbano",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1269",
    "label": "construir bonsái",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1270",
    "label": "construir compostaje",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1271",
    "label": "construir cocina vegana",
    "category": "gastronomia",
    "gear": [
      "cocina"
    ]
  },
  {
    "id": "hob_1272",
    "label": "construir repostería",
    "category": "ocio",
    "gear": [
      "cocina"
    ]
  },
  {
    "id": "hob_1273",
    "label": "construir panadería",
    "category": "gastronomia",
    "gear": [
      "cocina"
    ]
  },
  {
    "id": "hob_1274",
    "label": "construir cafés de especialidad",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1275",
    "label": "construir cata de tés",
    "category": "gastronomia",
    "gear": []
  },
  {
    "id": "hob_1276",
    "label": "construir cata de vinos",
    "category": "gastronomia",
    "gear": []
  },
  {
    "id": "hob_1277",
    "label": "construir cerveza artesanal",
    "category": "gastronomia",
    "gear": []
  },
  {
    "id": "hob_1278",
    "label": "construir cócteles",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1279",
    "label": "construir cocina fermentada",
    "category": "gastronomia",
    "gear": [
      "cocina"
    ]
  },
  {
    "id": "hob_1280",
    "label": "construir running",
    "category": "deporte",
    "gear": [
      "running",
      "zapatillas de correr"
    ]
  },
  {
    "id": "hob_1281",
    "label": "construir trail",
    "category": "ocio",
    "gear": [
      "running",
      "zapatillas de correr"
    ]
  },
  {
    "id": "hob_1282",
    "label": "construir ciclismo de carretera",
    "category": "ocio",
    "gear": [
      "bicicleta"
    ]
  },
  {
    "id": "hob_1283",
    "label": "construir mtb",
    "category": "ocio",
    "gear": [
      "bicicleta"
    ]
  },
  {
    "id": "hob_1284",
    "label": "construir bici urbana",
    "category": "deporte",
    "gear": [
      "bicicleta"
    ]
  },
  {
    "id": "hob_1285",
    "label": "construir patinaje",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1286",
    "label": "construir skate",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1287",
    "label": "construir surf",
    "category": "deporte",
    "gear": []
  },
  {
    "id": "hob_1288",
    "label": "construir bodyboard",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1289",
    "label": "construir paddle surf",
    "category": "deporte",
    "gear": [
      "kayak"
    ]
  },
  {
    "id": "hob_1290",
    "label": "construir kayak",
    "category": "ocio",
    "gear": [
      "kayak"
    ]
  },
  {
    "id": "hob_1291",
    "label": "construir remo",
    "category": "ocio",
    "gear": [
      "kayak"
    ]
  },
  {
    "id": "hob_1292",
    "label": "construir natación",
    "category": "deporte",
    "gear": []
  },
  {
    "id": "hob_1293",
    "label": "construir buceo",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1294",
    "label": "construir escalada indoor",
    "category": "deporte",
    "gear": []
  },
  {
    "id": "hob_1295",
    "label": "construir boulder",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1296",
    "label": "construir senderismo",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1297",
    "label": "construir trekking",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1298",
    "label": "construir acampada",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1299",
    "label": "construir orientación",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1300",
    "label": "construir geocaching",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1301",
    "label": "construir yoga",
    "category": "deporte",
    "gear": []
  },
  {
    "id": "hob_1302",
    "label": "construir pilates",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1303",
    "label": "construir meditación",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1304",
    "label": "construir tai chi",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1305",
    "label": "construir calistenia",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1306",
    "label": "construir crossfit",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1307",
    "label": "construir boxeo",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1308",
    "label": "construir artes marciales",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1309",
    "label": "construir esgrima",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1310",
    "label": "construir tiro con arco",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1311",
    "label": "construir tenis",
    "category": "deporte",
    "gear": []
  },
  {
    "id": "hob_1312",
    "label": "construir pádel",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1313",
    "label": "construir bádminton",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1314",
    "label": "construir ping-pong",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1315",
    "label": "construir fútbol",
    "category": "deporte",
    "gear": []
  },
  {
    "id": "hob_1316",
    "label": "construir baloncesto",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1317",
    "label": "construir voleibol",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1318",
    "label": "construir ultimate",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1319",
    "label": "construir disfraces",
    "category": "ocio",
    "gear": [
      "disfraz"
    ]
  },
  {
    "id": "hob_1320",
    "label": "construir cosplay",
    "category": "ocio",
    "gear": [
      "disfraz"
    ]
  },
  {
    "id": "hob_1321",
    "label": "construir teatro amateur",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1322",
    "label": "construir improvisación teatral",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1323",
    "label": "construir stand up",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1324",
    "label": "construir magia",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1325",
    "label": "construir malabares",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1326",
    "label": "construir cuerda floja",
    "category": "ocio",
    "gear": [
      "cuerda floja",
      "cuerda / slackline"
    ]
  },
  {
    "id": "hob_1327",
    "label": "construir slackline",
    "category": "ocio",
    "gear": [
      "cuerda floja",
      "cuerda / slackline"
    ]
  },
  {
    "id": "hob_1328",
    "label": "construir cometas",
    "category": "ocio",
    "gear": [
      "cometa"
    ]
  },
  {
    "id": "hob_1329",
    "label": "construir aeromodelismo",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1330",
    "label": "construir trenes miniatura",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1331",
    "label": "construir videojuegos indie",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1332",
    "label": "construir videojuegos competitivos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1333",
    "label": "construir juegos de mesa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1334",
    "label": "construir rol de mesa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1335",
    "label": "construir wargames",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1336",
    "label": "construir cartas coleccionables",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1337",
    "label": "construir lectura de novela",
    "category": "ocio",
    "gear": [
      "libros"
    ]
  },
  {
    "id": "hob_1338",
    "label": "construir poesía",
    "category": "ocio",
    "gear": [
      "libros"
    ]
  },
  {
    "id": "hob_1339",
    "label": "construir ensayo",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1340",
    "label": "construir escritura creativa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1341",
    "label": "construir journaling",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1342",
    "label": "construir podcasting",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1343",
    "label": "construir radio amateur",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1344",
    "label": "construir edición de vídeo",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1345",
    "label": "construir stop motion",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1346",
    "label": "construir fotografía analógica",
    "category": "arte",
    "gear": [
      "cámara"
    ]
  },
  {
    "id": "hob_1347",
    "label": "construir revelado",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1348",
    "label": "construir street photography",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1349",
    "label": "construir arquitectura urbana",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1350",
    "label": "construir visitar museos",
    "category": "cultura",
    "gear": []
  },
  {
    "id": "hob_1351",
    "label": "construir visitar monumentos",
    "category": "cultura",
    "gear": []
  },
  {
    "id": "hob_1352",
    "label": "construir ver pueblitos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1353",
    "label": "construir ver ciudad",
    "category": "cultura",
    "gear": []
  },
  {
    "id": "hob_1354",
    "label": "construir viajes en tren",
    "category": "cultura",
    "gear": []
  },
  {
    "id": "hob_1355",
    "label": "construir viajes en furgoneta",
    "category": "cultura",
    "gear": []
  },
  {
    "id": "hob_1356",
    "label": "construir turismo industrial",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1357",
    "label": "construir ruinas",
    "category": "cultura",
    "gear": []
  },
  {
    "id": "hob_1358",
    "label": "construir cementerios históricos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1359",
    "label": "construir mercados",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1360",
    "label": "construir librerías de viejo",
    "category": "ocio",
    "gear": [
      "libros"
    ]
  },
  {
    "id": "hob_1361",
    "label": "construir vinilos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1362",
    "label": "construir casetes",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1363",
    "label": "construir sellos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1364",
    "label": "construir monedas",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1365",
    "label": "construir minerales",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1366",
    "label": "construir fósiles",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1367",
    "label": "construir insectos (entomología amateur)",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1368",
    "label": "construir acuariofilia",
    "category": "mascotas",
    "gear": []
  },
  {
    "id": "hob_1369",
    "label": "construir cuidado de gatos",
    "category": "mascotas",
    "gear": []
  },
  {
    "id": "hob_1370",
    "label": "construir cuidado de perros",
    "category": "mascotas",
    "gear": []
  },
  {
    "id": "hob_1371",
    "label": "construir adiestramiento canino",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1372",
    "label": "construir agility",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1373",
    "label": "construir equitación",
    "category": "mascotas",
    "gear": []
  },
  {
    "id": "hob_1374",
    "label": "construir voluntariado animal",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1375",
    "label": "construir voluntariado social",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1376",
    "label": "construir lengua de signos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1377",
    "label": "construir idiomas",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1378",
    "label": "construir latín",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1379",
    "label": "construir esperanto",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1380",
    "label": "construir ajedrez por correspondencia",
    "category": "ocio",
    "gear": [
      "ajedrez",
      "tablero de ajedrez"
    ]
  },
  {
    "id": "hob_1381",
    "label": "construir go",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1382",
    "label": "construir shogi",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1383",
    "label": "construir bridge",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1384",
    "label": "construir mahjong",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1385",
    "label": "construir sudokus",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1386",
    "label": "construir crucigramas",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1387",
    "label": "construir escape rooms caseros",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1388",
    "label": "construir robótica",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1389",
    "label": "construir arduino",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1390",
    "label": "construir impresión 3D",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1391",
    "label": "construir reparar electrónicos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1392",
    "label": "construir linux",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1393",
    "label": "construir ciberseguridad ética amateur",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1394",
    "label": "construir mapas OSM",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1395",
    "label": "construir hammocking",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1396",
    "label": "construir sauna",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1397",
    "label": "construir baños fríos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1398",
    "label": "construir respiración",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1399",
    "label": "construir astrología cultural",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1400",
    "label": "construir tarot artístico",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1401",
    "label": "construir perfumería artesanal",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1402",
    "label": "construir jabones",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1403",
    "label": "construir velas",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1404",
    "label": "construir incienso",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1405",
    "label": "construir tes de hierbas",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1406",
    "label": "construir foraging urbano",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1407",
    "label": "construir urban sketching",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1408",
    "label": "construir zines",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1409",
    "label": "construir fanzines",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1410",
    "label": "construir serigrafía",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1411",
    "label": "construir linograbado",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1412",
    "label": "construir tipografía",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1413",
    "label": "construir diseño de interiores",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1414",
    "label": "construir feng shui amateur",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1415",
    "label": "construir organización del hogar",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1416",
    "label": "construir zero waste",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1417",
    "label": "construir costura de arreglos",
    "category": "arte",
    "gear": []
  },
  {
    "id": "hob_1418",
    "label": "construir upcycling",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1419",
    "label": "construir reparar bicis",
    "category": "deporte",
    "gear": [
      "bicicleta"
    ]
  },
  {
    "id": "hob_1420",
    "label": "construir mecánica básica",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1421",
    "label": "construir carpintería",
    "category": "ocio",
    "gear": [
      "material de pintura"
    ]
  },
  {
    "id": "hob_1422",
    "label": "construir torno de madera",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1423",
    "label": "construir pirografía",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1424",
    "label": "construir vidrio fundido",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1425",
    "label": "construir mosaicos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1426",
    "label": "construir graffiti legal",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1427",
    "label": "construir parkour ligero",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1428",
    "label": "construir danza contemporánea",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1429",
    "label": "construir salsa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1430",
    "label": "construir bachata",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1431",
    "label": "construir tango",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1432",
    "label": "construir swing",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1433",
    "label": "construir k-pop dance",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1434",
    "label": "construir ballet amateur",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1435",
    "label": "construir capoeira",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1436",
    "label": "restaurar ajedrez",
    "category": "ocio",
    "gear": [
      "ajedrez",
      "tablero de ajedrez"
    ]
  },
  {
    "id": "hob_1437",
    "label": "restaurar guitarra acústica",
    "category": "musica",
    "gear": [
      "guitarra"
    ]
  },
  {
    "id": "hob_1438",
    "label": "restaurar guitarra eléctrica",
    "category": "musica",
    "gear": [
      "guitarra"
    ]
  },
  {
    "id": "hob_1439",
    "label": "restaurar ukelele",
    "category": "musica",
    "gear": []
  },
  {
    "id": "hob_1440",
    "label": "restaurar piano",
    "category": "musica",
    "gear": []
  },
  {
    "id": "hob_1441",
    "label": "restaurar batería",
    "category": "musica",
    "gear": []
  },
  {
    "id": "hob_1442",
    "label": "restaurar violín",
    "category": "musica",
    "gear": []
  },
  {
    "id": "hob_1443",
    "label": "restaurar flauta",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1444",
    "label": "restaurar armónica",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1445",
    "label": "restaurar canto",
    "category": "musica",
    "gear": []
  },
  {
    "id": "hob_1446",
    "label": "restaurar dibujo a lápiz",
    "category": "arte",
    "gear": [
      "pintura",
      "material de pintura"
    ]
  },
  {
    "id": "hob_1447",
    "label": "restaurar acuarela",
    "category": "ocio",
    "gear": [
      "pintura",
      "material de pintura"
    ]
  },
  {
    "id": "hob_1448",
    "label": "restaurar óleo",
    "category": "arte",
    "gear": [
      "pintura",
      "material de pintura"
    ]
  },
  {
    "id": "hob_1449",
    "label": "restaurar acrílico",
    "category": "ocio",
    "gear": [
      "pintura"
    ]
  },
  {
    "id": "hob_1450",
    "label": "restaurar cómic",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1451",
    "label": "restaurar caligrafía",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1452",
    "label": "restaurar lettering",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1453",
    "label": "restaurar origami",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1454",
    "label": "restaurar cerámica",
    "category": "arte",
    "gear": []
  },
  {
    "id": "hob_1455",
    "label": "restaurar costura",
    "category": "arte",
    "gear": []
  },
  {
    "id": "hob_1456",
    "label": "restaurar punto de cruz",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1457",
    "label": "restaurar ganchillo",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1458",
    "label": "restaurar punto de media",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1459",
    "label": "restaurar bordado",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1460",
    "label": "restaurar macramé",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1461",
    "label": "restaurar cuero",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1462",
    "label": "restaurar joyería",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1463",
    "label": "restaurar modelismo",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1464",
    "label": "restaurar maquetas",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1465",
    "label": "restaurar puzles",
    "category": "ocio",
    "gear": [
      "puzles"
    ]
  },
  {
    "id": "hob_1466",
    "label": "restaurar puzzles 3D",
    "category": "ocio",
    "gear": [
      "puzles"
    ]
  },
  {
    "id": "hob_1467",
    "label": "restaurar legos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1468",
    "label": "restaurar drones",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1469",
    "label": "restaurar astronomía",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1470",
    "label": "restaurar birdwatching",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1471",
    "label": "restaurar setas",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1472",
    "label": "restaurar plantas de interior",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1473",
    "label": "restaurar huerto urbano",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1474",
    "label": "restaurar bonsái",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1475",
    "label": "restaurar compostaje",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1476",
    "label": "restaurar cocina vegana",
    "category": "gastronomia",
    "gear": [
      "cocina"
    ]
  },
  {
    "id": "hob_1477",
    "label": "restaurar repostería",
    "category": "ocio",
    "gear": [
      "cocina"
    ]
  },
  {
    "id": "hob_1478",
    "label": "restaurar panadería",
    "category": "gastronomia",
    "gear": [
      "cocina"
    ]
  },
  {
    "id": "hob_1479",
    "label": "restaurar cafés de especialidad",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1480",
    "label": "restaurar cata de tés",
    "category": "gastronomia",
    "gear": []
  },
  {
    "id": "hob_1481",
    "label": "restaurar cata de vinos",
    "category": "gastronomia",
    "gear": []
  },
  {
    "id": "hob_1482",
    "label": "restaurar cerveza artesanal",
    "category": "gastronomia",
    "gear": []
  },
  {
    "id": "hob_1483",
    "label": "restaurar cócteles",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1484",
    "label": "restaurar cocina fermentada",
    "category": "gastronomia",
    "gear": [
      "cocina"
    ]
  },
  {
    "id": "hob_1485",
    "label": "restaurar running",
    "category": "deporte",
    "gear": [
      "running",
      "zapatillas de correr"
    ]
  },
  {
    "id": "hob_1486",
    "label": "restaurar trail",
    "category": "ocio",
    "gear": [
      "running",
      "zapatillas de correr"
    ]
  },
  {
    "id": "hob_1487",
    "label": "restaurar ciclismo de carretera",
    "category": "ocio",
    "gear": [
      "bicicleta"
    ]
  },
  {
    "id": "hob_1488",
    "label": "restaurar mtb",
    "category": "ocio",
    "gear": [
      "bicicleta"
    ]
  },
  {
    "id": "hob_1489",
    "label": "restaurar bici urbana",
    "category": "deporte",
    "gear": [
      "bicicleta"
    ]
  },
  {
    "id": "hob_1490",
    "label": "restaurar patinaje",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1491",
    "label": "restaurar skate",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1492",
    "label": "restaurar surf",
    "category": "deporte",
    "gear": []
  },
  {
    "id": "hob_1493",
    "label": "restaurar bodyboard",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1494",
    "label": "restaurar paddle surf",
    "category": "deporte",
    "gear": [
      "kayak"
    ]
  },
  {
    "id": "hob_1495",
    "label": "restaurar kayak",
    "category": "ocio",
    "gear": [
      "kayak"
    ]
  },
  {
    "id": "hob_1496",
    "label": "restaurar remo",
    "category": "ocio",
    "gear": [
      "kayak"
    ]
  },
  {
    "id": "hob_1497",
    "label": "restaurar natación",
    "category": "deporte",
    "gear": []
  },
  {
    "id": "hob_1498",
    "label": "restaurar buceo",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1499",
    "label": "restaurar escalada indoor",
    "category": "deporte",
    "gear": []
  },
  {
    "id": "hob_1500",
    "label": "restaurar boulder",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1501",
    "label": "restaurar senderismo",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1502",
    "label": "restaurar trekking",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1503",
    "label": "restaurar acampada",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1504",
    "label": "restaurar orientación",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1505",
    "label": "restaurar geocaching",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1506",
    "label": "restaurar yoga",
    "category": "deporte",
    "gear": []
  },
  {
    "id": "hob_1507",
    "label": "restaurar pilates",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1508",
    "label": "restaurar meditación",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1509",
    "label": "restaurar tai chi",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1510",
    "label": "restaurar calistenia",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1511",
    "label": "restaurar crossfit",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1512",
    "label": "restaurar boxeo",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1513",
    "label": "restaurar artes marciales",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1514",
    "label": "restaurar esgrima",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1515",
    "label": "restaurar tiro con arco",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1516",
    "label": "restaurar tenis",
    "category": "deporte",
    "gear": []
  },
  {
    "id": "hob_1517",
    "label": "restaurar pádel",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1518",
    "label": "restaurar bádminton",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1519",
    "label": "restaurar ping-pong",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1520",
    "label": "restaurar fútbol",
    "category": "deporte",
    "gear": []
  },
  {
    "id": "hob_1521",
    "label": "restaurar baloncesto",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1522",
    "label": "restaurar voleibol",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1523",
    "label": "restaurar ultimate",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1524",
    "label": "restaurar disfraces",
    "category": "ocio",
    "gear": [
      "disfraz"
    ]
  },
  {
    "id": "hob_1525",
    "label": "restaurar cosplay",
    "category": "ocio",
    "gear": [
      "disfraz"
    ]
  },
  {
    "id": "hob_1526",
    "label": "restaurar teatro amateur",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1527",
    "label": "restaurar improvisación teatral",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1528",
    "label": "restaurar stand up",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1529",
    "label": "restaurar magia",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1530",
    "label": "restaurar malabares",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1531",
    "label": "restaurar cuerda floja",
    "category": "ocio",
    "gear": [
      "cuerda floja",
      "cuerda / slackline"
    ]
  },
  {
    "id": "hob_1532",
    "label": "restaurar slackline",
    "category": "ocio",
    "gear": [
      "cuerda floja",
      "cuerda / slackline"
    ]
  },
  {
    "id": "hob_1533",
    "label": "restaurar cometas",
    "category": "ocio",
    "gear": [
      "cometa"
    ]
  },
  {
    "id": "hob_1534",
    "label": "restaurar aeromodelismo",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1535",
    "label": "restaurar trenes miniatura",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1536",
    "label": "restaurar videojuegos indie",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1537",
    "label": "restaurar videojuegos competitivos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1538",
    "label": "restaurar juegos de mesa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1539",
    "label": "restaurar rol de mesa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1540",
    "label": "restaurar wargames",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1541",
    "label": "restaurar cartas coleccionables",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1542",
    "label": "restaurar lectura de novela",
    "category": "ocio",
    "gear": [
      "libros"
    ]
  },
  {
    "id": "hob_1543",
    "label": "restaurar poesía",
    "category": "ocio",
    "gear": [
      "libros"
    ]
  },
  {
    "id": "hob_1544",
    "label": "restaurar ensayo",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1545",
    "label": "restaurar escritura creativa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1546",
    "label": "restaurar journaling",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1547",
    "label": "restaurar podcasting",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1548",
    "label": "restaurar radio amateur",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1549",
    "label": "restaurar edición de vídeo",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1550",
    "label": "restaurar stop motion",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1551",
    "label": "restaurar fotografía analógica",
    "category": "arte",
    "gear": [
      "cámara"
    ]
  },
  {
    "id": "hob_1552",
    "label": "restaurar revelado",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1553",
    "label": "restaurar street photography",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1554",
    "label": "restaurar arquitectura urbana",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1555",
    "label": "restaurar visitar museos",
    "category": "cultura",
    "gear": []
  },
  {
    "id": "hob_1556",
    "label": "restaurar visitar monumentos",
    "category": "cultura",
    "gear": []
  },
  {
    "id": "hob_1557",
    "label": "restaurar ver pueblitos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1558",
    "label": "restaurar ver ciudad",
    "category": "cultura",
    "gear": []
  },
  {
    "id": "hob_1559",
    "label": "restaurar viajes en tren",
    "category": "cultura",
    "gear": []
  },
  {
    "id": "hob_1560",
    "label": "restaurar viajes en furgoneta",
    "category": "cultura",
    "gear": []
  },
  {
    "id": "hob_1561",
    "label": "restaurar turismo industrial",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1562",
    "label": "restaurar ruinas",
    "category": "cultura",
    "gear": []
  },
  {
    "id": "hob_1563",
    "label": "restaurar cementerios históricos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1564",
    "label": "restaurar mercados",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1565",
    "label": "restaurar librerías de viejo",
    "category": "ocio",
    "gear": [
      "libros"
    ]
  },
  {
    "id": "hob_1566",
    "label": "restaurar vinilos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1567",
    "label": "restaurar casetes",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1568",
    "label": "restaurar sellos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1569",
    "label": "restaurar monedas",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1570",
    "label": "restaurar minerales",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1571",
    "label": "restaurar fósiles",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1572",
    "label": "restaurar insectos (entomología amateur)",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1573",
    "label": "restaurar acuariofilia",
    "category": "mascotas",
    "gear": []
  },
  {
    "id": "hob_1574",
    "label": "restaurar cuidado de gatos",
    "category": "mascotas",
    "gear": []
  },
  {
    "id": "hob_1575",
    "label": "restaurar cuidado de perros",
    "category": "mascotas",
    "gear": []
  },
  {
    "id": "hob_1576",
    "label": "restaurar adiestramiento canino",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1577",
    "label": "restaurar agility",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1578",
    "label": "restaurar equitación",
    "category": "mascotas",
    "gear": []
  },
  {
    "id": "hob_1579",
    "label": "restaurar voluntariado animal",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1580",
    "label": "restaurar voluntariado social",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1581",
    "label": "restaurar lengua de signos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1582",
    "label": "restaurar idiomas",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1583",
    "label": "restaurar latín",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1584",
    "label": "restaurar esperanto",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1585",
    "label": "restaurar ajedrez por correspondencia",
    "category": "ocio",
    "gear": [
      "ajedrez",
      "tablero de ajedrez"
    ]
  },
  {
    "id": "hob_1586",
    "label": "restaurar go",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1587",
    "label": "restaurar shogi",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1588",
    "label": "restaurar bridge",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1589",
    "label": "restaurar mahjong",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1590",
    "label": "restaurar sudokus",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1591",
    "label": "restaurar crucigramas",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1592",
    "label": "restaurar escape rooms caseros",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1593",
    "label": "restaurar robótica",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1594",
    "label": "restaurar arduino",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1595",
    "label": "restaurar impresión 3D",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1596",
    "label": "restaurar reparar electrónicos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1597",
    "label": "restaurar linux",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1598",
    "label": "restaurar ciberseguridad ética amateur",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1599",
    "label": "restaurar mapas OSM",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1600",
    "label": "restaurar hammocking",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1601",
    "label": "restaurar sauna",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1602",
    "label": "restaurar baños fríos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1603",
    "label": "restaurar respiración",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1604",
    "label": "restaurar astrología cultural",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1605",
    "label": "restaurar tarot artístico",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1606",
    "label": "restaurar perfumería artesanal",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1607",
    "label": "restaurar jabones",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1608",
    "label": "restaurar velas",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1609",
    "label": "restaurar incienso",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1610",
    "label": "restaurar tes de hierbas",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1611",
    "label": "restaurar foraging urbano",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1612",
    "label": "restaurar urban sketching",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1613",
    "label": "restaurar zines",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1614",
    "label": "restaurar fanzines",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1615",
    "label": "restaurar serigrafía",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1616",
    "label": "restaurar linograbado",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1617",
    "label": "restaurar tipografía",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1618",
    "label": "restaurar diseño de interiores",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1619",
    "label": "restaurar feng shui amateur",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1620",
    "label": "restaurar organización del hogar",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1621",
    "label": "restaurar zero waste",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1622",
    "label": "restaurar costura de arreglos",
    "category": "arte",
    "gear": []
  },
  {
    "id": "hob_1623",
    "label": "restaurar upcycling",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1624",
    "label": "restaurar reparar bicis",
    "category": "deporte",
    "gear": [
      "bicicleta"
    ]
  },
  {
    "id": "hob_1625",
    "label": "restaurar mecánica básica",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1626",
    "label": "restaurar carpintería",
    "category": "ocio",
    "gear": [
      "material de pintura"
    ]
  },
  {
    "id": "hob_1627",
    "label": "restaurar torno de madera",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1628",
    "label": "restaurar pirografía",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1629",
    "label": "restaurar vidrio fundido",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1630",
    "label": "restaurar mosaicos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1631",
    "label": "restaurar graffiti legal",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1632",
    "label": "restaurar parkour ligero",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1633",
    "label": "restaurar danza contemporánea",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1634",
    "label": "restaurar salsa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1635",
    "label": "restaurar bachata",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1636",
    "label": "restaurar tango",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1637",
    "label": "restaurar swing",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1638",
    "label": "restaurar k-pop dance",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1639",
    "label": "restaurar ballet amateur",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1640",
    "label": "restaurar capoeira",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1641",
    "label": "fotografiar ajedrez",
    "category": "ocio",
    "gear": [
      "ajedrez",
      "tablero de ajedrez"
    ]
  },
  {
    "id": "hob_1642",
    "label": "fotografiar guitarra acústica",
    "category": "musica",
    "gear": [
      "guitarra"
    ]
  },
  {
    "id": "hob_1643",
    "label": "fotografiar guitarra eléctrica",
    "category": "musica",
    "gear": [
      "guitarra"
    ]
  },
  {
    "id": "hob_1644",
    "label": "fotografiar ukelele",
    "category": "musica",
    "gear": []
  },
  {
    "id": "hob_1645",
    "label": "fotografiar piano",
    "category": "musica",
    "gear": []
  },
  {
    "id": "hob_1646",
    "label": "fotografiar batería",
    "category": "musica",
    "gear": []
  },
  {
    "id": "hob_1647",
    "label": "fotografiar violín",
    "category": "musica",
    "gear": []
  },
  {
    "id": "hob_1648",
    "label": "fotografiar flauta",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1649",
    "label": "fotografiar armónica",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1650",
    "label": "fotografiar canto",
    "category": "musica",
    "gear": []
  },
  {
    "id": "hob_1651",
    "label": "fotografiar dibujo a lápiz",
    "category": "arte",
    "gear": [
      "pintura",
      "material de pintura"
    ]
  },
  {
    "id": "hob_1652",
    "label": "fotografiar acuarela",
    "category": "ocio",
    "gear": [
      "pintura",
      "material de pintura"
    ]
  },
  {
    "id": "hob_1653",
    "label": "fotografiar óleo",
    "category": "arte",
    "gear": [
      "pintura",
      "material de pintura"
    ]
  },
  {
    "id": "hob_1654",
    "label": "fotografiar acrílico",
    "category": "ocio",
    "gear": [
      "pintura"
    ]
  },
  {
    "id": "hob_1655",
    "label": "fotografiar cómic",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1656",
    "label": "fotografiar caligrafía",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1657",
    "label": "fotografiar lettering",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1658",
    "label": "fotografiar origami",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1659",
    "label": "fotografiar cerámica",
    "category": "arte",
    "gear": []
  },
  {
    "id": "hob_1660",
    "label": "fotografiar costura",
    "category": "arte",
    "gear": []
  },
  {
    "id": "hob_1661",
    "label": "fotografiar punto de cruz",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1662",
    "label": "fotografiar ganchillo",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1663",
    "label": "fotografiar punto de media",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1664",
    "label": "fotografiar bordado",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1665",
    "label": "fotografiar macramé",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1666",
    "label": "fotografiar cuero",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1667",
    "label": "fotografiar joyería",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1668",
    "label": "fotografiar modelismo",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1669",
    "label": "fotografiar maquetas",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1670",
    "label": "fotografiar puzles",
    "category": "ocio",
    "gear": [
      "puzles"
    ]
  },
  {
    "id": "hob_1671",
    "label": "fotografiar puzzles 3D",
    "category": "ocio",
    "gear": [
      "puzles"
    ]
  },
  {
    "id": "hob_1672",
    "label": "fotografiar legos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1673",
    "label": "fotografiar drones",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1674",
    "label": "fotografiar astronomía",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1675",
    "label": "fotografiar birdwatching",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1676",
    "label": "fotografiar setas",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1677",
    "label": "fotografiar plantas de interior",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1678",
    "label": "fotografiar huerto urbano",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1679",
    "label": "fotografiar bonsái",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1680",
    "label": "fotografiar compostaje",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1681",
    "label": "fotografiar cocina vegana",
    "category": "gastronomia",
    "gear": [
      "cocina"
    ]
  },
  {
    "id": "hob_1682",
    "label": "fotografiar repostería",
    "category": "ocio",
    "gear": [
      "cocina"
    ]
  },
  {
    "id": "hob_1683",
    "label": "fotografiar panadería",
    "category": "gastronomia",
    "gear": [
      "cocina"
    ]
  },
  {
    "id": "hob_1684",
    "label": "fotografiar cafés de especialidad",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1685",
    "label": "fotografiar cata de tés",
    "category": "gastronomia",
    "gear": []
  },
  {
    "id": "hob_1686",
    "label": "fotografiar cata de vinos",
    "category": "gastronomia",
    "gear": []
  },
  {
    "id": "hob_1687",
    "label": "fotografiar cerveza artesanal",
    "category": "gastronomia",
    "gear": []
  },
  {
    "id": "hob_1688",
    "label": "fotografiar cócteles",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1689",
    "label": "fotografiar cocina fermentada",
    "category": "gastronomia",
    "gear": [
      "cocina"
    ]
  },
  {
    "id": "hob_1690",
    "label": "fotografiar running",
    "category": "deporte",
    "gear": [
      "running",
      "zapatillas de correr"
    ]
  },
  {
    "id": "hob_1691",
    "label": "fotografiar trail",
    "category": "ocio",
    "gear": [
      "running",
      "zapatillas de correr"
    ]
  },
  {
    "id": "hob_1692",
    "label": "fotografiar ciclismo de carretera",
    "category": "ocio",
    "gear": [
      "bicicleta"
    ]
  },
  {
    "id": "hob_1693",
    "label": "fotografiar mtb",
    "category": "ocio",
    "gear": [
      "bicicleta"
    ]
  },
  {
    "id": "hob_1694",
    "label": "fotografiar bici urbana",
    "category": "deporte",
    "gear": [
      "bicicleta"
    ]
  },
  {
    "id": "hob_1695",
    "label": "fotografiar patinaje",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1696",
    "label": "fotografiar skate",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1697",
    "label": "fotografiar surf",
    "category": "deporte",
    "gear": []
  },
  {
    "id": "hob_1698",
    "label": "fotografiar bodyboard",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1699",
    "label": "fotografiar paddle surf",
    "category": "deporte",
    "gear": [
      "kayak"
    ]
  },
  {
    "id": "hob_1700",
    "label": "fotografiar kayak",
    "category": "ocio",
    "gear": [
      "kayak"
    ]
  },
  {
    "id": "hob_1701",
    "label": "fotografiar remo",
    "category": "ocio",
    "gear": [
      "kayak"
    ]
  },
  {
    "id": "hob_1702",
    "label": "fotografiar natación",
    "category": "deporte",
    "gear": []
  },
  {
    "id": "hob_1703",
    "label": "fotografiar buceo",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1704",
    "label": "fotografiar escalada indoor",
    "category": "deporte",
    "gear": []
  },
  {
    "id": "hob_1705",
    "label": "fotografiar boulder",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1706",
    "label": "fotografiar senderismo",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1707",
    "label": "fotografiar trekking",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1708",
    "label": "fotografiar acampada",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1709",
    "label": "fotografiar orientación",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1710",
    "label": "fotografiar geocaching",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1711",
    "label": "fotografiar yoga",
    "category": "deporte",
    "gear": []
  },
  {
    "id": "hob_1712",
    "label": "fotografiar pilates",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1713",
    "label": "fotografiar meditación",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1714",
    "label": "fotografiar tai chi",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1715",
    "label": "fotografiar calistenia",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1716",
    "label": "fotografiar crossfit",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1717",
    "label": "fotografiar boxeo",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1718",
    "label": "fotografiar artes marciales",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1719",
    "label": "fotografiar esgrima",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1720",
    "label": "fotografiar tiro con arco",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1721",
    "label": "fotografiar tenis",
    "category": "deporte",
    "gear": []
  },
  {
    "id": "hob_1722",
    "label": "fotografiar pádel",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1723",
    "label": "fotografiar bádminton",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1724",
    "label": "fotografiar ping-pong",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1725",
    "label": "fotografiar fútbol",
    "category": "deporte",
    "gear": []
  },
  {
    "id": "hob_1726",
    "label": "fotografiar baloncesto",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1727",
    "label": "fotografiar voleibol",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1728",
    "label": "fotografiar ultimate",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1729",
    "label": "fotografiar disfraces",
    "category": "ocio",
    "gear": [
      "disfraz"
    ]
  },
  {
    "id": "hob_1730",
    "label": "fotografiar cosplay",
    "category": "ocio",
    "gear": [
      "disfraz"
    ]
  },
  {
    "id": "hob_1731",
    "label": "fotografiar teatro amateur",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1732",
    "label": "fotografiar improvisación teatral",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1733",
    "label": "fotografiar stand up",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1734",
    "label": "fotografiar magia",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1735",
    "label": "fotografiar malabares",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1736",
    "label": "fotografiar cuerda floja",
    "category": "ocio",
    "gear": [
      "cuerda floja",
      "cuerda / slackline"
    ]
  },
  {
    "id": "hob_1737",
    "label": "fotografiar slackline",
    "category": "ocio",
    "gear": [
      "cuerda floja",
      "cuerda / slackline"
    ]
  },
  {
    "id": "hob_1738",
    "label": "fotografiar cometas",
    "category": "ocio",
    "gear": [
      "cometa"
    ]
  },
  {
    "id": "hob_1739",
    "label": "fotografiar aeromodelismo",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1740",
    "label": "fotografiar trenes miniatura",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1741",
    "label": "fotografiar videojuegos indie",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1742",
    "label": "fotografiar videojuegos competitivos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1743",
    "label": "fotografiar juegos de mesa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1744",
    "label": "fotografiar rol de mesa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1745",
    "label": "fotografiar wargames",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1746",
    "label": "fotografiar cartas coleccionables",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1747",
    "label": "fotografiar lectura de novela",
    "category": "ocio",
    "gear": [
      "libros"
    ]
  },
  {
    "id": "hob_1748",
    "label": "fotografiar poesía",
    "category": "ocio",
    "gear": [
      "libros"
    ]
  },
  {
    "id": "hob_1749",
    "label": "fotografiar ensayo",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1750",
    "label": "fotografiar escritura creativa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1751",
    "label": "fotografiar journaling",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1752",
    "label": "fotografiar podcasting",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1753",
    "label": "fotografiar radio amateur",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1754",
    "label": "fotografiar edición de vídeo",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1755",
    "label": "fotografiar stop motion",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1756",
    "label": "fotografiar fotografía analógica",
    "category": "arte",
    "gear": [
      "cámara"
    ]
  },
  {
    "id": "hob_1757",
    "label": "fotografiar revelado",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1758",
    "label": "fotografiar street photography",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1759",
    "label": "fotografiar arquitectura urbana",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1760",
    "label": "fotografiar visitar museos",
    "category": "cultura",
    "gear": []
  },
  {
    "id": "hob_1761",
    "label": "fotografiar visitar monumentos",
    "category": "cultura",
    "gear": []
  },
  {
    "id": "hob_1762",
    "label": "fotografiar ver pueblitos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1763",
    "label": "fotografiar ver ciudad",
    "category": "cultura",
    "gear": []
  },
  {
    "id": "hob_1764",
    "label": "fotografiar viajes en tren",
    "category": "cultura",
    "gear": []
  },
  {
    "id": "hob_1765",
    "label": "fotografiar viajes en furgoneta",
    "category": "cultura",
    "gear": []
  },
  {
    "id": "hob_1766",
    "label": "fotografiar turismo industrial",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1767",
    "label": "fotografiar ruinas",
    "category": "cultura",
    "gear": []
  },
  {
    "id": "hob_1768",
    "label": "fotografiar cementerios históricos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1769",
    "label": "fotografiar mercados",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1770",
    "label": "fotografiar librerías de viejo",
    "category": "ocio",
    "gear": [
      "libros"
    ]
  },
  {
    "id": "hob_1771",
    "label": "fotografiar vinilos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1772",
    "label": "fotografiar casetes",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1773",
    "label": "fotografiar sellos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1774",
    "label": "fotografiar monedas",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1775",
    "label": "fotografiar minerales",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1776",
    "label": "fotografiar fósiles",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1777",
    "label": "fotografiar insectos (entomología amateur)",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1778",
    "label": "fotografiar acuariofilia",
    "category": "mascotas",
    "gear": []
  },
  {
    "id": "hob_1779",
    "label": "fotografiar cuidado de gatos",
    "category": "mascotas",
    "gear": []
  },
  {
    "id": "hob_1780",
    "label": "fotografiar cuidado de perros",
    "category": "mascotas",
    "gear": []
  },
  {
    "id": "hob_1781",
    "label": "fotografiar adiestramiento canino",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1782",
    "label": "fotografiar agility",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1783",
    "label": "fotografiar equitación",
    "category": "mascotas",
    "gear": []
  },
  {
    "id": "hob_1784",
    "label": "fotografiar voluntariado animal",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1785",
    "label": "fotografiar voluntariado social",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1786",
    "label": "fotografiar lengua de signos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1787",
    "label": "fotografiar idiomas",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1788",
    "label": "fotografiar latín",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1789",
    "label": "fotografiar esperanto",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1790",
    "label": "fotografiar ajedrez por correspondencia",
    "category": "ocio",
    "gear": [
      "ajedrez",
      "tablero de ajedrez"
    ]
  },
  {
    "id": "hob_1791",
    "label": "fotografiar go",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1792",
    "label": "fotografiar shogi",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1793",
    "label": "fotografiar bridge",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1794",
    "label": "fotografiar mahjong",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1795",
    "label": "fotografiar sudokus",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1796",
    "label": "fotografiar crucigramas",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1797",
    "label": "fotografiar escape rooms caseros",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1798",
    "label": "fotografiar robótica",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1799",
    "label": "fotografiar arduino",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1800",
    "label": "fotografiar impresión 3D",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1801",
    "label": "fotografiar reparar electrónicos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1802",
    "label": "fotografiar linux",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1803",
    "label": "fotografiar ciberseguridad ética amateur",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1804",
    "label": "fotografiar mapas OSM",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1805",
    "label": "fotografiar hammocking",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1806",
    "label": "fotografiar sauna",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1807",
    "label": "fotografiar baños fríos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1808",
    "label": "fotografiar respiración",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1809",
    "label": "fotografiar astrología cultural",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1810",
    "label": "fotografiar tarot artístico",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1811",
    "label": "fotografiar perfumería artesanal",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1812",
    "label": "fotografiar jabones",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1813",
    "label": "fotografiar velas",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1814",
    "label": "fotografiar incienso",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1815",
    "label": "fotografiar tes de hierbas",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1816",
    "label": "fotografiar foraging urbano",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1817",
    "label": "fotografiar urban sketching",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1818",
    "label": "fotografiar zines",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1819",
    "label": "fotografiar fanzines",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1820",
    "label": "fotografiar serigrafía",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1821",
    "label": "fotografiar linograbado",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1822",
    "label": "fotografiar tipografía",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1823",
    "label": "fotografiar diseño de interiores",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1824",
    "label": "fotografiar feng shui amateur",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1825",
    "label": "fotografiar organización del hogar",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1826",
    "label": "fotografiar zero waste",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1827",
    "label": "fotografiar costura de arreglos",
    "category": "arte",
    "gear": []
  },
  {
    "id": "hob_1828",
    "label": "fotografiar upcycling",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1829",
    "label": "fotografiar reparar bicis",
    "category": "deporte",
    "gear": [
      "bicicleta"
    ]
  },
  {
    "id": "hob_1830",
    "label": "fotografiar mecánica básica",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1831",
    "label": "fotografiar carpintería",
    "category": "ocio",
    "gear": [
      "material de pintura"
    ]
  },
  {
    "id": "hob_1832",
    "label": "fotografiar torno de madera",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1833",
    "label": "fotografiar pirografía",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1834",
    "label": "fotografiar vidrio fundido",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1835",
    "label": "fotografiar mosaicos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1836",
    "label": "fotografiar graffiti legal",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1837",
    "label": "fotografiar parkour ligero",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1838",
    "label": "fotografiar danza contemporánea",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1839",
    "label": "fotografiar salsa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1840",
    "label": "fotografiar bachata",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1841",
    "label": "fotografiar tango",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1842",
    "label": "fotografiar swing",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1843",
    "label": "fotografiar k-pop dance",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1844",
    "label": "fotografiar ballet amateur",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1845",
    "label": "fotografiar capoeira",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1846",
    "label": "escribir sobre ajedrez",
    "category": "ocio",
    "gear": [
      "ajedrez",
      "tablero de ajedrez"
    ]
  },
  {
    "id": "hob_1847",
    "label": "escribir sobre guitarra acústica",
    "category": "musica",
    "gear": [
      "guitarra"
    ]
  },
  {
    "id": "hob_1848",
    "label": "escribir sobre guitarra eléctrica",
    "category": "musica",
    "gear": [
      "guitarra"
    ]
  },
  {
    "id": "hob_1849",
    "label": "escribir sobre ukelele",
    "category": "musica",
    "gear": []
  },
  {
    "id": "hob_1850",
    "label": "escribir sobre piano",
    "category": "musica",
    "gear": []
  },
  {
    "id": "hob_1851",
    "label": "escribir sobre batería",
    "category": "musica",
    "gear": []
  },
  {
    "id": "hob_1852",
    "label": "escribir sobre violín",
    "category": "musica",
    "gear": []
  },
  {
    "id": "hob_1853",
    "label": "escribir sobre flauta",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1854",
    "label": "escribir sobre armónica",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1855",
    "label": "escribir sobre canto",
    "category": "musica",
    "gear": []
  },
  {
    "id": "hob_1856",
    "label": "escribir sobre dibujo a lápiz",
    "category": "arte",
    "gear": [
      "pintura",
      "material de pintura"
    ]
  },
  {
    "id": "hob_1857",
    "label": "escribir sobre acuarela",
    "category": "ocio",
    "gear": [
      "pintura",
      "material de pintura"
    ]
  },
  {
    "id": "hob_1858",
    "label": "escribir sobre óleo",
    "category": "arte",
    "gear": [
      "pintura",
      "material de pintura"
    ]
  },
  {
    "id": "hob_1859",
    "label": "escribir sobre acrílico",
    "category": "ocio",
    "gear": [
      "pintura"
    ]
  },
  {
    "id": "hob_1860",
    "label": "escribir sobre cómic",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1861",
    "label": "escribir sobre caligrafía",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1862",
    "label": "escribir sobre lettering",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1863",
    "label": "escribir sobre origami",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1864",
    "label": "escribir sobre cerámica",
    "category": "arte",
    "gear": []
  },
  {
    "id": "hob_1865",
    "label": "escribir sobre costura",
    "category": "arte",
    "gear": []
  },
  {
    "id": "hob_1866",
    "label": "escribir sobre punto de cruz",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1867",
    "label": "escribir sobre ganchillo",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1868",
    "label": "escribir sobre punto de media",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1869",
    "label": "escribir sobre bordado",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1870",
    "label": "escribir sobre macramé",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1871",
    "label": "escribir sobre cuero",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1872",
    "label": "escribir sobre joyería",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1873",
    "label": "escribir sobre modelismo",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1874",
    "label": "escribir sobre maquetas",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1875",
    "label": "escribir sobre puzles",
    "category": "ocio",
    "gear": [
      "puzles"
    ]
  },
  {
    "id": "hob_1876",
    "label": "escribir sobre puzzles 3D",
    "category": "ocio",
    "gear": [
      "puzles"
    ]
  },
  {
    "id": "hob_1877",
    "label": "escribir sobre legos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1878",
    "label": "escribir sobre drones",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1879",
    "label": "escribir sobre astronomía",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1880",
    "label": "escribir sobre birdwatching",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1881",
    "label": "escribir sobre setas",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1882",
    "label": "escribir sobre plantas de interior",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1883",
    "label": "escribir sobre huerto urbano",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1884",
    "label": "escribir sobre bonsái",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1885",
    "label": "escribir sobre compostaje",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1886",
    "label": "escribir sobre cocina vegana",
    "category": "gastronomia",
    "gear": [
      "cocina"
    ]
  },
  {
    "id": "hob_1887",
    "label": "escribir sobre repostería",
    "category": "ocio",
    "gear": [
      "cocina"
    ]
  },
  {
    "id": "hob_1888",
    "label": "escribir sobre panadería",
    "category": "gastronomia",
    "gear": [
      "cocina"
    ]
  },
  {
    "id": "hob_1889",
    "label": "escribir sobre cafés de especialidad",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1890",
    "label": "escribir sobre cata de tés",
    "category": "gastronomia",
    "gear": []
  },
  {
    "id": "hob_1891",
    "label": "escribir sobre cata de vinos",
    "category": "gastronomia",
    "gear": []
  },
  {
    "id": "hob_1892",
    "label": "escribir sobre cerveza artesanal",
    "category": "gastronomia",
    "gear": []
  },
  {
    "id": "hob_1893",
    "label": "escribir sobre cócteles",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1894",
    "label": "escribir sobre cocina fermentada",
    "category": "gastronomia",
    "gear": [
      "cocina"
    ]
  },
  {
    "id": "hob_1895",
    "label": "escribir sobre running",
    "category": "deporte",
    "gear": [
      "running",
      "zapatillas de correr"
    ]
  },
  {
    "id": "hob_1896",
    "label": "escribir sobre trail",
    "category": "ocio",
    "gear": [
      "running",
      "zapatillas de correr"
    ]
  },
  {
    "id": "hob_1897",
    "label": "escribir sobre ciclismo de carretera",
    "category": "ocio",
    "gear": [
      "bicicleta"
    ]
  },
  {
    "id": "hob_1898",
    "label": "escribir sobre mtb",
    "category": "ocio",
    "gear": [
      "bicicleta"
    ]
  },
  {
    "id": "hob_1899",
    "label": "escribir sobre bici urbana",
    "category": "deporte",
    "gear": [
      "bicicleta"
    ]
  },
  {
    "id": "hob_1900",
    "label": "escribir sobre patinaje",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1901",
    "label": "escribir sobre skate",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1902",
    "label": "escribir sobre surf",
    "category": "deporte",
    "gear": []
  },
  {
    "id": "hob_1903",
    "label": "escribir sobre bodyboard",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1904",
    "label": "escribir sobre paddle surf",
    "category": "deporte",
    "gear": [
      "kayak"
    ]
  },
  {
    "id": "hob_1905",
    "label": "escribir sobre kayak",
    "category": "ocio",
    "gear": [
      "kayak"
    ]
  },
  {
    "id": "hob_1906",
    "label": "escribir sobre remo",
    "category": "ocio",
    "gear": [
      "kayak"
    ]
  },
  {
    "id": "hob_1907",
    "label": "escribir sobre natación",
    "category": "deporte",
    "gear": []
  },
  {
    "id": "hob_1908",
    "label": "escribir sobre buceo",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1909",
    "label": "escribir sobre escalada indoor",
    "category": "deporte",
    "gear": []
  },
  {
    "id": "hob_1910",
    "label": "escribir sobre boulder",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1911",
    "label": "escribir sobre senderismo",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1912",
    "label": "escribir sobre trekking",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1913",
    "label": "escribir sobre acampada",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1914",
    "label": "escribir sobre orientación",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1915",
    "label": "escribir sobre geocaching",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1916",
    "label": "escribir sobre yoga",
    "category": "deporte",
    "gear": []
  },
  {
    "id": "hob_1917",
    "label": "escribir sobre pilates",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1918",
    "label": "escribir sobre meditación",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1919",
    "label": "escribir sobre tai chi",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1920",
    "label": "escribir sobre calistenia",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1921",
    "label": "escribir sobre crossfit",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1922",
    "label": "escribir sobre boxeo",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1923",
    "label": "escribir sobre artes marciales",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1924",
    "label": "escribir sobre esgrima",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1925",
    "label": "escribir sobre tiro con arco",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1926",
    "label": "escribir sobre tenis",
    "category": "deporte",
    "gear": []
  },
  {
    "id": "hob_1927",
    "label": "escribir sobre pádel",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1928",
    "label": "escribir sobre bádminton",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1929",
    "label": "escribir sobre ping-pong",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1930",
    "label": "escribir sobre fútbol",
    "category": "deporte",
    "gear": []
  },
  {
    "id": "hob_1931",
    "label": "escribir sobre baloncesto",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1932",
    "label": "escribir sobre voleibol",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1933",
    "label": "escribir sobre ultimate",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1934",
    "label": "escribir sobre disfraces",
    "category": "ocio",
    "gear": [
      "disfraz"
    ]
  },
  {
    "id": "hob_1935",
    "label": "escribir sobre cosplay",
    "category": "ocio",
    "gear": [
      "disfraz"
    ]
  },
  {
    "id": "hob_1936",
    "label": "escribir sobre teatro amateur",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1937",
    "label": "escribir sobre improvisación teatral",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1938",
    "label": "escribir sobre stand up",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1939",
    "label": "escribir sobre magia",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1940",
    "label": "escribir sobre malabares",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1941",
    "label": "escribir sobre cuerda floja",
    "category": "ocio",
    "gear": [
      "cuerda floja",
      "cuerda / slackline"
    ]
  },
  {
    "id": "hob_1942",
    "label": "escribir sobre slackline",
    "category": "ocio",
    "gear": [
      "cuerda floja",
      "cuerda / slackline"
    ]
  },
  {
    "id": "hob_1943",
    "label": "escribir sobre cometas",
    "category": "ocio",
    "gear": [
      "cometa"
    ]
  },
  {
    "id": "hob_1944",
    "label": "escribir sobre aeromodelismo",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1945",
    "label": "escribir sobre trenes miniatura",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1946",
    "label": "escribir sobre videojuegos indie",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1947",
    "label": "escribir sobre videojuegos competitivos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1948",
    "label": "escribir sobre juegos de mesa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1949",
    "label": "escribir sobre rol de mesa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1950",
    "label": "escribir sobre wargames",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1951",
    "label": "escribir sobre cartas coleccionables",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1952",
    "label": "escribir sobre lectura de novela",
    "category": "ocio",
    "gear": [
      "libros"
    ]
  },
  {
    "id": "hob_1953",
    "label": "escribir sobre poesía",
    "category": "ocio",
    "gear": [
      "libros"
    ]
  },
  {
    "id": "hob_1954",
    "label": "escribir sobre ensayo",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1955",
    "label": "escribir sobre escritura creativa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1956",
    "label": "escribir sobre journaling",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1957",
    "label": "escribir sobre podcasting",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1958",
    "label": "escribir sobre radio amateur",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1959",
    "label": "escribir sobre edición de vídeo",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1960",
    "label": "escribir sobre stop motion",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1961",
    "label": "escribir sobre fotografía analógica",
    "category": "arte",
    "gear": [
      "cámara"
    ]
  },
  {
    "id": "hob_1962",
    "label": "escribir sobre revelado",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1963",
    "label": "escribir sobre street photography",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1964",
    "label": "escribir sobre arquitectura urbana",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1965",
    "label": "escribir sobre visitar museos",
    "category": "cultura",
    "gear": []
  },
  {
    "id": "hob_1966",
    "label": "escribir sobre visitar monumentos",
    "category": "cultura",
    "gear": []
  },
  {
    "id": "hob_1967",
    "label": "escribir sobre ver pueblitos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1968",
    "label": "escribir sobre ver ciudad",
    "category": "cultura",
    "gear": []
  },
  {
    "id": "hob_1969",
    "label": "escribir sobre viajes en tren",
    "category": "cultura",
    "gear": []
  },
  {
    "id": "hob_1970",
    "label": "escribir sobre viajes en furgoneta",
    "category": "cultura",
    "gear": []
  },
  {
    "id": "hob_1971",
    "label": "escribir sobre turismo industrial",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1972",
    "label": "escribir sobre ruinas",
    "category": "cultura",
    "gear": []
  },
  {
    "id": "hob_1973",
    "label": "escribir sobre cementerios históricos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1974",
    "label": "escribir sobre mercados",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1975",
    "label": "escribir sobre librerías de viejo",
    "category": "ocio",
    "gear": [
      "libros"
    ]
  },
  {
    "id": "hob_1976",
    "label": "escribir sobre vinilos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1977",
    "label": "escribir sobre casetes",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1978",
    "label": "escribir sobre sellos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1979",
    "label": "escribir sobre monedas",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1980",
    "label": "escribir sobre minerales",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1981",
    "label": "escribir sobre fósiles",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1982",
    "label": "escribir sobre insectos (entomología amateur)",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1983",
    "label": "escribir sobre acuariofilia",
    "category": "mascotas",
    "gear": []
  },
  {
    "id": "hob_1984",
    "label": "escribir sobre cuidado de gatos",
    "category": "mascotas",
    "gear": []
  },
  {
    "id": "hob_1985",
    "label": "escribir sobre cuidado de perros",
    "category": "mascotas",
    "gear": []
  },
  {
    "id": "hob_1986",
    "label": "escribir sobre adiestramiento canino",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1987",
    "label": "escribir sobre agility",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1988",
    "label": "escribir sobre equitación",
    "category": "mascotas",
    "gear": []
  },
  {
    "id": "hob_1989",
    "label": "escribir sobre voluntariado animal",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1990",
    "label": "escribir sobre voluntariado social",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1991",
    "label": "escribir sobre lengua de signos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1992",
    "label": "escribir sobre idiomas",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1993",
    "label": "escribir sobre latín",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1994",
    "label": "escribir sobre esperanto",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1995",
    "label": "escribir sobre ajedrez por correspondencia",
    "category": "ocio",
    "gear": [
      "ajedrez",
      "tablero de ajedrez"
    ]
  },
  {
    "id": "hob_1996",
    "label": "escribir sobre go",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1997",
    "label": "escribir sobre shogi",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1998",
    "label": "escribir sobre bridge",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_1999",
    "label": "escribir sobre mahjong",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2000",
    "label": "escribir sobre sudokus",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2001",
    "label": "escribir sobre crucigramas",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2002",
    "label": "escribir sobre escape rooms caseros",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2003",
    "label": "escribir sobre robótica",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2004",
    "label": "escribir sobre arduino",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2005",
    "label": "escribir sobre impresión 3D",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2006",
    "label": "escribir sobre reparar electrónicos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2007",
    "label": "escribir sobre linux",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2008",
    "label": "escribir sobre ciberseguridad ética amateur",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2009",
    "label": "escribir sobre mapas OSM",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2010",
    "label": "escribir sobre hammocking",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2011",
    "label": "escribir sobre sauna",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2012",
    "label": "escribir sobre baños fríos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2013",
    "label": "escribir sobre respiración",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2014",
    "label": "escribir sobre astrología cultural",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2015",
    "label": "escribir sobre tarot artístico",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2016",
    "label": "escribir sobre perfumería artesanal",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2017",
    "label": "escribir sobre jabones",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2018",
    "label": "escribir sobre velas",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2019",
    "label": "escribir sobre incienso",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2020",
    "label": "escribir sobre tes de hierbas",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2021",
    "label": "escribir sobre foraging urbano",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2022",
    "label": "escribir sobre urban sketching",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2023",
    "label": "escribir sobre zines",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2024",
    "label": "escribir sobre fanzines",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2025",
    "label": "escribir sobre serigrafía",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2026",
    "label": "escribir sobre linograbado",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2027",
    "label": "escribir sobre tipografía",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2028",
    "label": "escribir sobre diseño de interiores",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2029",
    "label": "escribir sobre feng shui amateur",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2030",
    "label": "escribir sobre organización del hogar",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2031",
    "label": "escribir sobre zero waste",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2032",
    "label": "escribir sobre costura de arreglos",
    "category": "arte",
    "gear": []
  },
  {
    "id": "hob_2033",
    "label": "escribir sobre upcycling",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2034",
    "label": "escribir sobre reparar bicis",
    "category": "deporte",
    "gear": [
      "bicicleta"
    ]
  },
  {
    "id": "hob_2035",
    "label": "escribir sobre mecánica básica",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2036",
    "label": "escribir sobre carpintería",
    "category": "ocio",
    "gear": [
      "material de pintura"
    ]
  },
  {
    "id": "hob_2037",
    "label": "escribir sobre torno de madera",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2038",
    "label": "escribir sobre pirografía",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2039",
    "label": "escribir sobre vidrio fundido",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2040",
    "label": "escribir sobre mosaicos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2041",
    "label": "escribir sobre graffiti legal",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2042",
    "label": "escribir sobre parkour ligero",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2043",
    "label": "escribir sobre danza contemporánea",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2044",
    "label": "escribir sobre salsa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2045",
    "label": "escribir sobre bachata",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2046",
    "label": "escribir sobre tango",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2047",
    "label": "escribir sobre swing",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2048",
    "label": "escribir sobre k-pop dance",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2049",
    "label": "escribir sobre ballet amateur",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2050",
    "label": "escribir sobre capoeira",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2051",
    "label": "enseñar ajedrez",
    "category": "ocio",
    "gear": [
      "ajedrez",
      "tablero de ajedrez"
    ]
  },
  {
    "id": "hob_2052",
    "label": "enseñar guitarra acústica",
    "category": "musica",
    "gear": [
      "guitarra"
    ]
  },
  {
    "id": "hob_2053",
    "label": "enseñar guitarra eléctrica",
    "category": "musica",
    "gear": [
      "guitarra"
    ]
  },
  {
    "id": "hob_2054",
    "label": "enseñar ukelele",
    "category": "musica",
    "gear": []
  },
  {
    "id": "hob_2055",
    "label": "enseñar piano",
    "category": "musica",
    "gear": []
  },
  {
    "id": "hob_2056",
    "label": "enseñar batería",
    "category": "musica",
    "gear": []
  },
  {
    "id": "hob_2057",
    "label": "enseñar violín",
    "category": "musica",
    "gear": []
  },
  {
    "id": "hob_2058",
    "label": "enseñar flauta",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2059",
    "label": "enseñar armónica",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2060",
    "label": "enseñar canto",
    "category": "musica",
    "gear": []
  },
  {
    "id": "hob_2061",
    "label": "enseñar dibujo a lápiz",
    "category": "arte",
    "gear": [
      "pintura",
      "material de pintura"
    ]
  },
  {
    "id": "hob_2062",
    "label": "enseñar acuarela",
    "category": "ocio",
    "gear": [
      "pintura",
      "material de pintura"
    ]
  },
  {
    "id": "hob_2063",
    "label": "enseñar óleo",
    "category": "arte",
    "gear": [
      "pintura",
      "material de pintura"
    ]
  },
  {
    "id": "hob_2064",
    "label": "enseñar acrílico",
    "category": "ocio",
    "gear": [
      "pintura"
    ]
  },
  {
    "id": "hob_2065",
    "label": "enseñar cómic",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2066",
    "label": "enseñar caligrafía",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2067",
    "label": "enseñar lettering",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2068",
    "label": "enseñar origami",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2069",
    "label": "enseñar cerámica",
    "category": "arte",
    "gear": []
  },
  {
    "id": "hob_2070",
    "label": "enseñar costura",
    "category": "arte",
    "gear": []
  },
  {
    "id": "hob_2071",
    "label": "enseñar punto de cruz",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2072",
    "label": "enseñar ganchillo",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2073",
    "label": "enseñar punto de media",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2074",
    "label": "enseñar bordado",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2075",
    "label": "enseñar macramé",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2076",
    "label": "enseñar cuero",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2077",
    "label": "enseñar joyería",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2078",
    "label": "enseñar modelismo",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2079",
    "label": "enseñar maquetas",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2080",
    "label": "enseñar puzles",
    "category": "ocio",
    "gear": [
      "puzles"
    ]
  },
  {
    "id": "hob_2081",
    "label": "enseñar puzzles 3D",
    "category": "ocio",
    "gear": [
      "puzles"
    ]
  },
  {
    "id": "hob_2082",
    "label": "enseñar legos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2083",
    "label": "enseñar drones",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2084",
    "label": "enseñar astronomía",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2085",
    "label": "enseñar birdwatching",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2086",
    "label": "enseñar setas",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2087",
    "label": "enseñar plantas de interior",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2088",
    "label": "enseñar huerto urbano",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2089",
    "label": "enseñar bonsái",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2090",
    "label": "enseñar compostaje",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2091",
    "label": "enseñar cocina vegana",
    "category": "gastronomia",
    "gear": [
      "cocina"
    ]
  },
  {
    "id": "hob_2092",
    "label": "enseñar repostería",
    "category": "ocio",
    "gear": [
      "cocina"
    ]
  },
  {
    "id": "hob_2093",
    "label": "enseñar panadería",
    "category": "gastronomia",
    "gear": [
      "cocina"
    ]
  },
  {
    "id": "hob_2094",
    "label": "enseñar cafés de especialidad",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2095",
    "label": "enseñar cata de tés",
    "category": "gastronomia",
    "gear": []
  },
  {
    "id": "hob_2096",
    "label": "enseñar cata de vinos",
    "category": "gastronomia",
    "gear": []
  },
  {
    "id": "hob_2097",
    "label": "enseñar cerveza artesanal",
    "category": "gastronomia",
    "gear": []
  },
  {
    "id": "hob_2098",
    "label": "enseñar cócteles",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2099",
    "label": "enseñar cocina fermentada",
    "category": "gastronomia",
    "gear": [
      "cocina"
    ]
  },
  {
    "id": "hob_2100",
    "label": "enseñar running",
    "category": "deporte",
    "gear": [
      "running",
      "zapatillas de correr"
    ]
  },
  {
    "id": "hob_2101",
    "label": "enseñar trail",
    "category": "ocio",
    "gear": [
      "running",
      "zapatillas de correr"
    ]
  },
  {
    "id": "hob_2102",
    "label": "enseñar ciclismo de carretera",
    "category": "ocio",
    "gear": [
      "bicicleta"
    ]
  },
  {
    "id": "hob_2103",
    "label": "enseñar mtb",
    "category": "ocio",
    "gear": [
      "bicicleta"
    ]
  },
  {
    "id": "hob_2104",
    "label": "enseñar bici urbana",
    "category": "deporte",
    "gear": [
      "bicicleta"
    ]
  },
  {
    "id": "hob_2105",
    "label": "enseñar patinaje",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2106",
    "label": "enseñar skate",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2107",
    "label": "enseñar surf",
    "category": "deporte",
    "gear": []
  },
  {
    "id": "hob_2108",
    "label": "enseñar bodyboard",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2109",
    "label": "enseñar paddle surf",
    "category": "deporte",
    "gear": [
      "kayak"
    ]
  },
  {
    "id": "hob_2110",
    "label": "enseñar kayak",
    "category": "ocio",
    "gear": [
      "kayak"
    ]
  },
  {
    "id": "hob_2111",
    "label": "enseñar remo",
    "category": "ocio",
    "gear": [
      "kayak"
    ]
  },
  {
    "id": "hob_2112",
    "label": "enseñar natación",
    "category": "deporte",
    "gear": []
  },
  {
    "id": "hob_2113",
    "label": "enseñar buceo",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2114",
    "label": "enseñar escalada indoor",
    "category": "deporte",
    "gear": []
  },
  {
    "id": "hob_2115",
    "label": "enseñar boulder",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2116",
    "label": "enseñar senderismo",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2117",
    "label": "enseñar trekking",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2118",
    "label": "enseñar acampada",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2119",
    "label": "enseñar orientación",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2120",
    "label": "enseñar geocaching",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2121",
    "label": "enseñar yoga",
    "category": "deporte",
    "gear": []
  },
  {
    "id": "hob_2122",
    "label": "enseñar pilates",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2123",
    "label": "enseñar meditación",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2124",
    "label": "enseñar tai chi",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2125",
    "label": "enseñar calistenia",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2126",
    "label": "enseñar crossfit",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2127",
    "label": "enseñar boxeo",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2128",
    "label": "enseñar artes marciales",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2129",
    "label": "enseñar esgrima",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2130",
    "label": "enseñar tiro con arco",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2131",
    "label": "enseñar tenis",
    "category": "deporte",
    "gear": []
  },
  {
    "id": "hob_2132",
    "label": "enseñar pádel",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2133",
    "label": "enseñar bádminton",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2134",
    "label": "enseñar ping-pong",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2135",
    "label": "enseñar fútbol",
    "category": "deporte",
    "gear": []
  },
  {
    "id": "hob_2136",
    "label": "enseñar baloncesto",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2137",
    "label": "enseñar voleibol",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2138",
    "label": "enseñar ultimate",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2139",
    "label": "enseñar disfraces",
    "category": "ocio",
    "gear": [
      "disfraz"
    ]
  },
  {
    "id": "hob_2140",
    "label": "enseñar cosplay",
    "category": "ocio",
    "gear": [
      "disfraz"
    ]
  },
  {
    "id": "hob_2141",
    "label": "enseñar teatro amateur",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2142",
    "label": "enseñar improvisación teatral",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2143",
    "label": "enseñar stand up",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2144",
    "label": "enseñar magia",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2145",
    "label": "enseñar malabares",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2146",
    "label": "enseñar cuerda floja",
    "category": "ocio",
    "gear": [
      "cuerda floja",
      "cuerda / slackline"
    ]
  },
  {
    "id": "hob_2147",
    "label": "enseñar slackline",
    "category": "ocio",
    "gear": [
      "cuerda floja",
      "cuerda / slackline"
    ]
  },
  {
    "id": "hob_2148",
    "label": "enseñar cometas",
    "category": "ocio",
    "gear": [
      "cometa"
    ]
  },
  {
    "id": "hob_2149",
    "label": "enseñar aeromodelismo",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2150",
    "label": "enseñar trenes miniatura",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2151",
    "label": "enseñar videojuegos indie",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2152",
    "label": "enseñar videojuegos competitivos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2153",
    "label": "enseñar juegos de mesa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2154",
    "label": "enseñar rol de mesa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2155",
    "label": "enseñar wargames",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2156",
    "label": "enseñar cartas coleccionables",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2157",
    "label": "enseñar lectura de novela",
    "category": "ocio",
    "gear": [
      "libros"
    ]
  },
  {
    "id": "hob_2158",
    "label": "enseñar poesía",
    "category": "ocio",
    "gear": [
      "libros"
    ]
  },
  {
    "id": "hob_2159",
    "label": "enseñar ensayo",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2160",
    "label": "enseñar escritura creativa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2161",
    "label": "enseñar journaling",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2162",
    "label": "enseñar podcasting",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2163",
    "label": "enseñar radio amateur",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2164",
    "label": "enseñar edición de vídeo",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2165",
    "label": "enseñar stop motion",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2166",
    "label": "enseñar fotografía analógica",
    "category": "arte",
    "gear": [
      "cámara"
    ]
  },
  {
    "id": "hob_2167",
    "label": "enseñar revelado",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2168",
    "label": "enseñar street photography",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2169",
    "label": "enseñar arquitectura urbana",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2170",
    "label": "enseñar visitar museos",
    "category": "cultura",
    "gear": []
  },
  {
    "id": "hob_2171",
    "label": "enseñar visitar monumentos",
    "category": "cultura",
    "gear": []
  },
  {
    "id": "hob_2172",
    "label": "enseñar ver pueblitos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2173",
    "label": "enseñar ver ciudad",
    "category": "cultura",
    "gear": []
  },
  {
    "id": "hob_2174",
    "label": "enseñar viajes en tren",
    "category": "cultura",
    "gear": []
  },
  {
    "id": "hob_2175",
    "label": "enseñar viajes en furgoneta",
    "category": "cultura",
    "gear": []
  },
  {
    "id": "hob_2176",
    "label": "enseñar turismo industrial",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2177",
    "label": "enseñar ruinas",
    "category": "cultura",
    "gear": []
  },
  {
    "id": "hob_2178",
    "label": "enseñar cementerios históricos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2179",
    "label": "enseñar mercados",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2180",
    "label": "enseñar librerías de viejo",
    "category": "ocio",
    "gear": [
      "libros"
    ]
  },
  {
    "id": "hob_2181",
    "label": "enseñar vinilos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2182",
    "label": "enseñar casetes",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2183",
    "label": "enseñar sellos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2184",
    "label": "enseñar monedas",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2185",
    "label": "enseñar minerales",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2186",
    "label": "enseñar fósiles",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2187",
    "label": "enseñar insectos (entomología amateur)",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2188",
    "label": "enseñar acuariofilia",
    "category": "mascotas",
    "gear": []
  },
  {
    "id": "hob_2189",
    "label": "enseñar cuidado de gatos",
    "category": "mascotas",
    "gear": []
  },
  {
    "id": "hob_2190",
    "label": "enseñar cuidado de perros",
    "category": "mascotas",
    "gear": []
  },
  {
    "id": "hob_2191",
    "label": "enseñar adiestramiento canino",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2192",
    "label": "enseñar agility",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2193",
    "label": "enseñar equitación",
    "category": "mascotas",
    "gear": []
  },
  {
    "id": "hob_2194",
    "label": "enseñar voluntariado animal",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2195",
    "label": "enseñar voluntariado social",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2196",
    "label": "enseñar lengua de signos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2197",
    "label": "enseñar idiomas",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2198",
    "label": "enseñar latín",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2199",
    "label": "enseñar esperanto",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2200",
    "label": "enseñar ajedrez por correspondencia",
    "category": "ocio",
    "gear": [
      "ajedrez",
      "tablero de ajedrez"
    ]
  },
  {
    "id": "hob_2201",
    "label": "enseñar go",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2202",
    "label": "enseñar shogi",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2203",
    "label": "enseñar bridge",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2204",
    "label": "enseñar mahjong",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2205",
    "label": "enseñar sudokus",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2206",
    "label": "enseñar crucigramas",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2207",
    "label": "enseñar escape rooms caseros",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2208",
    "label": "enseñar robótica",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2209",
    "label": "enseñar arduino",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2210",
    "label": "enseñar impresión 3D",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2211",
    "label": "enseñar reparar electrónicos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2212",
    "label": "enseñar linux",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2213",
    "label": "enseñar ciberseguridad ética amateur",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2214",
    "label": "enseñar mapas OSM",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2215",
    "label": "enseñar hammocking",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2216",
    "label": "enseñar sauna",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2217",
    "label": "enseñar baños fríos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2218",
    "label": "enseñar respiración",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2219",
    "label": "enseñar astrología cultural",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2220",
    "label": "enseñar tarot artístico",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2221",
    "label": "enseñar perfumería artesanal",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2222",
    "label": "enseñar jabones",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2223",
    "label": "enseñar velas",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2224",
    "label": "enseñar incienso",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2225",
    "label": "enseñar tes de hierbas",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2226",
    "label": "enseñar foraging urbano",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2227",
    "label": "enseñar urban sketching",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2228",
    "label": "enseñar zines",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2229",
    "label": "enseñar fanzines",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2230",
    "label": "enseñar serigrafía",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2231",
    "label": "enseñar linograbado",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2232",
    "label": "enseñar tipografía",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2233",
    "label": "enseñar diseño de interiores",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2234",
    "label": "enseñar feng shui amateur",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2235",
    "label": "enseñar organización del hogar",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2236",
    "label": "enseñar zero waste",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2237",
    "label": "enseñar costura de arreglos",
    "category": "arte",
    "gear": []
  },
  {
    "id": "hob_2238",
    "label": "enseñar upcycling",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2239",
    "label": "enseñar reparar bicis",
    "category": "deporte",
    "gear": [
      "bicicleta"
    ]
  },
  {
    "id": "hob_2240",
    "label": "enseñar mecánica básica",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2241",
    "label": "enseñar carpintería",
    "category": "ocio",
    "gear": [
      "material de pintura"
    ]
  },
  {
    "id": "hob_2242",
    "label": "enseñar torno de madera",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2243",
    "label": "enseñar pirografía",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2244",
    "label": "enseñar vidrio fundido",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2245",
    "label": "enseñar mosaicos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2246",
    "label": "enseñar graffiti legal",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2247",
    "label": "enseñar parkour ligero",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2248",
    "label": "enseñar danza contemporánea",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2249",
    "label": "enseñar salsa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2250",
    "label": "enseñar bachata",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2251",
    "label": "enseñar tango",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2252",
    "label": "enseñar swing",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2253",
    "label": "enseñar k-pop dance",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2254",
    "label": "enseñar ballet amateur",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2255",
    "label": "enseñar capoeira",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2256",
    "label": "competir en ajedrez",
    "category": "ocio",
    "gear": [
      "ajedrez",
      "tablero de ajedrez"
    ]
  },
  {
    "id": "hob_2257",
    "label": "competir en guitarra acústica",
    "category": "musica",
    "gear": [
      "guitarra"
    ]
  },
  {
    "id": "hob_2258",
    "label": "competir en guitarra eléctrica",
    "category": "musica",
    "gear": [
      "guitarra"
    ]
  },
  {
    "id": "hob_2259",
    "label": "competir en ukelele",
    "category": "musica",
    "gear": []
  },
  {
    "id": "hob_2260",
    "label": "competir en piano",
    "category": "musica",
    "gear": []
  },
  {
    "id": "hob_2261",
    "label": "competir en batería",
    "category": "musica",
    "gear": []
  },
  {
    "id": "hob_2262",
    "label": "competir en violín",
    "category": "musica",
    "gear": []
  },
  {
    "id": "hob_2263",
    "label": "competir en flauta",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2264",
    "label": "competir en armónica",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2265",
    "label": "competir en canto",
    "category": "musica",
    "gear": []
  },
  {
    "id": "hob_2266",
    "label": "competir en dibujo a lápiz",
    "category": "arte",
    "gear": [
      "pintura",
      "material de pintura"
    ]
  },
  {
    "id": "hob_2267",
    "label": "competir en acuarela",
    "category": "ocio",
    "gear": [
      "pintura",
      "material de pintura"
    ]
  },
  {
    "id": "hob_2268",
    "label": "competir en óleo",
    "category": "arte",
    "gear": [
      "pintura",
      "material de pintura"
    ]
  },
  {
    "id": "hob_2269",
    "label": "competir en acrílico",
    "category": "ocio",
    "gear": [
      "pintura"
    ]
  },
  {
    "id": "hob_2270",
    "label": "competir en cómic",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2271",
    "label": "competir en caligrafía",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2272",
    "label": "competir en lettering",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2273",
    "label": "competir en origami",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2274",
    "label": "competir en cerámica",
    "category": "arte",
    "gear": []
  },
  {
    "id": "hob_2275",
    "label": "competir en costura",
    "category": "arte",
    "gear": []
  },
  {
    "id": "hob_2276",
    "label": "competir en punto de cruz",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2277",
    "label": "competir en ganchillo",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2278",
    "label": "competir en punto de media",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2279",
    "label": "competir en bordado",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2280",
    "label": "competir en macramé",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2281",
    "label": "competir en cuero",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2282",
    "label": "competir en joyería",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2283",
    "label": "competir en modelismo",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2284",
    "label": "competir en maquetas",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2285",
    "label": "competir en puzles",
    "category": "ocio",
    "gear": [
      "puzles"
    ]
  },
  {
    "id": "hob_2286",
    "label": "competir en puzzles 3D",
    "category": "ocio",
    "gear": [
      "puzles"
    ]
  },
  {
    "id": "hob_2287",
    "label": "competir en legos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2288",
    "label": "competir en drones",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2289",
    "label": "competir en astronomía",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2290",
    "label": "competir en birdwatching",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2291",
    "label": "competir en setas",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2292",
    "label": "competir en plantas de interior",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2293",
    "label": "competir en huerto urbano",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2294",
    "label": "competir en bonsái",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2295",
    "label": "competir en compostaje",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2296",
    "label": "competir en cocina vegana",
    "category": "gastronomia",
    "gear": [
      "cocina"
    ]
  },
  {
    "id": "hob_2297",
    "label": "competir en repostería",
    "category": "ocio",
    "gear": [
      "cocina"
    ]
  },
  {
    "id": "hob_2298",
    "label": "competir en panadería",
    "category": "gastronomia",
    "gear": [
      "cocina"
    ]
  },
  {
    "id": "hob_2299",
    "label": "competir en cafés de especialidad",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2300",
    "label": "competir en cata de tés",
    "category": "gastronomia",
    "gear": []
  },
  {
    "id": "hob_2301",
    "label": "competir en cata de vinos",
    "category": "gastronomia",
    "gear": []
  },
  {
    "id": "hob_2302",
    "label": "competir en cerveza artesanal",
    "category": "gastronomia",
    "gear": []
  },
  {
    "id": "hob_2303",
    "label": "competir en cócteles",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2304",
    "label": "competir en cocina fermentada",
    "category": "gastronomia",
    "gear": [
      "cocina"
    ]
  },
  {
    "id": "hob_2305",
    "label": "competir en running",
    "category": "deporte",
    "gear": [
      "running",
      "zapatillas de correr"
    ]
  },
  {
    "id": "hob_2306",
    "label": "competir en trail",
    "category": "ocio",
    "gear": [
      "running",
      "zapatillas de correr"
    ]
  },
  {
    "id": "hob_2307",
    "label": "competir en ciclismo de carretera",
    "category": "ocio",
    "gear": [
      "bicicleta"
    ]
  },
  {
    "id": "hob_2308",
    "label": "competir en mtb",
    "category": "ocio",
    "gear": [
      "bicicleta"
    ]
  },
  {
    "id": "hob_2309",
    "label": "competir en bici urbana",
    "category": "deporte",
    "gear": [
      "bicicleta"
    ]
  },
  {
    "id": "hob_2310",
    "label": "competir en patinaje",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2311",
    "label": "competir en skate",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2312",
    "label": "competir en surf",
    "category": "deporte",
    "gear": []
  },
  {
    "id": "hob_2313",
    "label": "competir en bodyboard",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2314",
    "label": "competir en paddle surf",
    "category": "deporte",
    "gear": [
      "kayak"
    ]
  },
  {
    "id": "hob_2315",
    "label": "competir en kayak",
    "category": "ocio",
    "gear": [
      "kayak"
    ]
  },
  {
    "id": "hob_2316",
    "label": "competir en remo",
    "category": "ocio",
    "gear": [
      "kayak"
    ]
  },
  {
    "id": "hob_2317",
    "label": "competir en natación",
    "category": "deporte",
    "gear": []
  },
  {
    "id": "hob_2318",
    "label": "competir en buceo",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2319",
    "label": "competir en escalada indoor",
    "category": "deporte",
    "gear": []
  },
  {
    "id": "hob_2320",
    "label": "competir en boulder",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2321",
    "label": "competir en senderismo",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2322",
    "label": "competir en trekking",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2323",
    "label": "competir en acampada",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2324",
    "label": "competir en orientación",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2325",
    "label": "competir en geocaching",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2326",
    "label": "competir en yoga",
    "category": "deporte",
    "gear": []
  },
  {
    "id": "hob_2327",
    "label": "competir en pilates",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2328",
    "label": "competir en meditación",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2329",
    "label": "competir en tai chi",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2330",
    "label": "competir en calistenia",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2331",
    "label": "competir en crossfit",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2332",
    "label": "competir en boxeo",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2333",
    "label": "competir en artes marciales",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2334",
    "label": "competir en esgrima",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2335",
    "label": "competir en tiro con arco",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2336",
    "label": "competir en tenis",
    "category": "deporte",
    "gear": []
  },
  {
    "id": "hob_2337",
    "label": "competir en pádel",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2338",
    "label": "competir en bádminton",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2339",
    "label": "competir en ping-pong",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2340",
    "label": "competir en fútbol",
    "category": "deporte",
    "gear": []
  },
  {
    "id": "hob_2341",
    "label": "competir en baloncesto",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2342",
    "label": "competir en voleibol",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2343",
    "label": "competir en ultimate",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2344",
    "label": "competir en disfraces",
    "category": "ocio",
    "gear": [
      "disfraz"
    ]
  },
  {
    "id": "hob_2345",
    "label": "competir en cosplay",
    "category": "ocio",
    "gear": [
      "disfraz"
    ]
  },
  {
    "id": "hob_2346",
    "label": "competir en teatro amateur",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2347",
    "label": "competir en improvisación teatral",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2348",
    "label": "competir en stand up",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2349",
    "label": "competir en magia",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2350",
    "label": "competir en malabares",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2351",
    "label": "competir en cuerda floja",
    "category": "ocio",
    "gear": [
      "cuerda floja",
      "cuerda / slackline"
    ]
  },
  {
    "id": "hob_2352",
    "label": "competir en slackline",
    "category": "ocio",
    "gear": [
      "cuerda floja",
      "cuerda / slackline"
    ]
  },
  {
    "id": "hob_2353",
    "label": "competir en cometas",
    "category": "ocio",
    "gear": [
      "cometa"
    ]
  },
  {
    "id": "hob_2354",
    "label": "competir en aeromodelismo",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2355",
    "label": "competir en trenes miniatura",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2356",
    "label": "competir en videojuegos indie",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2357",
    "label": "competir en videojuegos competitivos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2358",
    "label": "competir en juegos de mesa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2359",
    "label": "competir en rol de mesa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2360",
    "label": "competir en wargames",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2361",
    "label": "competir en cartas coleccionables",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2362",
    "label": "competir en lectura de novela",
    "category": "ocio",
    "gear": [
      "libros"
    ]
  },
  {
    "id": "hob_2363",
    "label": "competir en poesía",
    "category": "ocio",
    "gear": [
      "libros"
    ]
  },
  {
    "id": "hob_2364",
    "label": "competir en ensayo",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2365",
    "label": "competir en escritura creativa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2366",
    "label": "competir en journaling",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2367",
    "label": "competir en podcasting",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2368",
    "label": "competir en radio amateur",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2369",
    "label": "competir en edición de vídeo",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2370",
    "label": "competir en stop motion",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2371",
    "label": "competir en fotografía analógica",
    "category": "arte",
    "gear": [
      "cámara"
    ]
  },
  {
    "id": "hob_2372",
    "label": "competir en revelado",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2373",
    "label": "competir en street photography",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2374",
    "label": "competir en arquitectura urbana",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2375",
    "label": "competir en visitar museos",
    "category": "cultura",
    "gear": []
  },
  {
    "id": "hob_2376",
    "label": "competir en visitar monumentos",
    "category": "cultura",
    "gear": []
  },
  {
    "id": "hob_2377",
    "label": "competir en ver pueblitos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2378",
    "label": "competir en ver ciudad",
    "category": "cultura",
    "gear": []
  },
  {
    "id": "hob_2379",
    "label": "competir en viajes en tren",
    "category": "cultura",
    "gear": []
  },
  {
    "id": "hob_2380",
    "label": "competir en viajes en furgoneta",
    "category": "cultura",
    "gear": []
  },
  {
    "id": "hob_2381",
    "label": "competir en turismo industrial",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2382",
    "label": "competir en ruinas",
    "category": "cultura",
    "gear": []
  },
  {
    "id": "hob_2383",
    "label": "competir en cementerios históricos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2384",
    "label": "competir en mercados",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2385",
    "label": "competir en librerías de viejo",
    "category": "ocio",
    "gear": [
      "libros"
    ]
  },
  {
    "id": "hob_2386",
    "label": "competir en vinilos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2387",
    "label": "competir en casetes",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2388",
    "label": "competir en sellos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2389",
    "label": "competir en monedas",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2390",
    "label": "competir en minerales",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2391",
    "label": "competir en fósiles",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2392",
    "label": "competir en insectos (entomología amateur)",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2393",
    "label": "competir en acuariofilia",
    "category": "mascotas",
    "gear": []
  },
  {
    "id": "hob_2394",
    "label": "competir en cuidado de gatos",
    "category": "mascotas",
    "gear": []
  },
  {
    "id": "hob_2395",
    "label": "competir en cuidado de perros",
    "category": "mascotas",
    "gear": []
  },
  {
    "id": "hob_2396",
    "label": "competir en adiestramiento canino",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2397",
    "label": "competir en agility",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2398",
    "label": "competir en equitación",
    "category": "mascotas",
    "gear": []
  },
  {
    "id": "hob_2399",
    "label": "competir en voluntariado animal",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2400",
    "label": "competir en voluntariado social",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2401",
    "label": "competir en lengua de signos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2402",
    "label": "competir en idiomas",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2403",
    "label": "competir en latín",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2404",
    "label": "competir en esperanto",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2405",
    "label": "competir en ajedrez por correspondencia",
    "category": "ocio",
    "gear": [
      "ajedrez",
      "tablero de ajedrez"
    ]
  },
  {
    "id": "hob_2406",
    "label": "competir en go",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2407",
    "label": "competir en shogi",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2408",
    "label": "competir en bridge",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2409",
    "label": "competir en mahjong",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2410",
    "label": "competir en sudokus",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2411",
    "label": "competir en crucigramas",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2412",
    "label": "competir en escape rooms caseros",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2413",
    "label": "competir en robótica",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2414",
    "label": "competir en arduino",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2415",
    "label": "competir en impresión 3D",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2416",
    "label": "competir en reparar electrónicos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2417",
    "label": "competir en linux",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2418",
    "label": "competir en ciberseguridad ética amateur",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2419",
    "label": "competir en mapas OSM",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2420",
    "label": "competir en hammocking",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2421",
    "label": "competir en sauna",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2422",
    "label": "competir en baños fríos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2423",
    "label": "competir en respiración",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2424",
    "label": "competir en astrología cultural",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2425",
    "label": "competir en tarot artístico",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2426",
    "label": "competir en perfumería artesanal",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2427",
    "label": "competir en jabones",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2428",
    "label": "competir en velas",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2429",
    "label": "competir en incienso",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2430",
    "label": "competir en tes de hierbas",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2431",
    "label": "competir en foraging urbano",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2432",
    "label": "competir en urban sketching",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2433",
    "label": "competir en zines",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2434",
    "label": "competir en fanzines",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2435",
    "label": "competir en serigrafía",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2436",
    "label": "competir en linograbado",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2437",
    "label": "competir en tipografía",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2438",
    "label": "competir en diseño de interiores",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2439",
    "label": "competir en feng shui amateur",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2440",
    "label": "competir en organización del hogar",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2441",
    "label": "competir en zero waste",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2442",
    "label": "competir en costura de arreglos",
    "category": "arte",
    "gear": []
  },
  {
    "id": "hob_2443",
    "label": "competir en upcycling",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2444",
    "label": "competir en reparar bicis",
    "category": "deporte",
    "gear": [
      "bicicleta"
    ]
  },
  {
    "id": "hob_2445",
    "label": "competir en mecánica básica",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2446",
    "label": "competir en carpintería",
    "category": "ocio",
    "gear": [
      "material de pintura"
    ]
  },
  {
    "id": "hob_2447",
    "label": "competir en torno de madera",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2448",
    "label": "competir en pirografía",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2449",
    "label": "competir en vidrio fundido",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2450",
    "label": "competir en mosaicos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2451",
    "label": "competir en graffiti legal",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2452",
    "label": "competir en parkour ligero",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2453",
    "label": "competir en danza contemporánea",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2454",
    "label": "competir en salsa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2455",
    "label": "competir en bachata",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2456",
    "label": "competir en tango",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2457",
    "label": "competir en swing",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2458",
    "label": "competir en k-pop dance",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2459",
    "label": "competir en ballet amateur",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2460",
    "label": "competir en capoeira",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2461",
    "label": "diseñar ajedrez",
    "category": "ocio",
    "gear": [
      "ajedrez",
      "tablero de ajedrez"
    ]
  },
  {
    "id": "hob_2462",
    "label": "diseñar guitarra acústica",
    "category": "musica",
    "gear": [
      "guitarra"
    ]
  },
  {
    "id": "hob_2463",
    "label": "diseñar guitarra eléctrica",
    "category": "musica",
    "gear": [
      "guitarra"
    ]
  },
  {
    "id": "hob_2464",
    "label": "diseñar ukelele",
    "category": "musica",
    "gear": []
  },
  {
    "id": "hob_2465",
    "label": "diseñar piano",
    "category": "musica",
    "gear": []
  },
  {
    "id": "hob_2466",
    "label": "diseñar batería",
    "category": "musica",
    "gear": []
  },
  {
    "id": "hob_2467",
    "label": "diseñar violín",
    "category": "musica",
    "gear": []
  },
  {
    "id": "hob_2468",
    "label": "diseñar flauta",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2469",
    "label": "diseñar armónica",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2470",
    "label": "diseñar canto",
    "category": "musica",
    "gear": []
  },
  {
    "id": "hob_2471",
    "label": "diseñar dibujo a lápiz",
    "category": "arte",
    "gear": [
      "pintura",
      "material de pintura"
    ]
  },
  {
    "id": "hob_2472",
    "label": "diseñar acuarela",
    "category": "ocio",
    "gear": [
      "pintura",
      "material de pintura"
    ]
  },
  {
    "id": "hob_2473",
    "label": "diseñar óleo",
    "category": "arte",
    "gear": [
      "pintura",
      "material de pintura"
    ]
  },
  {
    "id": "hob_2474",
    "label": "diseñar acrílico",
    "category": "ocio",
    "gear": [
      "pintura"
    ]
  },
  {
    "id": "hob_2475",
    "label": "diseñar cómic",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2476",
    "label": "diseñar caligrafía",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2477",
    "label": "diseñar lettering",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2478",
    "label": "diseñar origami",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2479",
    "label": "diseñar cerámica",
    "category": "arte",
    "gear": []
  },
  {
    "id": "hob_2480",
    "label": "diseñar costura",
    "category": "arte",
    "gear": []
  },
  {
    "id": "hob_2481",
    "label": "diseñar punto de cruz",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2482",
    "label": "diseñar ganchillo",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2483",
    "label": "diseñar punto de media",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2484",
    "label": "diseñar bordado",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2485",
    "label": "diseñar macramé",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2486",
    "label": "diseñar cuero",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2487",
    "label": "diseñar joyería",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2488",
    "label": "diseñar modelismo",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2489",
    "label": "diseñar maquetas",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2490",
    "label": "diseñar puzles",
    "category": "ocio",
    "gear": [
      "puzles"
    ]
  },
  {
    "id": "hob_2491",
    "label": "diseñar puzzles 3D",
    "category": "ocio",
    "gear": [
      "puzles"
    ]
  },
  {
    "id": "hob_2492",
    "label": "diseñar legos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2493",
    "label": "diseñar drones",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2494",
    "label": "diseñar astronomía",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2495",
    "label": "diseñar birdwatching",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2496",
    "label": "diseñar setas",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2497",
    "label": "diseñar plantas de interior",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2498",
    "label": "diseñar huerto urbano",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2499",
    "label": "diseñar bonsái",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2500",
    "label": "diseñar compostaje",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2501",
    "label": "diseñar cocina vegana",
    "category": "gastronomia",
    "gear": [
      "cocina"
    ]
  },
  {
    "id": "hob_2502",
    "label": "diseñar repostería",
    "category": "ocio",
    "gear": [
      "cocina"
    ]
  },
  {
    "id": "hob_2503",
    "label": "diseñar panadería",
    "category": "gastronomia",
    "gear": [
      "cocina"
    ]
  },
  {
    "id": "hob_2504",
    "label": "diseñar cafés de especialidad",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2505",
    "label": "diseñar cata de tés",
    "category": "gastronomia",
    "gear": []
  },
  {
    "id": "hob_2506",
    "label": "diseñar cata de vinos",
    "category": "gastronomia",
    "gear": []
  },
  {
    "id": "hob_2507",
    "label": "diseñar cerveza artesanal",
    "category": "gastronomia",
    "gear": []
  },
  {
    "id": "hob_2508",
    "label": "diseñar cócteles",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2509",
    "label": "diseñar cocina fermentada",
    "category": "gastronomia",
    "gear": [
      "cocina"
    ]
  },
  {
    "id": "hob_2510",
    "label": "diseñar running",
    "category": "deporte",
    "gear": [
      "running",
      "zapatillas de correr"
    ]
  },
  {
    "id": "hob_2511",
    "label": "diseñar trail",
    "category": "ocio",
    "gear": [
      "running",
      "zapatillas de correr"
    ]
  },
  {
    "id": "hob_2512",
    "label": "diseñar ciclismo de carretera",
    "category": "ocio",
    "gear": [
      "bicicleta"
    ]
  },
  {
    "id": "hob_2513",
    "label": "diseñar mtb",
    "category": "ocio",
    "gear": [
      "bicicleta"
    ]
  },
  {
    "id": "hob_2514",
    "label": "diseñar bici urbana",
    "category": "deporte",
    "gear": [
      "bicicleta"
    ]
  },
  {
    "id": "hob_2515",
    "label": "diseñar patinaje",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2516",
    "label": "diseñar skate",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2517",
    "label": "diseñar surf",
    "category": "deporte",
    "gear": []
  },
  {
    "id": "hob_2518",
    "label": "diseñar bodyboard",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2519",
    "label": "diseñar paddle surf",
    "category": "deporte",
    "gear": [
      "kayak"
    ]
  },
  {
    "id": "hob_2520",
    "label": "diseñar kayak",
    "category": "ocio",
    "gear": [
      "kayak"
    ]
  },
  {
    "id": "hob_2521",
    "label": "diseñar remo",
    "category": "ocio",
    "gear": [
      "kayak"
    ]
  },
  {
    "id": "hob_2522",
    "label": "diseñar natación",
    "category": "deporte",
    "gear": []
  },
  {
    "id": "hob_2523",
    "label": "diseñar buceo",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2524",
    "label": "diseñar escalada indoor",
    "category": "deporte",
    "gear": []
  },
  {
    "id": "hob_2525",
    "label": "diseñar boulder",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2526",
    "label": "diseñar senderismo",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2527",
    "label": "diseñar trekking",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2528",
    "label": "diseñar acampada",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2529",
    "label": "diseñar orientación",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2530",
    "label": "diseñar geocaching",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2531",
    "label": "diseñar yoga",
    "category": "deporte",
    "gear": []
  },
  {
    "id": "hob_2532",
    "label": "diseñar pilates",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2533",
    "label": "diseñar meditación",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2534",
    "label": "diseñar tai chi",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2535",
    "label": "diseñar calistenia",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2536",
    "label": "diseñar crossfit",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2537",
    "label": "diseñar boxeo",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2538",
    "label": "diseñar artes marciales",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2539",
    "label": "diseñar esgrima",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2540",
    "label": "diseñar tiro con arco",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2541",
    "label": "diseñar tenis",
    "category": "deporte",
    "gear": []
  },
  {
    "id": "hob_2542",
    "label": "diseñar pádel",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2543",
    "label": "diseñar bádminton",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2544",
    "label": "diseñar ping-pong",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2545",
    "label": "diseñar fútbol",
    "category": "deporte",
    "gear": []
  },
  {
    "id": "hob_2546",
    "label": "diseñar baloncesto",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2547",
    "label": "diseñar voleibol",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2548",
    "label": "diseñar ultimate",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2549",
    "label": "diseñar disfraces",
    "category": "ocio",
    "gear": [
      "disfraz"
    ]
  },
  {
    "id": "hob_2550",
    "label": "diseñar cosplay",
    "category": "ocio",
    "gear": [
      "disfraz"
    ]
  },
  {
    "id": "hob_2551",
    "label": "diseñar teatro amateur",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2552",
    "label": "diseñar improvisación teatral",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2553",
    "label": "diseñar stand up",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2554",
    "label": "diseñar magia",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2555",
    "label": "diseñar malabares",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2556",
    "label": "diseñar cuerda floja",
    "category": "ocio",
    "gear": [
      "cuerda floja",
      "cuerda / slackline"
    ]
  },
  {
    "id": "hob_2557",
    "label": "diseñar slackline",
    "category": "ocio",
    "gear": [
      "cuerda floja",
      "cuerda / slackline"
    ]
  },
  {
    "id": "hob_2558",
    "label": "diseñar cometas",
    "category": "ocio",
    "gear": [
      "cometa"
    ]
  },
  {
    "id": "hob_2559",
    "label": "diseñar aeromodelismo",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2560",
    "label": "diseñar trenes miniatura",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2561",
    "label": "diseñar videojuegos indie",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2562",
    "label": "diseñar videojuegos competitivos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2563",
    "label": "diseñar juegos de mesa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2564",
    "label": "diseñar rol de mesa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2565",
    "label": "diseñar wargames",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2566",
    "label": "diseñar cartas coleccionables",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2567",
    "label": "diseñar lectura de novela",
    "category": "ocio",
    "gear": [
      "libros"
    ]
  },
  {
    "id": "hob_2568",
    "label": "diseñar poesía",
    "category": "ocio",
    "gear": [
      "libros"
    ]
  },
  {
    "id": "hob_2569",
    "label": "diseñar ensayo",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2570",
    "label": "diseñar escritura creativa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2571",
    "label": "diseñar journaling",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2572",
    "label": "diseñar podcasting",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2573",
    "label": "diseñar radio amateur",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2574",
    "label": "diseñar edición de vídeo",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2575",
    "label": "diseñar stop motion",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2576",
    "label": "diseñar fotografía analógica",
    "category": "arte",
    "gear": [
      "cámara"
    ]
  },
  {
    "id": "hob_2577",
    "label": "diseñar revelado",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2578",
    "label": "diseñar street photography",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2579",
    "label": "diseñar arquitectura urbana",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2580",
    "label": "diseñar visitar museos",
    "category": "cultura",
    "gear": []
  },
  {
    "id": "hob_2581",
    "label": "diseñar visitar monumentos",
    "category": "cultura",
    "gear": []
  },
  {
    "id": "hob_2582",
    "label": "diseñar ver pueblitos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2583",
    "label": "diseñar ver ciudad",
    "category": "cultura",
    "gear": []
  },
  {
    "id": "hob_2584",
    "label": "diseñar viajes en tren",
    "category": "cultura",
    "gear": []
  },
  {
    "id": "hob_2585",
    "label": "diseñar viajes en furgoneta",
    "category": "cultura",
    "gear": []
  },
  {
    "id": "hob_2586",
    "label": "diseñar turismo industrial",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2587",
    "label": "diseñar ruinas",
    "category": "cultura",
    "gear": []
  },
  {
    "id": "hob_2588",
    "label": "diseñar cementerios históricos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2589",
    "label": "diseñar mercados",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2590",
    "label": "diseñar librerías de viejo",
    "category": "ocio",
    "gear": [
      "libros"
    ]
  },
  {
    "id": "hob_2591",
    "label": "diseñar vinilos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2592",
    "label": "diseñar casetes",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2593",
    "label": "diseñar sellos",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2594",
    "label": "diseñar monedas",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2595",
    "label": "diseñar minerales",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2596",
    "label": "diseñar fósiles",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2597",
    "label": "diseñar insectos (entomología amateur)",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2598",
    "label": "diseñar acuariofilia",
    "category": "mascotas",
    "gear": []
  },
  {
    "id": "hob_2599",
    "label": "diseñar cuidado de gatos",
    "category": "mascotas",
    "gear": []
  },
  {
    "id": "hob_2600",
    "label": "diseñar cuidado de perros",
    "category": "mascotas",
    "gear": []
  },
  {
    "id": "hob_2601",
    "label": "ajedrez en casa",
    "category": "ocio",
    "gear": [
      "ajedrez",
      "tablero de ajedrez"
    ]
  },
  {
    "id": "hob_2602",
    "label": "guitarra acústica en casa",
    "category": "musica",
    "gear": [
      "guitarra"
    ]
  },
  {
    "id": "hob_2603",
    "label": "guitarra eléctrica en casa",
    "category": "musica",
    "gear": [
      "guitarra"
    ]
  },
  {
    "id": "hob_2604",
    "label": "ukelele en casa",
    "category": "musica",
    "gear": []
  },
  {
    "id": "hob_2605",
    "label": "piano en casa",
    "category": "musica",
    "gear": []
  },
  {
    "id": "hob_2606",
    "label": "batería en casa",
    "category": "musica",
    "gear": []
  },
  {
    "id": "hob_2607",
    "label": "violín en casa",
    "category": "musica",
    "gear": []
  },
  {
    "id": "hob_2608",
    "label": "flauta en casa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2609",
    "label": "armónica en casa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2610",
    "label": "canto en casa",
    "category": "musica",
    "gear": []
  },
  {
    "id": "hob_2611",
    "label": "dibujo a lápiz en casa",
    "category": "arte",
    "gear": [
      "pintura",
      "material de pintura"
    ]
  },
  {
    "id": "hob_2612",
    "label": "acuarela en casa",
    "category": "ocio",
    "gear": [
      "pintura",
      "material de pintura"
    ]
  },
  {
    "id": "hob_2613",
    "label": "óleo en casa",
    "category": "arte",
    "gear": [
      "pintura",
      "material de pintura"
    ]
  },
  {
    "id": "hob_2614",
    "label": "acrílico en casa",
    "category": "ocio",
    "gear": [
      "pintura"
    ]
  },
  {
    "id": "hob_2615",
    "label": "cómic en casa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2616",
    "label": "caligrafía en casa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2617",
    "label": "lettering en casa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2618",
    "label": "origami en casa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2619",
    "label": "cerámica en casa",
    "category": "arte",
    "gear": []
  },
  {
    "id": "hob_2620",
    "label": "costura en casa",
    "category": "arte",
    "gear": []
  },
  {
    "id": "hob_2621",
    "label": "punto de cruz en casa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2622",
    "label": "ganchillo en casa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2623",
    "label": "punto de media en casa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2624",
    "label": "bordado en casa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2625",
    "label": "macramé en casa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2626",
    "label": "cuero en casa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2627",
    "label": "joyería en casa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2628",
    "label": "modelismo en casa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2629",
    "label": "maquetas en casa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2630",
    "label": "puzles en casa",
    "category": "ocio",
    "gear": [
      "puzles"
    ]
  },
  {
    "id": "hob_2631",
    "label": "puzzles 3D en casa",
    "category": "ocio",
    "gear": [
      "puzles"
    ]
  },
  {
    "id": "hob_2632",
    "label": "legos en casa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2633",
    "label": "drones en casa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2634",
    "label": "astronomía en casa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2635",
    "label": "birdwatching en casa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2636",
    "label": "setas en casa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2637",
    "label": "plantas de interior en casa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2638",
    "label": "huerto urbano en casa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2639",
    "label": "bonsái en casa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2640",
    "label": "compostaje en casa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2641",
    "label": "cocina vegana en casa",
    "category": "gastronomia",
    "gear": [
      "cocina"
    ]
  },
  {
    "id": "hob_2642",
    "label": "repostería en casa",
    "category": "ocio",
    "gear": [
      "cocina"
    ]
  },
  {
    "id": "hob_2643",
    "label": "panadería en casa",
    "category": "gastronomia",
    "gear": [
      "cocina"
    ]
  },
  {
    "id": "hob_2644",
    "label": "cafés de especialidad en casa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2645",
    "label": "cata de tés en casa",
    "category": "gastronomia",
    "gear": []
  },
  {
    "id": "hob_2646",
    "label": "cata de vinos en casa",
    "category": "gastronomia",
    "gear": []
  },
  {
    "id": "hob_2647",
    "label": "cerveza artesanal en casa",
    "category": "gastronomia",
    "gear": []
  },
  {
    "id": "hob_2648",
    "label": "cócteles en casa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2649",
    "label": "cocina fermentada en casa",
    "category": "gastronomia",
    "gear": [
      "cocina"
    ]
  },
  {
    "id": "hob_2650",
    "label": "running en casa",
    "category": "deporte",
    "gear": [
      "running",
      "zapatillas de correr"
    ]
  },
  {
    "id": "hob_2651",
    "label": "trail en casa",
    "category": "ocio",
    "gear": [
      "running",
      "zapatillas de correr"
    ]
  },
  {
    "id": "hob_2652",
    "label": "ciclismo de carretera en casa",
    "category": "ocio",
    "gear": [
      "bicicleta"
    ]
  },
  {
    "id": "hob_2653",
    "label": "mtb en casa",
    "category": "ocio",
    "gear": [
      "bicicleta"
    ]
  },
  {
    "id": "hob_2654",
    "label": "bici urbana en casa",
    "category": "deporte",
    "gear": [
      "bicicleta"
    ]
  },
  {
    "id": "hob_2655",
    "label": "patinaje en casa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2656",
    "label": "skate en casa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2657",
    "label": "surf en casa",
    "category": "deporte",
    "gear": []
  },
  {
    "id": "hob_2658",
    "label": "bodyboard en casa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2659",
    "label": "paddle surf en casa",
    "category": "deporte",
    "gear": [
      "kayak"
    ]
  },
  {
    "id": "hob_2660",
    "label": "kayak en casa",
    "category": "ocio",
    "gear": [
      "kayak"
    ]
  },
  {
    "id": "hob_2661",
    "label": "remo en casa",
    "category": "ocio",
    "gear": [
      "kayak"
    ]
  },
  {
    "id": "hob_2662",
    "label": "natación en casa",
    "category": "deporte",
    "gear": []
  },
  {
    "id": "hob_2663",
    "label": "buceo en casa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2664",
    "label": "escalada indoor en casa",
    "category": "deporte",
    "gear": []
  },
  {
    "id": "hob_2665",
    "label": "boulder en casa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2666",
    "label": "senderismo en casa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2667",
    "label": "trekking en casa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2668",
    "label": "acampada en casa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2669",
    "label": "orientación en casa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2670",
    "label": "geocaching en casa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2671",
    "label": "yoga en casa",
    "category": "deporte",
    "gear": []
  },
  {
    "id": "hob_2672",
    "label": "pilates en casa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2673",
    "label": "meditación en casa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2674",
    "label": "tai chi en casa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2675",
    "label": "calistenia en casa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2676",
    "label": "crossfit en casa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2677",
    "label": "boxeo en casa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2678",
    "label": "artes marciales en casa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2679",
    "label": "esgrima en casa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2680",
    "label": "tiro con arco en casa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2681",
    "label": "ajedrez en el parque",
    "category": "ocio",
    "gear": [
      "ajedrez",
      "tablero de ajedrez"
    ]
  },
  {
    "id": "hob_2682",
    "label": "guitarra acústica en el parque",
    "category": "musica",
    "gear": [
      "guitarra"
    ]
  },
  {
    "id": "hob_2683",
    "label": "guitarra eléctrica en el parque",
    "category": "musica",
    "gear": [
      "guitarra"
    ]
  },
  {
    "id": "hob_2684",
    "label": "ukelele en el parque",
    "category": "musica",
    "gear": []
  },
  {
    "id": "hob_2685",
    "label": "piano en el parque",
    "category": "musica",
    "gear": []
  },
  {
    "id": "hob_2686",
    "label": "batería en el parque",
    "category": "musica",
    "gear": []
  },
  {
    "id": "hob_2687",
    "label": "violín en el parque",
    "category": "musica",
    "gear": []
  },
  {
    "id": "hob_2688",
    "label": "flauta en el parque",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2689",
    "label": "armónica en el parque",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2690",
    "label": "canto en el parque",
    "category": "musica",
    "gear": []
  },
  {
    "id": "hob_2691",
    "label": "dibujo a lápiz en el parque",
    "category": "arte",
    "gear": [
      "pintura",
      "material de pintura"
    ]
  },
  {
    "id": "hob_2692",
    "label": "acuarela en el parque",
    "category": "ocio",
    "gear": [
      "pintura",
      "material de pintura"
    ]
  },
  {
    "id": "hob_2693",
    "label": "óleo en el parque",
    "category": "arte",
    "gear": [
      "pintura",
      "material de pintura"
    ]
  },
  {
    "id": "hob_2694",
    "label": "acrílico en el parque",
    "category": "ocio",
    "gear": [
      "pintura"
    ]
  },
  {
    "id": "hob_2695",
    "label": "cómic en el parque",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2696",
    "label": "caligrafía en el parque",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2697",
    "label": "lettering en el parque",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2698",
    "label": "origami en el parque",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2699",
    "label": "cerámica en el parque",
    "category": "arte",
    "gear": []
  },
  {
    "id": "hob_2700",
    "label": "costura en el parque",
    "category": "arte",
    "gear": []
  },
  {
    "id": "hob_2701",
    "label": "punto de cruz en el parque",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2702",
    "label": "ganchillo en el parque",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2703",
    "label": "punto de media en el parque",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2704",
    "label": "bordado en el parque",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2705",
    "label": "macramé en el parque",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2706",
    "label": "cuero en el parque",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2707",
    "label": "joyería en el parque",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2708",
    "label": "modelismo en el parque",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2709",
    "label": "maquetas en el parque",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2710",
    "label": "puzles en el parque",
    "category": "ocio",
    "gear": [
      "puzles"
    ]
  },
  {
    "id": "hob_2711",
    "label": "puzzles 3D en el parque",
    "category": "ocio",
    "gear": [
      "puzles"
    ]
  },
  {
    "id": "hob_2712",
    "label": "legos en el parque",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2713",
    "label": "drones en el parque",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2714",
    "label": "astronomía en el parque",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2715",
    "label": "birdwatching en el parque",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2716",
    "label": "setas en el parque",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2717",
    "label": "plantas de interior en el parque",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2718",
    "label": "huerto urbano en el parque",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2719",
    "label": "bonsái en el parque",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2720",
    "label": "compostaje en el parque",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2721",
    "label": "cocina vegana en el parque",
    "category": "gastronomia",
    "gear": [
      "cocina"
    ]
  },
  {
    "id": "hob_2722",
    "label": "repostería en el parque",
    "category": "ocio",
    "gear": [
      "cocina"
    ]
  },
  {
    "id": "hob_2723",
    "label": "panadería en el parque",
    "category": "gastronomia",
    "gear": [
      "cocina"
    ]
  },
  {
    "id": "hob_2724",
    "label": "cafés de especialidad en el parque",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2725",
    "label": "cata de tés en el parque",
    "category": "gastronomia",
    "gear": []
  },
  {
    "id": "hob_2726",
    "label": "cata de vinos en el parque",
    "category": "gastronomia",
    "gear": []
  },
  {
    "id": "hob_2727",
    "label": "cerveza artesanal en el parque",
    "category": "gastronomia",
    "gear": []
  },
  {
    "id": "hob_2728",
    "label": "cócteles en el parque",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2729",
    "label": "cocina fermentada en el parque",
    "category": "gastronomia",
    "gear": [
      "cocina"
    ]
  },
  {
    "id": "hob_2730",
    "label": "running en el parque",
    "category": "deporte",
    "gear": [
      "running",
      "zapatillas de correr"
    ]
  },
  {
    "id": "hob_2731",
    "label": "trail en el parque",
    "category": "ocio",
    "gear": [
      "running",
      "zapatillas de correr"
    ]
  },
  {
    "id": "hob_2732",
    "label": "ciclismo de carretera en el parque",
    "category": "ocio",
    "gear": [
      "bicicleta"
    ]
  },
  {
    "id": "hob_2733",
    "label": "mtb en el parque",
    "category": "ocio",
    "gear": [
      "bicicleta"
    ]
  },
  {
    "id": "hob_2734",
    "label": "bici urbana en el parque",
    "category": "deporte",
    "gear": [
      "bicicleta"
    ]
  },
  {
    "id": "hob_2735",
    "label": "patinaje en el parque",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2736",
    "label": "skate en el parque",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2737",
    "label": "surf en el parque",
    "category": "deporte",
    "gear": []
  },
  {
    "id": "hob_2738",
    "label": "bodyboard en el parque",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2739",
    "label": "paddle surf en el parque",
    "category": "deporte",
    "gear": [
      "kayak"
    ]
  },
  {
    "id": "hob_2740",
    "label": "kayak en el parque",
    "category": "ocio",
    "gear": [
      "kayak"
    ]
  },
  {
    "id": "hob_2741",
    "label": "remo en el parque",
    "category": "ocio",
    "gear": [
      "kayak"
    ]
  },
  {
    "id": "hob_2742",
    "label": "natación en el parque",
    "category": "deporte",
    "gear": []
  },
  {
    "id": "hob_2743",
    "label": "buceo en el parque",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2744",
    "label": "escalada indoor en el parque",
    "category": "deporte",
    "gear": []
  },
  {
    "id": "hob_2745",
    "label": "boulder en el parque",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2746",
    "label": "senderismo en el parque",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2747",
    "label": "trekking en el parque",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2748",
    "label": "acampada en el parque",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2749",
    "label": "orientación en el parque",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2750",
    "label": "geocaching en el parque",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2751",
    "label": "yoga en el parque",
    "category": "deporte",
    "gear": []
  },
  {
    "id": "hob_2752",
    "label": "pilates en el parque",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2753",
    "label": "meditación en el parque",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2754",
    "label": "tai chi en el parque",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2755",
    "label": "calistenia en el parque",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2756",
    "label": "crossfit en el parque",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2757",
    "label": "boxeo en el parque",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2758",
    "label": "artes marciales en el parque",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2759",
    "label": "esgrima en el parque",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2760",
    "label": "tiro con arco en el parque",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2761",
    "label": "ajedrez en la playa",
    "category": "ocio",
    "gear": [
      "ajedrez",
      "tablero de ajedrez"
    ]
  },
  {
    "id": "hob_2762",
    "label": "guitarra acústica en la playa",
    "category": "musica",
    "gear": [
      "guitarra"
    ]
  },
  {
    "id": "hob_2763",
    "label": "guitarra eléctrica en la playa",
    "category": "musica",
    "gear": [
      "guitarra"
    ]
  },
  {
    "id": "hob_2764",
    "label": "ukelele en la playa",
    "category": "musica",
    "gear": []
  },
  {
    "id": "hob_2765",
    "label": "piano en la playa",
    "category": "musica",
    "gear": []
  },
  {
    "id": "hob_2766",
    "label": "batería en la playa",
    "category": "musica",
    "gear": []
  },
  {
    "id": "hob_2767",
    "label": "violín en la playa",
    "category": "musica",
    "gear": []
  },
  {
    "id": "hob_2768",
    "label": "flauta en la playa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2769",
    "label": "armónica en la playa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2770",
    "label": "canto en la playa",
    "category": "musica",
    "gear": []
  },
  {
    "id": "hob_2771",
    "label": "dibujo a lápiz en la playa",
    "category": "arte",
    "gear": [
      "pintura",
      "material de pintura"
    ]
  },
  {
    "id": "hob_2772",
    "label": "acuarela en la playa",
    "category": "ocio",
    "gear": [
      "pintura",
      "material de pintura"
    ]
  },
  {
    "id": "hob_2773",
    "label": "óleo en la playa",
    "category": "arte",
    "gear": [
      "pintura",
      "material de pintura"
    ]
  },
  {
    "id": "hob_2774",
    "label": "acrílico en la playa",
    "category": "ocio",
    "gear": [
      "pintura"
    ]
  },
  {
    "id": "hob_2775",
    "label": "cómic en la playa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2776",
    "label": "caligrafía en la playa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2777",
    "label": "lettering en la playa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2778",
    "label": "origami en la playa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2779",
    "label": "cerámica en la playa",
    "category": "arte",
    "gear": []
  },
  {
    "id": "hob_2780",
    "label": "costura en la playa",
    "category": "arte",
    "gear": []
  },
  {
    "id": "hob_2781",
    "label": "punto de cruz en la playa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2782",
    "label": "ganchillo en la playa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2783",
    "label": "punto de media en la playa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2784",
    "label": "bordado en la playa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2785",
    "label": "macramé en la playa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2786",
    "label": "cuero en la playa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2787",
    "label": "joyería en la playa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2788",
    "label": "modelismo en la playa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2789",
    "label": "maquetas en la playa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2790",
    "label": "puzles en la playa",
    "category": "ocio",
    "gear": [
      "puzles"
    ]
  },
  {
    "id": "hob_2791",
    "label": "puzzles 3D en la playa",
    "category": "ocio",
    "gear": [
      "puzles"
    ]
  },
  {
    "id": "hob_2792",
    "label": "legos en la playa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2793",
    "label": "drones en la playa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2794",
    "label": "astronomía en la playa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2795",
    "label": "birdwatching en la playa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2796",
    "label": "setas en la playa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2797",
    "label": "plantas de interior en la playa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2798",
    "label": "huerto urbano en la playa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2799",
    "label": "bonsái en la playa",
    "category": "ocio",
    "gear": []
  },
  {
    "id": "hob_2800",
    "label": "compostaje en la playa",
    "category": "ocio",
    "gear": []
  }
];
